import Vue from 'vue';
import { MLCreate, MLInstaller, MLanguage } from 'vue-multilanguage';

Vue.use(MLInstaller);

// Atenção - utilizar craze (`) para delimitar as strings e sempre colocar uma virgula no final da linha!
//         - não utilizar variáveis em multiplas linhas!

export default new MLCreate({
  initial: 'portuguese',
  save: true,
  languages: [
    new MLanguage('portuguese').create({
      ln: 'br',
      //translation_script_start_pt
      agreementText: `Você concorda com os termos do contrato de confidencialidade?`,
      agree: `Concordo`,
      doNotAgree: `Não Concordo`,
      programWithNda: `Este programa possui um NDA vinculado!`,
      ndaAccepted: `NDA aceito!`,
      programWithoutNda: `Este programa ainda não possui um NDA vinculado!`,
      menuProgram: `Programas`,
      menuReport: `Relatórios`,
      menuAccount: `Minha conta`,
      navInvitations: `Convites`,
      navPayments: `Pagamentos`,
      navCreateNda: `Criar um Modelo NDA`,
      navEditNda: `Editar NDA`,
      navPrograms: `Programas`,
      navPublished: `Publicados`,
      navClosed: `Inativos`,
      navNda: `NDAs`,
      navAll: `Todos`,
      navPending: `Pendente`,
      navRetest: `Reteste`,
      dashTitle: `Bem vindo {0}!`,
      dashSubTitle: `Uma visão geral e acesso rápido da sua conta só para você`,
      dashReportResolv: `Relatórios aprovados`,
      navAverage: `Média de Recompensas`,
      dashMsgYouHave: `Você possui`,
      dashMsgYouDHave: `Você não possui`,
      msgProgramPu: `programas publicos!`,
      msgProgramPr: `programas privados!`,
      dashMsgGP: `Gerenciar seus programas.`,
      dashMsgCP: `Cadastrar um programa agora?`,
      dashInvTitle: `Convide Especialistas!`,
      dashInvSubTitle: `Faça o convite à especialistas para participar dos seus programas.`,
      dashPayTitle: `Pagamentos!`,
      dashPaySubTitle: `Resumo financeiro e solicitações de pagamentos.`,
      dashNdaTitle: `Contratos de Confidencialidade!`,
      dashNdaSubTitle: `Gerencie os contratos de confidencialidade dos seus programas.`,
      dashCreatNdaTitle: `Modelo Padrão de NDA!`,
      dashCreatNdaSubTitle: `Crie um modelo padrão para gerenciar os contratos de confidencialidade dos seus programas.`,
      dashCreatNdaAbriefsummary: `Um breve sumário pra o especialista entender do que se trata ...`,
      dashCreatNdaDesc: `NDA é uma sigla em inglês para Non-Disclosure-Agreements, ou simplesmente acordo de sigilo de informações. Ele tem a intenção de proteger segredos industriais, comerciais, ou ainda qualquer informação que não pode ser divulgada e deve manter-se em sigilo entre aqueles que têm acesso a ela.`,
      dashCreatNdaWriteTerms: `Redija os termos do seu contrato de confidencialidade e suas peculiaridades.`,
      dashCreatNdawritePaste: `Vamos começar, redija ou cole os seus termos!`,
      dashCreatNdaWantAttach: `Quer anexar um documento à ser assinado?`,
      progTitle: `Visão Geral!`,
      progSubTitle: `Acompanhe e gerencie seus programas na BugHunt.`,
      progPubTitle: `Programas Publicados!`,
      progPubSubTitle: `Gerencie seus programas publicados! Acompanhe todos os detalhes.`,
      progCampTitle: `Campanhas`,
      progClosTitle: `Programas Inativos!`,
      progClosSubTitle: `Bateu saudade? Veja os dados dos programas inativos.`,
      progCreateTitle: `Criar um Programa`,
      progCreateSubTitle: `Momento emocionante, hora de começar a criar o seu programa!`,
      progRankTitle: `Ranking de Contribuições!`,
      progRankSubTitle: `Veja quem mais contribui com seus programas.`,
      progRankSendThank: `Envie um Agradecimento!`,
      progRankBtnSendThank: `Enviar Agradecimento`,
      progTimelineTitle: `Programas Timeline!`,
      progTimelineSubTitle: `Acompanhe a timeline dos seus programas`,
      repTitle: `Relatórios!`,
      repSubTitle: `Gerencie os relatórios enviados por especialistas aos seus programas.`,
      repSubTitleHacker: `Gerencie os relatórios enviados aos programas.`,
      repDetMsgAlter: `Alterações feitas no relatório não podem ser desfeitas!`,
      ccpTitle: `Vamos criar um programa ?`,
      ccpProgPubli: `Programa Público`,
      ccpProgPubliDesc: `Criar um programa onde todos os especialistas cadastrados podem ver e enviar relatórios!`,
      ccpProgVDPDesc: `Criar um programa onde todos os especialistas podem ver e enviar relatórios!`,
      ccpProgPriv: `Programa Privado`,
      ccpProgPrivDesc: `Criar um programa onde somente os especialistas selecionados podem ver e enviar relatórios!`,
      managedProgram: `Programa Gerenciado`,
      protectedByNDA: `Protegido por um NDA`,
      helpTitle: `Precisando de ajuda ?`,
      helpProgram: `Como funciona um programa ?`,
      helpDifference: `Qual a diferença entre privado e público ?`,
      helpaverage: `Qual a média aplicada em um bounty ?`,
      rankTitle: `Ranking de Contribuições`,
      retest_confirmed: `Corrigido`,
      retest_denied: `Falha persiste`,
      accountSubTitle: `Uma visão geral e acesso rápido da sua conta só para você.`,
      accountAcSubTitle: `Quem, quando e como acessaram sua conta`,
      accountTerSubTitle: `Acesse nossos termos e política de privacidade`,
      accountUserSubTitle: `Gerencie quem tem acesso a organização.`,
      accountSettSubTitle: `Como deseja receber seus e-mails, política de privacidade e outros.`,
      aboutUs: `Sobre nós`,
      aboutYou: `Sobre você`,
      aboutYourAccount: `Sobre sua conta`,
      aboutTheProgramPolicy: `Sobre a política do programa!`,
      add: `Adicionar`,
      addUser: `Adicionar Usuário`,
      addAcomment: `Adicione um comentário`,
      addExpertToBlacklist: `Adicionar especialista à Blacklist`,
      addTheScopesHere: `Adicione os escopos aqui!`,
      addOutOfScopesHere: `Adicione aqui as aplicações que devem ser evitadas durante os testes de segurança!`,
      addYourPayPalAccount: `Adicione sua conta do PayPal`,
      adjustedTheImpactTo: `ajustou o impacto para`,
      adjustedTheImpactFrom: `ajustou o impacto de`,
      adjustMetrics: `Ajustar Métricas`,
      allowedFiles: `Arquivos permitidos: vídeos, imagens e arquivos de texto .jpg .jpeg .png .txt .rar .zip .7z`,
      alreadyHaveAccount: `Já possui uma conta?`,
      accepted: `Aceito`,
      acceptThisInvitation: `Aceitar este Convite!`,
      access: `Acessos`,
      accessControl: `Controle de Acesso`,
      accessMyAccount: `Acessar minha conta!`,
      accessProfile: `Perfil de Acesso`,
      accessInformation: `Informações de Acesso`,
      accountCreatedSuccessfully: `Conta criada com sucesso!`,
      accountDeleted: `Conta deletada`,
      accountRecovery: `Recuperação de conta`,
      accurate: `Apurado`,
      activate: `Ativar`,
      activated: `Ativado`,
      additionalServices: `Serviços Adicionais`,
      addOtherRewardsHere: `Adicione outras recompensas aqui!`,
      addToBlacklist: `Adicionar a Blacklist`,
      agreementSpecialists: `Especialistas em acordo`,
      ago: `há {0}`,
      aGoodPolicAvoids: `Uma boa política evita problemas, caso tenha algum problema nos consulte.`,
      all: `Todos`,
      gatTagOptDescription: `Apenas relatórios quem contenham a tag GAT`,
      gatTagDescription: `Quais relatórios serão enviados para a plataforma GAT?`,
      allowMobileAccess: `Permitir acessos de celular`,
      allowedToPayReward: `Tem permissão para pagar recompensas.`,
      allThePrograms: `Todos os programas`,
      allStatus: `Todos os Status`,
      aLowercaseLetter: `uma letra minúscula`,
      anEmailContainingPasswordReset: `Um email contendo instruções para o reset de senha foi enviado.`,
      aNewValidationEmailHasBeenSenToYou: `Um novo e-mail de validação foi enviado para você, verique sua caixa postal`,
      aNewSuperStrongPassword: `Uma nova senha super forte!`,
      annotation: `Anotação`,
      aNumber: `um número`,
      anUppercaseLetter: `uma letra maiúscula`,
      thePasswordMustHave: `A senha deve ter`,
      anyQuestionsAboutIntegration: `Dúvidas sobre essa integração?`,
      application: `Aplicativo`,
      applicableReport: `Relatório aplicável`,
      approvedReports: `Relatórios aprovados`,
      approveWithoutRetest: `Você deseja mesmo encerrar o relatório como aprovado antes de solicitar um reteste?`,
      approveRetest: `Aprovar reteste`,
      approvedRetest: `aprovou o reteste`,
      areYouSureYouWantToDeleteThisUser: `Tem certeza de que deseja excluir este usuário ?`,
      as: `como`,
      aSuperStrongPasswordNow: `Uma senha super forte agora!`,
      atBugHuntYouWillFindPrograms: `Na BugHunt você vai encontrar programas para testar diferentes tipos de tecnologias, coloque em prática seus conhecimentos, testando aplicações reais de forma ética e legalizada.`,
      attention: `Atenção!`,
      atLeastCharacters: `no mínimo 6 caracteres`,
      authentication: `Autenticação`,
      averageTicket: `Ticket Médio`,
      average_time_to_bounty: `Tempo médio para pagar recompensa`,
      average_time_to_first_response: `Tempo médio para a primeira resposta`,
      average_time_to_resolution: `Tempo médio para encerramento do relatório`,
      averageTimeToBounty: `Tempo médio para pagamento`,
      avgTimeToBounty: `O tempo médio decorrido desde a primeira interação da empresa com um relatório até a solicitação de pagamento de uma recompensa.`,
      avgTimeToFirstResponse: `O tempo médio decorrido desde o envio do relatório até a primeira interação da empresa com um relatório.`,
      avgTimeToResolution: `O tempo médio decorrido desde a abertura de um relatório até o seu encerramento.`,
      awaitingAcceptance: `Aguardando aceitação`,
      awaitingPayment: `aguardando pagamento`,
      paymentReceived: `recebeu o pagamento`,
      awaitingResponse: `Aguardando Resposta`,
      award: `Premiação`,
      backupCodesLeft: `códigos de backup restantes`,
      balance: `Saldo`,
      basedLast90Day: `Baseado nos últimos 90 dias`,
      beforeActivatingTwoFactorAuthentication: `Antes de ativar o Two-factor authentication é preciso validar o seu telefone.`,
      beforeContinuingYouNeed: `Antes de continuar é preciso validar seu e-mail!`,
      billingCreditCard: `Cartão de Crédito de faturamento`,
      billingForms: `Formas de Faturamento`,
      billingInformation: `Informações de Faturamento`,
      byActivatingTheProgramSpecialistsWill: `Ao ativar o programa os especialistas poderão enviar novos relatórios!`,
      byPausingTheProgramExpertsWill: `Ao pausar o programa os especialistas não poderão mais enviar novos relatórios!`,
      bounty: `Financeira`,
      bountyAwarded: `Recompensa concedida`,
      bugBountyAndTheSecurityParadox: `Bug Bounty e o paradoxo da Segurança`,
      bugHuntIsTheFirstBrazilianBugBounty: `<b>BugHunt</b> é a primeira plataforma brasileira de Bug Bounty, e agora está em parceria com a <b>AME Digital</b> com propósito de democratizar o acesso a segurança da informação e com isso tornar a Internet um lugar mais seguro.`,
      ongoingProfileVerification: `Seu perfil está sendo verificado!`,
      cancel: `Cancelar`,
      cannotEnterEqualScopes: `Não é possível inserir escopos iguais`,
      cannotEnterSpecialCharacters: `Não é possível inserir caracteres especiais`,
      cautionNDA1: `Ao redigir o NDA da sua empresa certifique-se de que ele contemple os seguintes itens:`,
      cautionNDA2: `conter ao menos uma cláusula com a penalidade, em caso de descumprimento;`,
      cautionNDA3: `informar as partes que assumem aquele compromisso;`,
      cautionNDA4: `conter prazo de validade;`,
      cautionNDA5: `detalhar especificamente sobre o que se refere aquele NDA, pois informações genéricas e ambíguas descaracterizam o documento legal;`,
      cautionNDA6: `utilizar a tag `,
      cautionNDA7: `para se referir ao nome do especialista;`,
      cautionNDA8: `O modelo de NDA abaixo é ilustrativo. Certifique-se de informar corretamente os dados da sua empresa ao redigir o contrato de confidencialidade `,
      changeAccessPassword: `Alterar senha de acesso`,
      changePassword: `Alterar Senha`,
      changePermission: `Alterar permissão`,
      changedReportSeverity: `Severidade do relatório alterada`,
      changedReportStatus: `Situação do relatório alterada`,
      changedTheStatusFrom: `alterou a situação de {f} para {l}`,
      changedTheSituationTo: `alterou a situação para {0}`,
      changedTheTitleOf: `alterou o título do relatório de {f} para {l}`,
      changedTheTitleTo: `alterou o título do relatório para {0}`,
      changedTheVisibilityOf: `alterou a visibilidade de {f} para {l}`,
      changedTheVisibilityTo: `alterou a visibilidade para {0}`,
      checkOutAllFieldsHighlightedInRed: `Confira todos os campos destacados em vermelho!`,
      chooseANicknameYoursAlone: `Escolha um apelido para ser só seu!`,
      city: `Cidade`,
      clickHereToLearn: `Saiba mais.`,
      clearData: `Limpar dados`,
      clearlyDefine: `Defina claramente sua política do programa.`,
      close: `Encerrar`,
      closed: `Encerrado`,
      closedAgo: `Encerrado {0} dias`,
      closedIn: `Encerrado em`,
      closedReport: `Relatório fechado`,
      closedReports: `Relatórios encerrados`,
      closedTheReportAs: `fechou o relatório como`,
      reopenedTheReport: `reabriu o relatório`,
      code: `Código`,
      conclude: `Concluir`,
      connectionDenied: `Conexão negada`,
      connectionTime: `Tempo aproximado de conexão`,
      connectionRefusedUserDisabled: `Conexão recusada, usuário desativado!`,
      connectionsPerUser: `Conexões por usuário`,
      contacts: `Contatos`,
      company: `Empresa`,
      completed: `Concluídos`,
      confirm: `Confirmar!`,
      confirmAccountRemoval: `Confirmar Remoção de Conta`,
      confirmYourPassword: `Confirme sua senha!`,
      token2fa: `Informe o token da autenticação de 2 fatores`,
      confirmProgramChanges: `Descreva as alterações feitas no programa`,
      congratulationsYourUsernameIsNowVerified: `Parabéns, agora seu usuário é verificado.`,
      invalidEmail: `Email inválido, verifique e tente novamente.`,
      continueReport: `Continuar Relatório`,
      copiedId: `Id copiado`,
      copyLink: `Copiar link`,
      continue: `Continuar`,
      creatAccountInvit: `Criou a conta pelo convite`,
      createA: `Criar um`,
      created: `Criado!`,
      createMyAccount: `Criar minha conta!`,
      critical: `Crítico`,
      request_response: `Resposta`,
      request_closure: `Encerramento`,
      responseRequestReport: `solicitou uma resposta para este relatório.`,
      reportClosureRequest: `solicitou encerramento deste relatório.`,
      day: `dia`,
      days: `dias`,
      dateTime: `Data/Hora`,
      declined: `Recusado`,
      dataChanged: `Dados alterados!`,
      dataWillBeRemovedWithPhoneValidation: `Os dados do 2fa serão removidos com a validação do telefone!`,
      date: `Data`,
      declineThisInvitation: `Recusar este Convite!`,
      delimitDomains: `Delimite domínios, subdomínios, aplicativos e muito mais`,
      delimitItems: `Delimite itens`,
      deleteUser: `Excluir usuário`,
      depositedAmount: `Total de Aportes`,
      delimitationOfDomainsSubdomains: `Delimitação de domínios, subdomínios, aplicativos e outros`,
      describeALittleMoreAboutTheImpact: `Descreva um pouco mais sobre o impacto!`,
      describeChangesMadeInProgram: `Este resumo ficará disponível para todos os especialistas que participam deste programa!`,
      describeClearlyHowTheVulnerabilityWorks: `Descreva claramente como funciona a vulnerabilidade.`,
      describeInDetailTheImpactOfThisRepor: `Descreva em detalhes o impacto deste relatório.`,
      describeThePerformedTests: `Descreva os testes realizados`,
      describeTheTitleOfTheReport: `Descreva o título do relatório`,
      describeTheScope: `Qual é a url da aplicação vulnerável?`,
      description: `Descrição`,
      descriptionSubmitReport: `##### 1. Resumo \n(adicionar resumo da vulnerabilidade)\n\n##### 2. Descrição\n(adicione mais detalhes sobre esta vulnerabilidade)\n 1. [adicionar etapa]\n\n##### 3. Passos para reproduzir\n(Adicione detalhes de como podemos reproduzir o problema)\n 1. [adicionar etapa]\n 2. [adicionar etapa]\n 3. [adicionar etapa]\n\n##### 4. Material de apoio / referências\n(por exemplo, capturas de tela, registros, etc.)\n 1. Liste qualquer material adicional\n `,
      descriptionCannotContainSpecialCharacters: `A descrição não pode conter caracteres especiais`,
      descriptionMustBeFromToCharacters: `A descrição deve ter de {f} a {l} caracteres.`,
      describeEditsMade: `Descreva as edições feitas.`,
      details: `Detalhes`,
      directoryName: `Nome do Diretório`,
      disable: `Desativar`,
      domain: `Domínio`,
      done: `Pago`,
      doNotUseSpecialCharactersAndMalicious: `Não use caracteres especiais e payloads maliciosos no título, impacto e resumo, esses itens devem ser anexados como .zip, .rar ou .7z no final do relatório.`,
      doNotUseSpecialCharacters: `Não envie payloads com possíveis códigos maliciosos, esses itens devem ser anexados como .zip, .rar ou .7z!`,
      dontForgetToSaveYourChanges: `Não esqueça de salvar as alterações!`,
      downloadTheReportPDF: `Download do Relatório em PDF`,
      doYouHaveOrganizationAndDidYou: `Gostaria de proteger sua empresa?`,
      doYouWantToRemoveThePhone: `Deseja remover o telefone ?`,
      doyoureallyWanttoDeleteVacancy: `Deseja mesmo excluir esta vaga ?`,
      doYouReallyWantToRemoveTwoFactor: `Deseja mesmo remover o Two-factor authentication ?`,
      doYouReallyWantToRemoveThisAccount: `Deseja mesmo remover esta conta ?`,
      doYouReallyWantToRemoveThis: `Deseja mesmo remover esta {0} ?`,
      doYouWantToActivateTheProgram: `Deseja ativar o programa ?`,
      doYouWantToContinue: `Deseja continuar com os campos já preenchidos ?`,
      doYouWantDisableProgram: `Deseja desativar o programa ?`,
      doYouWantToPauseTheProgram: `Deseja pausar o programa ?`,
      doYouWantToAddVPNToYourNewProgram: `Você deseja adicionar VPN ao seu novo programa?`,
      editProgram: `Editar Programa`,
      editNda: `Editar NDA`,
      eligible: `Elegível`,
      efficiencyMetrics: `Métricas de eficiência`,
      emailAlreadyRegistered: `E-mail já esta cadastrado`,
      emailAlreadyValidatedNonExistent: `E-mail já validado ou expirado!`,
      emailConfirmation: `Confirmação de e-mail`,
      emailDoesNotAppearToBeValid: `O e-mail não parece ser válido`,
      emailSuccessfullyValidated: `Email validado com sucesso!`,
      enableTwoFactorAuthentication: `Habilitar autenticação de dois fatores`,
      end: `Final`,
      enterNewTags: `Digite novas tags separando as por virgula`,
      enterPasswordConfirmation: `Digite a confirmação da senha`,
      enterTheCode: `Digite o código`,
      enterTheCodeReceivedBySms: `Informe o código recebido por sms`,
      enterTheCompletePhone: `Informe o Telefone completo`,
      enterTheDescriptionOfTheOrganization: `Informe a descrição da organização`,
      enterTheEmail: `Informe o e-mail`,
      enterTheNameOfTheOrganization: `Informe o nome da organização`,
      enterThePassword: `Digite a senha`,
      enterTheUsername: `Informe o username`,
      enterTheScope: `Informe o escopo do programa!`,
      enterUserName: `Informe o nome do usuário`,
      enterYourEmail: `Informe seu e-mail`,
      enterYourFullName: `Escreva seu nome completo`,
      enterYourPayPalAccountEmail: `Informe o email da conta PayPal`,
      enterYourPrimaryEmailAddress: `Informe seu e-mail primário!`,
      enterYourUserPassword: `Informe sua senha de usuário`,
      enterYourRewardDetails: `Digite os detalhes da recompensa!`,
      evaluate_retest: `Avaliar reteste`,
      evaluatedRetest: `Reteste avaliado`,
      executiveSummary: `Sumário executivo da organização`,
      exit: `Sair`,
      expertSuccessfullCreated: `Especialista {0} criado com sucesso`,
      export: `Exportar`,
      exportLogs: `Exportar logs`,
      exportInCsv: `Exportar em .csv`,
      exportReports: `Exportar relatórios`,
      externalLinkNotice: `Aviso de link externo`,
      extract: `Extrato`,
      extractedBy: `Extraido por`,
      fillInTheDetailsBelowTo: `Preencha os detalhes abaixo para alterar sua senha.`,
      fillInAllFieldHighlightedInRed: `Preencha todos os campos destacados em vermelho!`,
      filterByTags: `Tags`,
      findSecurityJobsOnOurDashboard: `BugHunt conectando a comunidade com as melhores empresas.`,
      forgotYourPassword: `Esqueceu sua senha ?`,
      forSecurityWeRequestYourPassword: `Por segurança solicitamos sua senha para esta operação.`,
      forYourSecurityToPDF: `Para sua segurança é necessario adicionar uma senha ao PDF.`,
      fullName: `Nome completo`,
      generateNewCodes: `Gerar novos códigos`,
      getAccessToExclusiveRewards: `Tenha acesso à recompensas exclusivas deste programa!`,
      gift: `Brinde`,
      giftsAndAcknowledgments: `Brindes e Agradecimentos`,
      guests: `Convidados`,
      hackerControl: `Controle de Hackers`,
      haveYouRevised: `Revisou seu modelo? Então pronto!`,
      haveYouReviewedYourReportNow: `Revisou seu relatório? Então pronto, vamos enviá-lo para análise!`,
      here: `aqui`,
      hereYouCanSetUpYourAccount: `Aqui você pode configurar a sua conta para receber suas recompensas.`,
      high: `Alto`,
      historic: `Histórico`,
      features: `Funcionalidades`,
      iAlreadyHaveAnSccount: `Eu já tenho conta!`,
      iAlreadyRemembered: `Eu já lembrei!`,
      iAgreeWithThe: `Eu concordo com os `,
      ifYouDontReceiveIt: `Caso não receba, poderá tentar de novo em`,
      ifYouNeedToSubmitMoreComment: `Se precisar enviar mais, é só escrever outro comentário`,
      impact: `Impacto`,
      impactDescriptionCannotContainSpecialCharacters: `A descrição do impacto não pode conter caracteres especiais!`,
      inactivated: `inativado`,
      inactiveUsers: `Usuários Inativos`,
      initProgramMessage: `Programa iniciado dia `,
      informBugHuntPassword: `Informe a senha da plataforma BugHunt para confirmar esta operação.`,
      informThePhoneWithAreaCode: `Informe o telefone com DDD`,
      informTheRecommendations: `Informe as recomensas que o especialista vai obter caso tenha sucesso!`,
      informTheScope: `Informe o escopo`,
      informTheScopeWhereTheThreatsAre: `Informe o escopo onde estão as ameaças`,
      selectTheScopeType: `Selecione o tipo do escopo inspecionado`,
      informTheImpact: `Informe o impacto`,
      informTheUser: `Informe o usuário`,
      informTheWebsite: `Informe o website`,
      interationIdealTime: `O tempo médio ideal para {interationType} é de `,
      interviewWithExpertIgorRincon: `Entrevista com especialista Igor Rincon`,
      invalidBackupCodeOrToken: `Código ou token de backup inválidos`,
      invalidCode: `Código inválido`,
      invalidCodeOrToken: `Código ou token inválido`,
      invalidDate: `Data inválida`,
      invalidData: `Dados inválidos`,
      invalidRegistrationData: `Dados para cadastro {0} inválidos!`,
      invalidEmailOrPassword: `E-mail ou senha inválida!`,
      invalidPassword: `Senha inválida`,
      invite: `Convidar`,
      invitationAccepted: `Convite aceito`,
      invitationDeclined: `Convite recusado`,
      invitationLimitManagersReached: `O limite de convites para gestores foi atingido.`,
      invitationProgramLimitReached: `O limite de convites do programa {program} foi atingido.`,
      invitationNotFoundOrExpired: `Convite não encontrado ou expirado!`,
      invitationsAccepted: `Convite aceito`,
      invitationsReceived: `Convites Recebidos!`,
      invitationRevoked: `Convite revogado`,
      invitationSent: `Convite enviado`,
      invoiceValue: `Total da nota fiscal`,
      NdaCreated: `NDA criado`,
      inProgress: `Em andamento`,
      inRelationToTheReport: `Referente ao relatório`,
      inSomeCasesTheEmailMayFallAsSpam: `Em alguns casos, o e-mail pode ser considerado spam.`,
      integration: `Integração`,
      integrations: `Integrações`,
      integrationsNotAvailable: `Integrações não disponíveis!`,
      inTheProgram: `no programa`,
      internal: `Interno`,
      invoices: `Faturamentos`,
      iPAdress: `Endereço IP`,
      issued: `Emitido`,
      itHappensInTheBestFamilies: `Acontece nas melhores famílias! Não se preocupe, basta colocar seu e-mail e enviaremos uma nova senha.`,
      itHappensInTheBestFamiliesDonotworry: `Acontece nas melhores famílias! Não se preocupe.`,
      itIsNotPossibleToEnterEqualRewards: `Não é possível inserir recompensas iguais!`,
      itIsNotPossibleToEnterMore: `Não é possível inserir mais que 30 tags!`,
      itIsNotPossibleToSubmitAnotherRetest: `Não foi possível submeter a avaliação do reteste!<br /> Aguarde o reteste do especialista.`,
      iWantToCreateAnAccount: `Quero criar uma conta!`,
      jobBoard: `Painel de Vagas`,
      jobDescription: `##### Sobre a Empresa \n Descreva aqui os detalhes sobre sua **empresa**\n \n ##### Sobre a Vaga\n Estamos procurando por um Profissional que terá como principais responsabilidades:\n - Responsabilidade 1.\n - Responsabilidade 2.\n - Responsabilidade 3.\n \n ##### Requisitos\n - **Requisito 1:** Acima de x anos de experiência.\n - **Requisito 2:** Acima de x anos de experiência.\n - **Requisito 3:** Acima de x anos de experiência.`,
      jobTitle: `Título da Vaga`,
      joinedThePlatform: `Entrou na plataforma`,
      lastReviewSubmittedAgo: `Última revisão enviada há {0}`,
      lastInvitations: `Últimos Convites Enviados`,
      last7daysOfAccess: `Últimos 7 dias de acesso`,
      latestReports: `Últimos relatórios`,
      letStartYourRegistrationAnd: `Vamos iniciar seu cadastro e em breve iremos entrar em contato com você para esclarecer qualquer dúvida e finalizar seu cadastro!`,
      letsCompleteYourRegistration: `Vamos concluir seu cadastro!`,
      letsCreateYourAccount: `Vamos criar sua conta!`,
      letsCreateYourPreRegistration: `Vamos criar seu pré-cadastro!`,
      lessThanMonthAgo: `há menos de um mês`,
      like: `do tipo`,
      limitScope: `Delimite o escopo e somente os acessos que serão recopensados!`,
      limitOutOfScope: `Quais aplicações não devem ser testadas?`,
      limitOfScopesPerProgramReached: `Limite de {0} escopos por programa atingido!`,
      linkToJob: `Link para vaga`,
      location: `Localidade`,
      longPeriodsImpactSpecialists: `Longos períodos de espera podem impactar o engajamento dos especialistas neste programa.`,
      low: `Baixo`,
      makePayment: `Realize um Pagamento`,
      makeAPayment: `Realizar um Pagamento`,
      makeSureYouHaveACompatibleAppLike: `Certifique-se de ter um aplicativo compatível como `,
      makeYourAccessEvenMoreSecure: `Torne seu acesso ainda mais seguro`,
      manageAccess: `Gerencie quem tem acesso ao programa.`,
      managementInvitations: `Gerenciamento de convites recebidos.`,
      manageVPNforUsers: `Gerencie a VPN dos usuários de cada programa`,
      manageYourPlanInformation: `Gerencie as informações do seu plano.`,
      manageYourProgressPlatform: `Gerencie seu progresso na plataforma BugHunt`,
      maximumLengthIsCharacters: `Tamanho máximo é de {0} caracteres`,
      maximumFilesPerComment: `O máximo é de 10 arquivos por comentário`,
      medianTimeToResolution: `Tempo médio para resolução`,
      medianTimeToFirstResponse: `Tempo médio até a primeira resposta`,
      medium: `Médio`,
      metricDoesNotHaveEnoughDataYet: `Não existem dados suficientes para cálculo desta métrica`,
      metricsDoesNotHaveEnoughDataYet: `Ainda não existem dados suficientes para cálculo das métricas`,
      message: `Mensagem`,
      messagePostedAgo: `mensagem publicada há {time}`,
      messagePublishedDay: `mensagem publicada dia {day}`,
      missedResponseTargetsReportsSent: `Respostas enviadas acima do tempo esperado`,
      missedResponseTargetsResolved: `Resolução de relatórios acima do tempo esperado`,
      missedResponseTargetsBounty: `Pagamentos efetuados acima do tempo esperado`,
      monthlyFee: `Valor da mensalidade`,
      monthlyPayment: `Mensalidade`,
      moreOptions: `Mais opções`,
      money: `Dinheiro`,
      myPlan: `Meu Plano`,
      myBusiness: `Minha empresa`,
      nameChanged: `Nome alterado!`,
      nameOfAccountHolder: `Nome do responsável pela conta!`,
      nameIsNotValid: `O nome não é válido`,
      navigation: `Navegação`,
      needChangeDescription: `Utilize o molde para fazer uma descrição detalhada.`,
      ndaVerificationRequired: `Seu perfil está apto a participar do processo de verificação!`,
      ndaChange: `Mudança de NDA`,
      next: `Próxima`,
      new: `Novo`,
      newComment: `Novo comentário`,
      newUsers: `Novos Usuários`,
      newPassword: `Nova Senha`,
      newPasswordAndConfirmation: `Nova senha e confirmação não são iguais!`,
      newReport: `Novo relatório`,
      none: `Nenhum`,
      noActivePrograms: `Nenhum programa ativo`,
      noInvitationAvailable: `Nenhum convite disponível`,
      noNotificationsAvailable: `Nenhuma notificação disponível`,
      noPaymentsFound: `Nenhum pagamento encontrado`,
      noProgramAvailable: `Nenhum programa disponível`,
      noReportsFound: `Nenhum relatório encontrado`,
      noScopeAvailable: `Nenhum escopo disponível!`,
      noSuggestionsAvailable: `Nenhuma sugestão disponível`,
      noteValue: `Valor da Nota`,
      notAvailableForThisPlan: `Não disponível para este Plano!`,
      notAuthorized: `Não autorizado!`,
      shutdownRequested: `O encerramento deste relatório já foi solicitado!`,
      replyNotificationTitle: `Solicitação de resposta`,
      closingRequestTitle: `Solicitação de encerramento`,
      replyRequestMessage: `Já foi solicitada uma resposta para este relatório!`,
      notificationResponseReport: `Atenção! Uma resposta foi solicitada para este relatório.`,
      shutdownNotificationMessage: `Atenção! Foi solicitado o fechamento deste relatório.`,
      notificationSeeRequest: `Ver solicitação`,
      requestSent: `Solicitação enviada com sucesso!`,
      reportResponseNotification: `Atenção! Foi solicitado uma resposta deste relatório.`,
      notEligible: `Não elegível`,
      noExpertsFound: `Nenhum especialista encontrado`,
      notificationUpdatedNDA: `O contrato de confidencialidade do programa {programName} foi atualizado! Para continuar participando deste programa é necesário você revise e aceite o NDA.`,
      noUserAvailable: `Nenhum usuário disponível`,
      noVpnAccessLogFound: `Nenhum log de acesso a vpn encontrado!`,
      nowTellUsLittle: `Agora nos fale um pouco da política do programa!`,
      nowTellUsALittleBitAboutTheThreat: `Agora conte-nos um pouco sobre a ameaça!`,
      ofReward: `de recompensa`,
      oneDayAgo: `há um dia`,
      oldPassword: `Senha Antiga`,
      outstandingPayments: `Pagamentos pendentes`,
      open: `Aberto`,
      opssMatiDidntApproveYourData: `Opss, a Mati não aprovou seus dados.`,
      other: `Outros`,
      others: `Outros`,
      otherTypes: `Outros tipos`,
      outOfScope: `fora de escopo`,
      outOfScopeTitle: `Fora de Escopo`,
      participating: `Participando`,
      password: `Senha`,
      passwordChanged: `Senha alterada!`,
      passwordConfirmation: `Confirmação da Nova Senha`,
      passwordsMustMatch: `As senhas devem ser iguais`,
      passwordUpdateRequired: `Atenção! Altere sua senha para evitar o bloqueio desta conta!`,
      remainingDaysToUpdateYourPassword: `dias restantes para atualizar sua senha.`,
      passwordExpiredNotificationTitle: `Atenção! Sua senha expirou!`,
      passwordExpiredInstructions: `Sua conta será bloqueada temporariamente. Mantenha sua senha atualizada e siga as instruções enviadas ao e-mail associado a esta conta.`,
      enablePasswordExpiration: `Habilitar expiração de senha`,
      configSuccess: `Configuração atualizada com sucesso!`,
      expirePasswordConfig: `As senhas dos usuários serão válidas por`,
      passwordUpdateRequired: `Atenção! Altere sua senha para evitar o bloqueio desta conta!`,
      remainingDaysToUpdateYourPassword: `dias restantes para atualizar sua senha.`,
      passwordExpiredNotificationTitle: `Atenção! Sua senha expirou!`,
      passwordExpiredInstructions: `Sua conta será bloqueada temporariamente. Mantenha sua senha atualizada e siga as instruções enviadas ao e-mail associado a esta conta.`,
      enablePasswordExpiration: `Habilitar expiração de senha`,
      configSuccess: `Configuração atualizada com sucesso!`,
      expirePasswordConfig: `As senhas dos usuários serão válidas por`,
      pasteTheLinkIntoTheBodyOfTheDescription: `Cole o link no corpo da descrição.`,
      pause: `Pausar`,
      paused: `Pausado`,
      pauseProgram: `Pausar programa ?`,
      paymentFor: `Pagamento para`,
      paymentHistory: `Histórico de Pagamentos`,
      paymentSummary: `Resumo de pagamentos`,
      paymentRequested: `Pagamento solicitado`,
      pending: `Pendente`,
      pendingSubscription: `Pendente de Assinatura`,
      permission: `Permissão`,
      permissions: `Permissões`,
      pleaseMakeSureThatThisEmail: `Por favor, certifique-se que este email esteja correto e que pertença a você.`,
      phoneNumber: `Número de telefone`,
      phoneSuccessfullyRemoved: `Telefone removido com sucesso!`,
      phoneValidation: `Validação de telefone`,
      platform: `Plataforma`,
      points: `Pontos`,
      pointsIn: `pontos em`,
      possibleDup: `Relatório possivelmente duplicado - O escopo {scope} já recebeu relatórios referentes a {CWE}`,
      possibleSpam: `Possível SPAM - Verificamos que o especialista {expert} enviou vários relatórios referentes a {CWE} no escopo {scope}.`,
      postedComment: `postou um comentário `,
      postedImage: `Postou uma imagem`,
      previous: `Anterior`,
      primaryEmail: `e-mail principal`,
      primaryEmailReceiving: `E-Mail primário para recebimento de informações`,
      privacy: `Privacidade`,
      privacyPolicy: `Política de Privacidade`,
      private: `Privado`,
      privateProgram: `programa privado`,
      profileInformation: `Informações do Perfil`,
      profileVerifiedReleased: `Verificação de perfil solicitada`,
      program: `Programa`,
      programs: `Programas`,
      programDetails: `Detalhes do programa`,
      program_management: `Gerenciamento de programas`,
      programLifeCycle: `Ciclo de vida do programa`,
      programsLimitReached: `Limite de programas {0} atingido!`,
      programsIhaveAlreadyContributed: `Programas que já contribuí`,
      programPolicy: `Política do Programa`,
      programPolicyMustBeInformed: `A política do programa deve ser informada`,
      programPolicyMustBeBetweenAndCharacters: `A política do programa deve ter entre {f} e {l} caracteres`,
      programRanking: `Ranking do programa`,
      programNdaMustBeBetweenAndCharacters: `O conteúdo do NDA deve ter entre {f} e {l} caracteres`,
      programsPublishedOnTheWeb: `Programas publicados na web podem ser acessados por especialistas não cadastrados na plataforma.`,
      programSuccessfullyChanged: `Programa alterado com sucesso`,
      programType: `Tipo de Programa`,
      programWith: `Programa com {0}`,
      proofOfConceptLinks: `Links para prova de conceito são geralmente benignos, mas muitas vezes podem ser acompanhados por consequências não intencionais.`,
      setProgramNda: `Você deseja adicionar o contrato de confidencialidade ao seu novo programa?`,
      public: `Público`,
      publicInformation: `Dados Públicos`,
      publicOrPrivateProgram: `Programa público ou privado`,
      publicProgram: `programa público`,
      publish: `Publicar`,
      published: `Publicado`,
      publishedDaysAgo: `Publicado há {0}`,
      publishProgramOnTheWeb: `Publicar programa na Web ?`,
      publishToTheWeb: `Publicar na Web `,
      questionsAboutUrl: `Dúvidas sobre {0}`,
      rankingDoesNotHaveEnoughDataYet: `O Ranking ainda não tem dados suficientes`,
      rankingPosition: `{0}° no Ranking`,
      received: `Recebido`,
      receiveAdvertising: `Receive advertising emails`,
      receiveEmails: `Recebimento de E-Mails`,
      receiveAdvertisingEmails: `Receber e-mails de propaganda`,
      receiveNotificationsAboutNewReports: `Receba notificações sobre novos relatórios diretamente em suas plataformas de gestão`,
      referenceDate: `Data de referência`,
      refuseRetest: `Recusar reteste`,
      refusedRetest: `recusou o reteste`,
      registerBelowTheTags: `Gerenciamento de tags`,
      registeredUsers: `Usuários Registrados`,
      registeredVacancies: `Vagas`,
      registration: `Cadastro`,
      removeAccount: `Remover Conta`,
      remove: `Remover`,
      removeFromWhitelist: `Remover da Whitelist`,
      removeFromBlacklist: `Remover da Blacklist`,
      removed: `Removido`,
      reportAllPossibleThreatData: `Informe todos os dados possíveis das ameaças`,
      report: `Relatório`,
      reportID: `ID do relatório`,
      reportCreatedSuccessfully: `Relatório criado com sucesso`,
      reportEvaluation: `Avaliação do relatório`,
      reportPayments: `Pagamentos de relatórios`,
      reports: `Relatórios`,
      reportSent: `Relatório enviado`,
      reportsSent: `Relatórios enviados`,
      reportTitle: `Título do relatório`,
      reportedThatTheVulnerabilityIsFixed: `informou que a vulnerabilidade está corrigida`,
      reportedThatTheVulnerabilityIsNotPatched: `informou que a vulnerabilidade não está corrigida`,
      reportedVulnerabilities: `Vulnerabilidades reportadas`,
      vulnerabilities: `Vulnerabilidades`,
      overviewSubTitle: `Uma visão gerencial da sua conta só para você`,
      summaryCard: `Resumo dos relatórios`,
      requestedPayment: `solicitou um pagamento`,
      requestedPaymentOf: `solicitou o pagamento de`,
      requestedANewTestOfTheReport: `solicitou um novo teste do relatório`,
      reset: `Limpar`,
      rewardValue: `Valor da recompensa`,
      whatIsAnNda: `O que é um NDA?`,
      whatIsAnNda2: `NDA é uma sigla em inglês para Non-Disclosure-Agreements, ou simplesmente acordo de sigilo de informações.`,
      whatIsAnNda3: `Ele tem a intenção de proteger segredos industriais, comerciais, ou ainda qualquer informação que não pode ser divulgada e deve manter-se em sigilo entre aqueles que têm acesso a ela.`,
      whatIsaVPNAndHow: `O que é uma VPN e como ele pode ajudar em seus programas ?`,
      reportTags: `Adicionar tag(s) no relatório`,
      requestNewPassword: `Solicitar nova senha!`,
      requestRetest: `Solicitar Reteste`,
      requestSubscription: `Solicitar Assinatura`,
      requiredField: `Campo obrigatório`,
      retestRequested: `Reteste Solicitado`,
      requestedRetestPayment: `solicitou o pagamento do reteste`,
      retestId: `Reteste id`,
      retestSent: `Reteste enviado`,
      return: `Voltar`,
      resolved: `Resolvidos`,
      revoke: `Revogar`,
      revokeWebAccessToTheProgram: `Revogar acesso Web ao programa ?`,
      revoked: `Revogado`,
      revokeAccess: `Revogar Acesso`,
      rewardAmount: `Valor da Recompensa`,
      reward: `Recompensa`,
      rewardDetails: `Detalhes da recompensa`,
      rewards: `Recompensas`,
      rewardsReceived: `Recompensas Recebidas`,
      rewardsWithFinancialValues: `Recompensas com valores financeiros`,
      save: `Salvar`,
      saveEditions: `Salvar alterações`,
      saveNda: `Salvar contrato de confidencialidade`,
      saveInformation: `Salvar`,
      scopePerProgram: `Escopo por programa`,
      scopesPerProgram: `Escopos por programa`,
      search: `Pesquisar`,
      seconds: `segundos`,
      select: `Selecione`,
      selectAddAccount: `Selecione "Adicionar conta" ou "+" e digitalize o código QR abaixo`,
      selectAScoreForTheReport: `Selecione uma pontuação para o relatório`,
      selectFile: `Selecione o arquivo!`,
      selectProgram: `Selecione um programa`,
      selectLanguage: `Selecione um idioma`,
      selectScopeType: `Selecione o tipo de escopo`,
      selectTheThreat: `Selecione a ameaça!`,
      selectTheProgramScope: `Selecione o escopo do programa!`,
      selectTheProgramImpact: `Selecione o impacto do programa!`,
      selectTheReport: `Selecione o relatório`,
      selectTheScope: `Selecione o escopo`,
      selectTheCWE: `Selecione o CWE`,
      selectTheVulnerability: `Selecione a vulnerabilidade`,
      securityAnalyst: `Ex. Analista de segurança`,
      send: `Enviar`,
      sentTheRetest: `Enviou o reteste`,
      sendMessage: `Enviar Mensagem`,
      sent: `Enviou`,
      sentTo: `Enviado`,
      sentTheReport: `enviou o relatório`,
      settings: `Configurações`,
      severityReports: `Relatórios por severidade`,
      severity: `Severidade`,
      currentValue: `Valor atual`,
      finalValue: `Valor final`,
      showingResultsOfTotal: `Mostrando {results} de {totalResults} resultados.`,
      since: `Desde {0}`,
      sinceLastMonth: `desde mês passado`,
      situation: `Situação`,
      scope: `Escopo`,
      scopeLimitExceeded: `O limite de escopos do programa foi excedido.`,
      scopeListOfTheProgram: `Lista de escopo do programa!`,
      score: `Pontuação`,
      scoreHistory: `Histórico de pontuação`,
      scopeType: `Tipo do Escopo`,
      share: `Compartilhar`,
      smsCode: `Código SMS`,
      smsCodeSent: `Código SMS enviado`,
      specialist: `Especialista`,
      specialistNotFound: `Especialista não encontrado!`,
      standard: `Padrão`,
      standoutCreate: `Destaque-se! Crie um título motivador.`,
      start: `Início`,
      pauseMessage: `Não foi possível executar a ação, uma vez que a campanha ainda não teve início.`,
      startAnAccountForOrganization: `Criar uma conta para organização`,
      startWithRewards: `Começe pelas recomensas que possuem valor financeiro`,
      statistics: `Estatísticas`,
      stateCity: `Estado`,
      status: `Status`,
      statusChanged: `Status alterado!`,
      storeYourBackupCodes: `Armazene seus códigos de backup`,
      subdomain: `Subdomínio`,
      submittedDays: `Enviado tem {0} dias`,
      submitComment: `Enviar Comentário`,
      submitForReview: `Enviar para Análise`,
      rewardNotice: `Lembrete: Esse programa oferece recompensa em dobro`,
      submitReport: `Submeter Relatório`,
      submit_retest: `Submeter reteste`,
      successfullyGeneratedKeys: `Keys geradas com sucesso!`,
      suggestions: `Sugestões`,
      suggestedReward: `Recompensa sugerida`,
      summary: `Resumo`,
      superSimpleItDoesntEvenTake: `É simples, não leva nem 1 minuto. Basta informar os dados abaixo e pronto! Sua conta está criada.`,
      superSimpleItDoesntEvenTakeCompany: `É simples, não leva nem 1 minuto. Basta informar os dados comuns da organização e pronto! Sua conta será enviada para análise.`,
      support: `Suporte`,
      sureAddExpertBlacklist: `Tem certeza de que deseja adicionar este especialista a blacklist ?`,
      sureAddExpertWhiteList: `Tem certeza de que deseja adicionar este especialista a Whitelist ?`,
      sureRemoveExpertBlacklist: `Tem certeza de que deseja retirar este especialista da Blacklist ?`,
      sureRemoveExpertWhitelist: `Tem certeza de que deseja remover este especialista da Whitelist ?`,
      successfullyCreatedProgram: `Programa criado com sucesso`,
      successfullyCreated: `criada com sucesso`,
      acceptedNda: `NDA aceito com sucesso!`,
      openReports: `Relatórios abertos`,
      openYourApp: `Abra seu aplicativo.`,
      or: `ou`,
      organizationName: `Nome da organização`,
      overallRanking: `Ranking Geral`,
      paidRetest: `Se o&nbsp;<b>reteste for aprovado</b>, você receberá mais&nbsp;<b>{0}</b>&nbsp;do valor do bounty.`,
      tagsAreUsedToHelpIdentifyReports: `As Tags são utilizadas para auxiliar na identificação dos relatórios.`,
      tagsForReports: `Tags para relatórios`,
      takeAction: `Realizar Ação`,
      takeTheOpportunityToAcquireMoreComplete: `Aproveite a oportunidade para adquirir planos mais completos para sua empresa`,
      talkDirectlyToOurOperators: `Fale diretamente com nossos operadores.`,
      target: `Tempo esperado: {0}`,
      telephone: `Telefone`,
      testDescriptionsMustBetweenCharacters: `A descrição dos testes deve ter entre {f} e {l} caracteres`,
      tests: `Testes`,
      terms: `Termos`,
      termsAPolicy: `Termos e Política`,
      termsOfUse: `Termos de Uso`,
      thanksForRegistering: `Obrigado por se cadastrar!`,
      thankByEmail: `Agradecimento por e-mail`,
      theActionsTakenOnTheReportCannotBe: `As ações feitas no relatório não poderão ser removidas`,
      theCommentNeedsToBeInformed: `O comentário precisa ser informado!`,
      theDescriptionTestsMustBeInformed: `A descrição dos testes precisa ser informada`,
      theDescriptionOfTheProgramMustBeInformed: `A descrição do programa deve ser informado`,
      theImpactDescriptionMustBeInformed: `A descrição do impacto precisa ser informada`,
      theImpactDescriptionMustBetweenCharacters: `A descrição do impacto deve ter entre {f} e {l} caracteres`,
      theIsNotValid: `O {0} não válido`,
      theFileIsNotValid: `O arquivo não é válido!`,
      theNameMustBeFromToCharacters: `O nome deve ter de {f} a {l} caracteres`,
      theNameOfThePersonResponsibleIsMandatory: `O nome do responsável é obrigatório.`,
      theNameOfTheProgramMustBInformed: `O nome do programa deve ser informado`,
      theNameWillBeAssignedToYourProgramsURL: `O nome será atribuido a URL do seu programa.`,
      thenUseYourEmail: `Então utilize seu e-mail, sua senha e acesse nossa plataforma. Caso tenha esquecido da senha ou seu usuário, utilize a opção de recuperação abaixo!`,
      thePhoneIsNotValid: `O telefone não é valido.`,
      theProgramDescriptionMustBeBetweenAndCharacters: `A descrição do programa deve ter entre {f} e {l} caracteres!`,
      theProgramNameMustBeBetweenAndCharacters: `O nome do programa deve ter entre {f} e {l} caracteres`,
      thereIsAlreadyAprogram: `Já existe um programa cadastrado com esse nome!`,
      thereIsAlreadyProgramSlug: `Já existe um programa cadastrado com essa slug!`,
      theReportNeedsToBeInformed: `O relatório precisa ser informado`,
      theRetestMustBeSentWithinDays: `O reteste deve ser enviado em até {0} dias`,
      theRetestWasNotSubmitted: `O reteste não foi submetido!`,
      theRetestHaAlreadyAccepted: `O reteste já foi aceito!`,
      theseSettingsDirectlyImpactTheAccessOfExperts: `Essas configurações impactam diretamente no acesso dos especialistas.`,
      theScopeAddressMustBeInformed: `O endereço do escopo deve ser informado`,
      theThreatDescriptionMustBeInformed: `A descrição da ameaça deve ser informada!`,
      theThreatDescriptionMustBetweenCharacters: `A descrição da ameaça deve ter entre {f} e {l} caracteres`,
      theTitleMustBeInformed: `O título precisa ser informado`,
      theTitleMustBeBetweenCharacters: `O título deve ter entre {f} e {l} caracteres`,
      theWebhookIsNotValid: `O webhook não é válido!`,
      theWebsiteMustBeFromToCharacters: `O website deve ter de {f} a {l} caracteres`,
      thisChangeIsIrreversible: `Essa alteração é irreversível.`,
      thisInformationCanAppear: `Essas informações podem aparecer no perfil público da empresa, ao lado dos seus comentários e em qualquer um dos seus relatórios.`,
      thisIsAnInternalSurvey: `Esta é uma pesquisa interna, os especialistas não terão acesso aos dados deste questionário.`,
      thisServiceCreatesAVPNResponsible: `Este serviço cria uma VPN, responsável por conectar e monitorar o tráfego de dados dos testes do especialista aos seus escopos, e com isso maior rastreabilidade e segurança.`,
      thisWeek: `nesta semana`,
      threats: `Ameaças`,
      time: `Tempo`,
      timeToFirstResponse: `a primeira resposta`,
      timeToBounty: `pagar a recompensa`,
      timeToResolution: `encerrar o relatório`,
      title: `Título`,
      to: `para`,
      toAcceptThisInvitation: `Para aceitar este convite é necessário se verificar na Meta<b>Map</b> , após a verificação, aguarda alguns minutos e atualize a página.`,
      tokenIsInvalid: `O token é inválido ou já foi utilizado`,
      toAddMorePrograms: `Para acrescentar mais programas confira nossos planos clicando`,
      toAddMoreScopesToThe: `Para acrescentar mais escopos no programa confira nossos planos clicando`,
      toAddMoreUsersCheck: `Para acrescentar mais usuários, confira nossos planos clicando`,
      toAddTheseIntegrations: `Para acrescentar estas integrações confira nossos planos clicando`,
      toAddThisFeatureCheck: `Para acrescentar este recurso, confira nossos planos clicando`,
      toChangeYourPlanContactSupport: `Para alterar seu plano, entre em contato com o suporte.`,
      toCheck: `Verificar`,
      toConfirmWeNeedYourPassword: `Para confirmar precisamos de sua senha`,
      toConfirmYourRegistrationOn: `Para confirmar seu cadastro em nossa plataforma é necessário clicar no botão abaixo.`,
      today: `Hoje`,
      toDoThisYouNeedToEnterYourAppCode: `Para fazer isso é preciso digitar o código de seu aplicativo ou colar um de seus tokens de backup!`,
      topReportedCWE: `CWE mais relatado`,
      totalConnectedHours: `Total de horas conectadas`,
      totalEvents: `Total de eventos`,
      totalMonthlyFees: `Total das mensalidades`,
      totalReports: `Total de relatórios`,
      totalReceived: `Total Recebido`,
      totalRewards: `Total de recompensas`,
      toTheProgram: `ao programa`,
      totalSpent: `Total Pago`,
      totalSum: `Somatório Total`,
      trackYourOpenReports: `Acompanhe seus relatórios abertos`,
      twoFactorAuthentication: `Autenticação de dois fatores`,
      type: `Tipo`,
      typeOfContract: `Tipo de contrato`,
      typeOrPasteOneOfYourBackupTokens: `Digite ou cole um de seus tokens de backup, lembrando que cada token só pode ser usado uma vez!`,
      typeProgramLimitExceeded: `O limite de programas do tipo {programType} foi excedido`,
      unableToCompleteThisRequest: `Não foi possível concluir esta solicitação.`,
      unableToSubmittedTheReport: `Não foi possível submeter este relatório. Certifique-se que todos os campos foram preenchidos corretamente.`,
      undefinedRanking: `Ranking indefinido`,
      uninformed: `Não informado`,
      unshowPassword: `Esconder senha`,
      update: `Atualizar`,
      updates: `Atualizações ({numberOfUpdates})`,
      updated: `Atualizado`,
      uploadFiles: `Enviar arquivos`,
      upTo: `Até`,
      urlIsNotValid: `A url não é válida`,
      useBackupCode: `Usar código de backup ?`,
      user: `Usuário`,
      userBlockedForOverTrying: `Usuário bloqueado por excesso de tentativas, tente novamente mais tarde.`,
      userByCompany: `Usuário por empresa`,
      userDisconnected: `Usuário desconectado!`,
      userLimitReached: `Limite de usuários atingido!`,
      userLoggedIn: `Usuário conectado!`,
      usersByCompany: `Usuários por empresa`,
      userDoesNotHavPermissionToPerform: `Usuário não tem permissão para executar esta ação`,
      usernameHasInvalidCharacters: `O nome de usuário possui caracteres inválidos`,
      usernameIsNotAvailable: `O username não está disponível!`,
      usernameMustBeFromCharacters: `O nome de usuário deve ter de {f} a {l} caracteres.`,
      users: `Usuários`,
      userEmail: `Usuário ou e-mail`,
      usersOnTheBlacklist: `Usuários na Blacklist não terão acesso a este programa!`,
      userRemoved: `Usuário removido`,
      useYourAuthenticationAppToEnterTheCode: `Use seu aplicativo de autenticação para inserir o código`,
      validatePhone: `Validar telefone`,
      validatedPhone: `Telefone validado`,
      value: `Valor`,
      verified: `Verificado`,
      verifieds: `Verificados`,
      vpnIP: `IP da VPN`,
      waitingConfirmation: `Aguardando confirmação`,
      wantSaveChangesProgram: `Você deseja mesmo salvar as alterações feitas neste programa?`,
      waysExplore: `Formas de Explorar`,
      weLeaveThisPanel: `Deixamos esse painel para você publicar suas vagas para nossos especialistas`,
      whatIsBugBounty: `O que é Bug Bounty`,
      whatIsYourAction: `Qual sua ação?`,
      whatIsNdaHeader: `Fique atento!`,
      whatPrograms: `Quais programas?`,
      whatTypeOfVulnerability: `Qual o tipo de vulnerabilidade reportada`,
      whoDoYouWantInvite: `Quem deseja convidar?`,
      whiteMessage: `Escreva uma mensagem...`,
      weakPasswordContain: `Senha fraca! ela deve cont`,
      websiteInvitation: `Convite do site`,
      weSendAToast: `Enviamos um brinde`,
      weAreUnderMaintenance: `Estamos em manutenção! Retorne em breve!`,
      weTemporarilyStoreYourReport: `Armazenamos temporariamente os dados de seu relatório para o programa`,
      weWillContactYouShortly: `Em breve entraremos em contato para confirmar seus dados.`,
      wikiSubTitle: `Nós ajudamos como podemos e como não podemos.`,
      withoutWebAccessTheProgram: `Sem acesso Web o programa ficará disponível apenas para usuários da plataforma.`,
      workModel: `Modelo de trabalho`,
      workSchedule: `Horário de Trabalho`,
      yesIWantToRegister: `Sim, quero me cadastrar`,
      yes: `Sim`,
      no: `Não`,
      youAcceptedThisInvitation: `Você aceitou esse convite`,
      youAreAboutToVisitLink: `Você está prestes a visitar um link externo.`,
      youAreAllowedToViewTheReports: `Tem permissão para ver os relatórios.`,
      youCanUseOneOfTheseBackupCodes: `Você pode usar um desses códigos de backup para fazer o login, caso perca o acesso ao seu smartphone. Lembre-se de que cada código só pode ser usado uma vez.`,
      yourCurrentPlanIsThe: `Seu plano atual é`,
      youDoNotHaveAnyTagRegistered: `Você não possui nenhuma Tag cadastrada, para adicionar acesse o menu <a href="/account?tags">Minha Conta/Tags</a>`,
      youDontHave: `Você não possui`,
      youDontHaveAnyAcceptedInvitations: `Ainda não possui convites aceitos!`,
      youDontHaveAnyInvitationsWaiting: `Ainda não possui convites aguardando respostas!`,
      youDontHaveAnyNDAs: `Você ainda não possui um programa com contrato de confidencialidade!`,
      youDontHaveAnyNDAsHacker: `Você ainda não concordou com nenhum contrato de confidencialidade!`,
      youDontHaveAnyProgramsInThisCategoryYet: `Você ainda não possui programas nessa categoria`,
      youDontHaveSubmittedReports: `Ainda não possui relatórios aprovados!`,
      youHave: `Você possui`,
      youHaveBeenInvitedToSend: `Você foi convidado para enviar relatórios à esse programa`,
      youHavePermissionToViewAndEditReports: `Tem permissão para ver e editar os relatórios.`,
      youMustAgreeToThe: `Você precisa concordar com os`,
      youMustAgreeToTheTermsOfUse: `Você precisa concordar com o termo de uso.`,
      youMustAgreeToTheTermsOfUseAndCodeOfConduct: `Você precisa concordar com o termo de uso e código de conduta.`,
      yourAccessPassword: `Sua senha de acesso!`,
      yourAccesEmail: `Seu e-mail de acesso ao {0}`,
      youReachedLimit: `Você atingiu o limite diário de envio de relatórios!`,
      yourEmail: `Seu email`,
      yourFullName: `Seu nome completo!`,
      yourNameMustBeBetweenAndCharacters: `Seu nome deve ter entre {f} e {l} caracteres!`,
      yourOrganizationNameIsRequired: `O nome da sua organização é obrigatório`,
      YourOrganizationTradeName: `Nome fantasia da sua organização!`,
      yourPassword: `Sua senha`,
      yourPhoneToGetInTouch: `Telefone para entrarmos em contato!`,
      yourProfileIsNowAbleTo: `Seu perfil está apto a participar do processo de verificação!`,
      ndaVerificationRequired1: `Você foi convidado para participar do programa `,
      ndaVerificationRequired2: `A verificação do seu perfil é necessária para aceitar este convite!`,
      ndaVerificationRequired3: `Confira a sua lista de notificações e prossiga com o processo de verificação.`,
      noJobsFound: `Nenhuma vaga encontrada`,
      registrationDone: `Cadastro efetuado!`,
      reportPaymentVerificationRequired1: `O pagamento de uma recompensa para o relatório `,
      reportPaymentVerificationRequired2: `foi solicitado!`,
      reportSummaryNotValid: `O resumo do relatório não é válido!`,
      reportContentIsNotValid: `O conteúdo do relatório não é válido!`,
      reportVulnerabilitIsNotValid: `O impacto da vulnerabilidade não é válido!`,
      reportCriticalityIsNotValid: `A criticidade da vulnerabilidade não é válida`,
      reportCantAcceptEspecialCaracter: `( Não é possível inserir caracteres especiais. )`,
      reportScopeIsNotValid: `O identificador do escopo do relatório não é válido!`,
      reportIdentifierIsNotValid: `O identificador do programa não é válido!`,
      reportVulnerabilityIdentifierIsNotValid: `O identificador da vulnerabilidade não é válido!`,
      ndaVerificationRequired6: `Complete a validação do seu perfil para que possamos prosseguir com o pagamento da recompensa!`,
      reportTitleIsNotValid: `O título do relatório não é válido!`,
      showPassword: `Mostrar senha`,
      companyNdaVerificationRequired: `Você precisa criar um NDA para o seu programa antes de convidar especialistas!`,
      taxesNotIncluded: `Tributos não inclusos`,
      youAcceptedParticipateInThisProgram: `Você aceitou participar deste programa.`,
      youCanCalculate: `Você pode calcular a severidade através da calculadora abaixo`,
      youShouldConsiderUsingSeparate: `Você deve considerar o uso de um navegador ou máquina virtual separada antes de continuar.`,
      yourSecurityPlatformAndBugReward: `A sua plataforma de Bug Bounty`,
      youWereInvitedPartOf: `Você foi convidado a fazer parte do time {0}, Basta informar os dados da sua conta.`,
      youWillBeRedirectedIn: `Você será redirecionado em`,
      youWillReceiveReportsFromCommunity: `Você irá receber relatórios dos especialistas em segurança da nossa comunidade, sem nenhum custo adicional, minimizando os riscos de seus dados serem expostos ou vulnerabilidades exploradas.`,
      invitationsSummary: `Resumo dos convites`,
      doubleReward: `Recompensa em dobro`,
      boostedProgram: `Programa impulsionado!`,
      doubleCampaignNotificationStarted: `Campanha de bonificação iniciada`,
      doubleCampaignNotificationClosed: `Campanha de bonificação encerrada`,
      doubleCampaignNotificationPaused: `Campanha de bonificação pausada`,
      doubleCampaignNotificationResumed: `Campanha de bonificação retomada`,
      campSubTitle: `Gerencie suas campanhas! Acompanhe todos os detalhes.`,
      historicCampaign: `Histórico`,
      historicDoubleBounty: `Bounty em dobro`,
      historicDoubleScore: `Score em dobro`,
      inText: `De`,
      until: `Até`,
      finished: `Finalizado`,
      in_progress: `Em progresso`,
      situationCancel: `Cancelado`,
      createdTh: `Criado em`,
      periodTh: `Período`,
      rewardsTh: `Recompensas`,
      situationsTh: `Situações`,
      historicApproved: `Aprovados`,
      historicCancel: `Cancelados`,
      historicPaused: `Pausados`,
      historicFinished: `Finalizados`,
      notificationAttention: `Atenção!`,
      notificationYourCampaignHasStarted: `Sua campanha foi iniciada!`,
      notificationThisCampaign: `Esta campanha`,
      notificationHasClosed: `foi encerrada`,
      notificationHasBeenPaused: `foi pausada`,
      keepAnEyeOutNotification: `fique de olho`,
      notificationWillLetYouKnowWhenToStartAgain: `avisaremos quando iniciar novamente.`,
      notificationThisCampaignIsLiveAgain: `Esta campanha está no ar novamente!`,
      finalDate: `Fim`,
      remain: `Restam`,
      campaignStarted: `A campanha de recompensas dobradas foi iniciada!`,
      campaignClosed: `A campanha de recompensas dobradas foi finalizada!`,
      campaignPause: `A campanha de recompensas dobradas foi pausada!`,
      campaignReactivated: `A campanha de recompensas dobradas foi reativada!`,
      campaignFinalDays: `para o fim da campanha`,
      campaignInitialDays: `para o inicío da campanha`,
      dayCampaign: `dia`,
      daysCampaign: `dias`,
      daysGeneric: `dia(s)`,
      btnRegister: `Cadastrar`,
      btnCancel: `Cancelar`,
      btnLabel: `Selecione a data`,
      doubleBounties: `Dobrar bounties`,
      doubleScore: `Dobrar pontuação`,
      activeDoubleCampaign: `Impulsionar programa`,
      selectAPeriod: `Selecione um período:`,
      monthlyRanking: `Ranking Mensal`,
      generalRanking: `Ranking Geral`,
      expertRating: `Confira a classificação dos especialistas BugHunt`,
      bountyOffer: `Você está oferencendo: Bounties em dobro`,
      bountyScore: `Você está oferencendo: Pontuação em dobro`,
      bountyAndScoreOffer: `você está oferecendo: Bouties e Pontuação em dobro`,
      closeCampaign: `Encerrar Campanha de bonificação`,
      pauseCampaign: `Pausar Campanha de bonificação`,
      reactivateCampaign: `Reativar Campanha de bonificação`,
      boostCampaign: `Impulsionar programa`,
      doubleCheckCampaign: `Estou ciente das alterações do valor atual das recompensas.`,
      successfullyCreatedCampaign: `Solicitação realizada com sucesso, por favor aguarde análise de aprovação da campanha!`,
      vpnMessage: `Não há uma vpn habilitada neste programa.`,
      campaignPaused: `Campanha pausada com sucesso!`,
      doubleCampaignClosed: `Campanha encerrada com sucesso!`,
      doubleCampaignResumed: `Campanha retomada com sucesso!`,
      registeredProgramWarning: `Este programa já possui uma campanha aprovada ou encerrada a menos de 15 dias.`,
      warningBoutiesOrScore: `A campanha deve oferecer bounties ou pontuação em dobro!`,
      invalidDateMessage: `Data inválida, por favor verifique se o campo foi preenchido corretamente!`,
      v_administrator: `administrador`,
      v_viewer: `visualizador`,
      v_analyst: `analista`,
      administrator: `Administrador`,
      viewer: `Visualizador`,
      analyst: `Analista`,
      v_private: `privado`,
      v_public: `publico`,
      v_internal: `interno`,
      v_new: `novo`,
      v_under_review: `em revisão`,
      v_triaged: `triado`,
      v_needs_information: `necessita de informações`,
      v_approved: `aprovado`,
      v_informative: `informativo`,
      v_duplicated: `duplicado`,
      v_not_applicable: `não aplicável`,
      v_spam: `spam`,
      v_accepted: `Aceitos`,
      v_pending: `Pendentes`,
      v_declined: `Recusados`,
      v_revoked: `Revogados`,
      v_pending_retest: `Reteste`,
      v_retest_done: `Reteste concluído`,
      retest_done: `Reteste concluído`,
      pending_retest: `Reteste Pendente`,
      notImpact: `Severidade não informada`,
      lowImpact: `Severidade baixa`,
      mediumImpact: `Severidade média`,
      highImpact: `Severidade alta`,
      criticalImpact: `Severidade crítica`,
      approved: `Aprovado`,
      informative: `Informativo`,
      duplicated: `Duplicado`,
      not_applicable: `Não aplicável`,
      spam: `Spam`,
      comment: `Postar um comentário`,
      change_situation: `Alterar situação`,
      update_severity: `Alterar severidade`,
      request_update: `Solicitar atualização`,
      retest: `Solicitar reteste`,
      pay_bounty: `Pagar uma recompensa`,
      close_report: `Fechar o relatório`,
      reopen_report: `Reabrir o relatório`,
      needs_information: `Aguardando informações`,
      under_review: `Em revisão`,
      triaged: `Triado`,
      plan_trial: `Plano Trial`,
      plan_bronze: `Plano Bronze`,
      plan_silver: `Plano Prata`,
      plan_gold: `Plano Ouro`,
      trial: `Trial`,
      bronze: `Bronze`,
      silver: `Prata`,
      gold: `Ouro`,
      fulltime: `Full-time`,
      parttime: `Part-time`,
      clt: `CLT`,
      pj: `PJ`,
      autonomous: `Autônomo`,
      cltflex: `CLT-Flex`,
      cooperative: `Cooperativo`,
      internship: `Estágio`,
      hybrid: `Híbrido`,
      office: `Presencial`,
      remote: `Remoto`,
      web: `Aplicação Web`,
      api: `API`,
      mobileapplication: `Aplicação Mobile`,
      mobileapplicationandroid: `Aplicação Mobile Android`,
      mobileapplicationios: `Aplicação Mobile IOS`,
      ip: `Endereço de IP`,
      january: `Janeiro`,
      february: `Fevereiro`,
      march: `Março`,
      april: `Abril`,
      may: `Maio`,
      june: `Junho`,
      july: `Julho`,
      august: `Agosto`,
      september: `Setembro`,
      october: `Outubro`,
      november: `Novembro`,
      december: `Dezembro`,
      seeOriginalText: `Texto original.`,
      waiting_for_information: `Aguardando informações`,
      severity_updated: `Severidade atualizada`,
      retest_requested: `Solicitação de resteste`,
      bounty_paid: `Recompensa paga`,
      close_as_approved: `Fechar como aprovado`,
      close_as_informative: `Fechar como informativo`,
      close_as_spam: `Fechar como spam`,
      close_as_duplicated: `Fechar como duplicado`,
      close_as_not_applicable: `Fechar como não aplicável`,
      select_option: `Selecione uma opção`,
      deleteMessageAlert: `Tem certeza de que deseja excluir esta mensagem?`,
      automaticMessage: `Ao selecionar a opção, a resposta automática será registrada como uma primeira interação no relatório.`,
      defaultMessageCenterMenu: `Central de Mensagens Padrão`,
      registerNotFound: `Nenhum registro foi encontrado.`,
      registeredMessageTitle: `Mensagens Cadastradas`,
      customSettingsTitle: `Configurações Personalizadas`,
      customSettingsSubtitle: `Configuração de mensagens para respostas padronizadas`,
      addMessageButton: `Adicionar mensagem`,
      existingMessageAlert: `É possível cadastrar apenas uma mensagem por tipo de mensagem. Atualmente, todas as mensagens já estão registradas!`,
      editMessage: `Editar Mensagem`,
      registerMessage: `Cadastrar Mensagem`,
      placeholderTitleMessage: `Titulo da mensagem`,
      placeholderTextAreaMessage: `Adicione uma descrição...`,
      labelAutomatic: `Automático`,
      alertMessageSuccess: `Mensagem cadastrada com sucesso!`,
      alertMessageUpdate: `Mensagem atualizada com sucesso!`,
      swalTokenRemoved: `O token foi excluído com sucesso.`,
      deleteTokenCompany: `Excluir token`,
      placeholderTokenCompany: `Digite um token`,
      errorToken: `O token deve conter no mínimo 20 caracteres e no máximo 500 caracteres!`,
      emailNotification: `A notificação por e-mail foi ativada com sucesso!`,
      enableEmailNotification: `Ativar o recebimento de atualizações do programa por meio de endereço eletrónico.`,
      emailNotificationDisabled: `A notificação enviada por e-mail foi desativada!`,
      china: `China`,
      india: `Índia`,
      estadosUnidos: `Estados Unidos`,
      indonesia: `Indonésia`,
      paquistao: `Paquistão`,
      brasil: `Brasil`,
      nigeria: `Nigéria`,
      bangladesh: `Bangladesh`,
      russia: `Rússia`,
      mexico: `México`,
      japao: `Japão`,
      etiopia: `Etiópia`,
      filipinas: `Filipinas`,
      egito: `Egito`,
      vietna: `Vietnã`,
      repuplicaDemocraticaDoCongo: `República Democrática do Congo`,
      turquia: `Turquia`,
      ira: `Irã`,
      alemanha: `Alemanha`,
      tailandia: `Tailândia`,
      reinoUnido: `Reino Unido`,
      franca: `França`,
      italia: `Itália`,
      tanzania: `Tanzânia`,
      africaDoSul: `África do Sul`,
      mianmar: `Mianmar (Birmânia)`,
      coreiaDoSul: `Coreia do Sul`,
      colombia: `Colômbia`,
      quenia: `Quênia`,
      espanha: `Espanha`,
      ucrania: `Ucrânia`,
      uganda: `Uganda`,
      sudao: `Sudão`,
      angertina: `Argentina`,
      angelia: `Argélia`,
      iraque: `Iraque`,
      polonia: `Polônia`,
      canada: `Canadá`,
      uzbequistao: `Uzbequistão`,
      arabiaSaudita: `Arábia Saudita`,
      br: `Português`,
      en: `Inglês`,
      es: `Espanhol`,
      fr: `Francês`,
      it: `Italiano`,
      ru: `Russo`,
      de: `Alemão`,
      jp: `Japonês`,
      cn: `Chinês`,
      pl: `Polonês`,
      ua: `Ucraniano`,
      sd: `Árabe`,
      kr: `Coreano`,
      in: `Hindi`,
      id: `Indonésio`,
      pk: `Urdu`,
      bd: `Bengali`,
      et: `Amárico`,
      ph: `Filipino (Tagalo)`,
      vn: `Vietnamita`,
      tr: `Turco`,
      ir: `Persa`,
      th: `Tailandês`,
      za: `Africâner`,
      mm: `Birmanês`,
      ug: `Suaíli`,
      uz: `Uzbeque`,
      sa: `Árabe`,
      additionalMoreLanguages: `Adicionar mais idioma`,
      country: `País`,
      language: `Idioma`,
      clearText: `Utilizar a mensagem padrão`,
      selectCountry: `Selecione um país`,
      basic: `Básico`,
      proficiency: `Proficiência`,
      conversational: `Conversacional`,
      fluent: `Fluente`,
      native: `Nativo ou bilingue`,
      AreYouSureYouWantToCompleteTheRequest: `Tem certeza de que deseja concluir esta solicitação?`,
      managers: `Gestores`,
      manageProgram: `Defina quem irá gerenciar o seu novo programa.`,
      config: `Configurações`,
      programSettings: `Configurações do programa`,
      programEditAlert: `Atenção! Não é possível editar programas inativos ou aguardando aprovação.`,
      changeSettings: `Alterar configurações`,
      managersWithAccesToTheProgram: `Gestores com acesso ao programa`,
      freeAccess: `Acesso liberado`,
      pendingInviteAlert: `Atenção! Já existe um convite pendente associado a este endereço de email.`,
      USDT: `Dólar`,
      BRL: `Real`,
      selectCurrencyType: `Selecione o tipo de moeda`,
      passwordSuccess: `Senha cadastrada com sucesso!`,
      isNan: `O valor informado deve ser numérico.`,
      filterScope: `Filtrar por escopo`,
      selectScope: `Selecione uma opção de escopo`,
      filterScopeTitle: `Filtro por escopo`,
      scopeSelected: `Escopo selecionado`,
      summaryFinancialCard: `Resumo financeiro`,
      summaryTotalCard: `Total de aportes`,
      summaryTotalPgCard: `Total pago`,
      projectedValueLabel: `Quantidade de meses a serem projetados`,
      totalMonthlyPayments: `Total de mensalidades`,
      totalManagedServices: `Total de serviços gerenciados`,
      totalRewardsPaid: `Total de recompensas pagas`,
      monthAndyear: `Mês/Ano`,
      contribution: `Aporte`,
      managed: `Gerenciado`,
      costProjection: `Projeção de custos`,
      contributionBalance: `Saldo do aporte`,
      detailsNF: `Detalhes NF`,
      total: `Total`,
      expenseNotification: `Fique no controle! Configure notificações para quando você atingir "70%" do seu orçamento de gasto.`,
      errorValueBudget: `Informe o limite do budget`,
      errorBudgetNotification: `Informe o percentual desejado`,
      labelInvalidValue: `Valor inválido. Por favor, insira um valor entre 0 e 100`,
      labelCurrencyValue: `Valor inválido: Não é possível cadastrar valores negativos.`,
      titleBudgetActive: `Limitar custos mensais de recompensas`,
      budgetLimitProgram: `O budget limite para este programa é`,
      errorBudgetLimit: `Informe o limite do budget`,
      invalidValueBudget: `Valor inválido: Não é possível cadastrar valores negativos.`,
      notificationBudget: `Notificar quando atingir o valor de`,
      percentageBudget: `Informe o percentual desejado`,
      percentageErrorBudget: `Valor inválido. Por favor, insira um valor entre 0 e 100`,
      pauseProgramBudget: `Pausar o programa antes de atingir o total do budget?`,
      percentagePauseBudget: `Porcentagem de pausa (0-99%)`,
      createCredentialTooltip: `Definir credencial`,
      confirmBtn: `Confirmar`,
      swalCredential: `Credencial salva com sucesso.`,
      labelCredentialForTest: `As credenciais para testar o sistema e o escopo do programa`,
      labelCredentialForTestContinued: `estão listadas abaixo`,
      labelCredentialIndividual: `Uso individual. Não compartilhe para garantir a sua segurança.`,
      labelCredentialShared: `Uso compartilhado. Todos os especialistas possuem o mesmo acesso.`,
      credentials: `Credenciais`,
      confirmPassword: `Confirmar Senha`,
      confirmPasswordToViewCredential: `Confirme sua senha de acesso à plataforma para visualizar as `,
      confirmPasswordToViewCredentialContinued: `credenciais disponíveis`,
      hello: `Olá`,
      doYouHaveCredentials: `você tem credenciais para usar nos sistemas e escopos que serão testados`,
      manageYourCredentials: `Gerencie suas credenciais genéricas cadastradas para facilitar o acesso dos especialistas que realizarão testes em seus sistemas`,
      manageYourCredentialsTooltip: `Gerencie suas credenciais`,
      credentialPublica: `Credencial Genérica`,
      credentialPrivate: `Credencial Exclusiva`,
      credentialPublicaDescription: `As credenciais genéricas cadastradas serão enviadas para todos os especialistas que estão participando do programa, com o objetivo de serem utilizadas para realizar os testes de segurança.`,
      credentialSentToSpecialist: `As credenciais exclusivas cadastradas serão enviadas apenas para o especilista de destino`,
      credentialSentToSpecialistContinued: `com o objetivo de serem utilizadas para realizar os testes de segurança.`,
      request_review: `Solicitar revisão da triagem`,
      request_review_report: `solicitou revisão da triagem`,
      reviewRequestedNotification: `Solicitação de revisão`,
      availableCredential: `Credencial disponível`,
      allActionsAllowed: `Tem permissão para gerenciar todos os programas e usuários.`,
      owner: `Owner`,
      AreYouSureYouWantToUpdateTheUserRole: `Você deseja aplicar as alterações nas permissões deste usuário?`,
      v_owner: `owner`,
      manageCredentials: `Gerencie as credencias cadastradas.`,
      setPublicCredential: `Gerencie suas credenciais públicas`,
      programSpellers: `Especialistas do programa`,
      viewCredentials: `Visualizar Credenciais`,
      informPassword: `Informe sua senha`,
      credentialDeleted: `Credencial deletada com sucesso!`,
      genericError: `Algo deu errado. Estamos resolvendo isso agora. Por favor, tente novamente mais tarde.`,
      delete: `Excluir`,
      toClose: `Fechar`,
      labelDeleteCredential: `Tem certeza de que deseja excluir esta credencial?`,
      credentialsTooltip: `Credenciais Disponíveis`,
      setPasswordExpiration: `Definir expiração de senha`,
      authenticationViaEmail: `Habilitar autenticação via email`,
      accessValidation: `Validação de acesso`,
      invalidCodeError: `O código informado não é válido!`,
      confirmPasswordLabel: `Confirme a sua senha de acesso à plataforma para finalizar a ação desejada.`,
      emailAuthenticationInformation: `Aumente a segurança de todas as contas, habilitando a autenticação por e-mail, protegendo as informações dos usuários contra acessos indevidos.`,
      alertTwoFactory: `<div class="container-two-factory"><p class="two-factory-descrition">Para enviar um relatório neste programa, é necessário habilitar a autenticação de dois fatores. Sua segurança é nossa prioridade e essa camada extra de proteção é essencial para garantir a integridade de sua conta. <span>Siga as etapas de configuração para ativar a autenticação de 2 fatores agora.</span></p></div>`,
      twoFactoryNewUsersContinuation: `poderão interagir com os relatórios.`,
      restriction: `Restrição`,
      warningTwoFactorAuthentication: `Atenção! Configuração de autenticação de 2 fatores necessária.`,
      labelFeatureTwoFactorAuthentication: `Somente gestores com Two-factor Authentication podem interagir com relatórios de programas.`,
      labelFeatureTwoFactorAuthenticationHacker: `Apenas os especialistas com Two-Factor Authentication podem enviar novos relatórios para o programa.`,
      configureNow: `Configurar agora`,
      enable2fa: `ativada a obrigatoriedade de configurar a autenticação de duplo fator`,
      disable2fa: `desativada a obrigatoriedade de configurar a autenticação de duplo fator`,
      itWas: `Foi`,
      toProgram: `para o programa,`,
      translateText: `Traduzir texto`,
      openingDate: `Data de abertura:`,
      classification: `Classificação`,
      confidential: `Confidencial`,
      selectProgram: `Selecionar programa`,
      swalSuccess: `Alteração realizada com sucesso.`,
      dateDownloadReport: `de download`,
      setHallOfFame: `Você deseja ativar o hall da fama em seu novo programa?`,
      addHackerToHof: `Você deseja adicionar o especialista ao Hall da fama?`,
      hallOfFame: `Hall da Fama`,
      hallOfFameDoesNotHaveEnoughDataYet: `O Hall da Fama ainda não possui especialistas!`,
      hallOfFameThanksDescription: `gostaria de agradecer aos seguintes pesquisadores por reportarem falhas de segurança significativas.`,
      addedAt: `Adicionado em`,
      programByObjective: `Programa por objetivo`,
      programObjective: `Objetivo do Programa`,
      nowTellUsLittleObjective: `Agora nos fale um pouco do objetivo do programa!`,
      aGoodObjectiveAvoids: `Um objetivo bem definido evita problemas, caso tenha algum problema nos consulte.`,
      target: `Objetivo`,
      include: `Incluir`,
      infoTarget: `Atenção! É necessário informar pelo menos um objetivo.`,
      aboutTarget: `Sobre o objetivo do programa!`,
      setProgramReward: `Defina a recompensa do programa.`,
      maxProgram: `Atenção! É permitido no máximo 10 objetivos por programa.`,
      requiredProgram: `Por favor, cadastre um objetivo para o programa.`,
      targetRequired: `Por favor, preencha o objetivo do programa.`,
      requiredBounty: `Por favor, insira um valor.`,
      idConfirmation: `Falta pouco! Confirme sua identidade para prosseguir com o processo de troca de senha.`,
      titleTarget: `Título do objetivo`,
      targetPlaceholder: `Título do objetivo do programa!`,
      titleTargetError: `Por favor, preencha o título objetivo do programa.`,
      updateTarget: `Objetivo atualizado com sucesso!`,
      swalTarget: `Por favor, verifique se os campos estão preenchidos corretamente.`,
      areYouSureYouWantToDeleteThisTarget: `Tem certeza de que deseja remover este objetivo ?`,
      removeTargetProgram: `Objetivo removido com sucesso!`,
      selectAnObjectiveForTheReport: `Qual o tipo de objetivo reportado`,
      informTheTarget: `Informe o objetivo`,
      selectTheProgramTarget: `Selecione um objetivo do programa!`,
      achievedTheObjective: `O objetivo do programa foi atingido?`,
      reachedIn: `Objetivo atingido em`,
      noObjectivesAvailable: `Nenhum objetivo disponível!`,
      removeIn: `removido`,
      achievedIn: `alcançado pelo`,
      pauseProgramSwal: `Programa pausado por falta de objetivo(s) ativo.`,
      cBoostedProgram: `Programa impulsionado`,
      signedAgreements: `Contratos assinados`,
      ccpProgObj: `Programa por Objetivo`,
      ccpProgObjDesc: `Criar um programa com objetivos pré-definidos, onde você escolhe quem pode participar e enviar relatórios!`,
      objectiveProgram: `programa por objetivo`,
      publicPrograms: `programas públicos`,
      privatePrograms: `programas privados`,
      objectivePrograms: `programas por objetivo`,
      alertMessageRemoved: `Mensagem removida com sucesso!`,
      scopeNotFound: `Escopo não encontrado.`,
      usernameOrEmail: `Username ou E-Mail`,
      aboutTheProgramPolicyHacker: `As regras contidas na política do programa devem ser respeitadas!`,
      jiraIssueType: `Qual será o tipo da atividade que será cadastrada no jira?`,
      conceded: `concedeu`,
      toTheSpecialist: `ao especialista`,
      getToKnow: `Conheça`,
      solutions: `Soluções`,
      contact: `Contato`,
      ourBlog: `Nosso Blog`,
      doubts: `Dúvidas?`,
      inTheMedia: `Na mídia`,
      talkToUs: `Fale conosco`,
      understandHowItWorks: `Entenda como funciona!`,
      publicPrograms: `Programas públicos`,
      privatePrograms: `Programas privados`,
      managedPrograms: `Programas gerenciados`,
      vdpPrograms: `Programas VDP`,
      howItWorks: `Como funciona!`,
      ranking: `Ranking`,
      url: `URL`,
      multipliedScore: `Bônus! score multiplicado`,
      codeOfConduct: `Código de Conduta`,
      and: `e`,
      reportConfidential: `Classificação do documento: Confidencial`,
      securitySystem: `Sistema de Segurança`,
      emailAlreadyRegisteredInOurDatabase: `Email já cadastrado em nossa base de dados`,
      theTokenMustBeEntered: `O token precisa ser informado`,
      actionAlreadyReported: `Ação já reportada!`,
      statusPauseProgram: `O programa foi pausado`,
      statusStartProgram: `O programa foi reativado`,
      by: `por`,
      in: `em`,
      invalidName: `O nome inserido não é válido!`,
      includeMoreDetails: `Acrescentar mais detalhes...`,
      maxTech: `O máximo permitido é de 10 tecnologias por escopo.`,
      maxLine: `Por favor, limite a mensagem a no máximo 10 quebras de linha.`,
      includeInfoScope: `Insira observações sobre o escopo... `,
      includeTech: `Insira as tecnologias`,
      editScope: `Editar escopo`,
      scopeDetails: `Detalhes do escopo`,
      minMaxScopeCaracter: `O escopo deve ter entre 3 e 40 caracteres`,
      characters: `Caracteres`,
      //translation_script_end_pt
    }),

    new MLanguage('english').create({
      ln: 'en',
      //translation_script_start_en
      agreementText: `Do you agree with the terms of the confidentiality agreement?`,
      agree: `I agree`,
      doNotAgree: `I don't agree`,
      programWithNda: `This program has a linked NDA!`,
      ndaAccepted: `NdA accepted!`,
      programWithoutNda: `This program doesn't have a linked NDA yet!`,
      menuProgram: `Programs`,
      menuReport: `Reports`,
      menuAccount: `My account`,
      navInvitations: `Invites`,
      navPayments: `Payouts`,
      navCreateNda: `Create an NDA Template`,
      navEditNda: `Edit NDA`,
      navPrograms: `Programs`,
      navPublished: `Published`,
      navClosed: `Inactive`,
      navNda: `NDAs`,
      navAll: `All`,
      navPending: `Pending`,
      navRetest: `Retest`,
      dashTitle: `Welcome {0}!`,
      dashSubTitle: `An overview and quick access of your account just for you`,
      dashReportResolv: `Approved reports`,
      navAverage: `Average Rewards`,
      dashMsgYouHave: `You have`,
      dashMsgYouDHave: `You don't have`,
      msgProgramPu: `public programs!`,
      msgProgramPr: `private programs!`,
      dashMsgGP: `Manage your programs.`,
      dashMsgCP: `Register a program now?`,
      dashInvTitle: `Invite Experts!`,
      dashInvSubTitle: `Invite specialists to participate in your programs.`,
      dashPayTitle: `Payments!`,
      dashPaySubTitle: `Financial summary and payment requests.`,
      dashNdaTitle: `Confidentiality contracts!`,
      dashNdaSubTitle: `Manage the confidentiality agreements for your programs.`,
      dashCreatNdaTitle: `Standard NDA template!`,
      dashCreatNdaSubTitle: `Create a standard template for managing confidentiality agreements for your programs.`,
      dashCreatNdaAbriefsummary: `A brief summary for the specialist to understand what it is about...`,
      dashCreatNdaDesc: `NdA is an acronym in English for Non-Disclosure-Agreements, or simply information confidentiality agreement. It is intended to protect industrial or commercial secrets, or any information that cannot be disclosed and must be kept confidential among those who have access to it.`,
      dashCreatNdaWriteTerms: `Draft the terms of your confidentiality agreement and its peculiarities.`,
      dashCreatNdawritePaste: `Let's get started, write or paste your terms!`,
      dashCreatNdaWantAttach: `Do you want to attach a document to be signed?`,
      progTitle: `Overview!`,
      progSubTitle: `Track and manage your programs on BugHunt.`,
      progPubTitle: `Published programs!`,
      progPubSubTitle: `Manage your published programs! Keep track of all the details.`,
      progCampTitle: `Campaigns`,
      progClosTitle: `Inactive programs!`,
      progClosSubTitle: `Did you miss me? See the data for inactive programs.`,
      progCreateTitle: `Create a Program`,
      progCreateSubTitle: `Exciting moment, time to start creating your program!`,
      progRankTitle: `Contributions ranking!`,
      progRankSubTitle: `See who contributes the most to your programs.`,
      progRankSendThank: `Send a Thank You!`,
      progRankBtnSendThank: `Send Acknowledgement`,
      progTimelineTitle: `Program's Timeline!`,
      progTimelineSubTitle: `Follow the timeline of your programs`,
      repTitle: `Reports!`,
      repSubTitle: `Manage the reports submitted by experts to your programs.`,
      repSubTitleHacker: `Manage the reports sent to the programs.`,
      repDetMsgAlter: `Changes made to the report cannot be undone!`,
      ccpTitle: `Are we going to create a program?`,
      ccpProgPubli: `Public program`,
      ccpProgPubliDesc: `Create a program where all registered specialists can view and submit reports!`,
      ccpProgVDPDesc: `Create a program where all specialists can view and submit reports!`,
      ccpProgPriv: `Private program`,
      ccpProgPrivDesc: `Create a program where only selected specialists can view and submit reports!`,
      managedProgram: `Managed program`,
      protectedByNDA: `Protected by an NDA`,
      helpTitle: `Needing help?`,
      helpProgram: `How does a program work?`,
      helpDifference: `What is the difference between private and public?`,
      helpaverage: `What is the average applied to a bounty?`,
      rankTitle: `Contributions ranking`,
      retest_confirmed: `Redressed`,
      retest_denied: `Failure persists`,
      accountSubTitle: `An overview and quick access of your account just for you.`,
      accountAcSubTitle: `Who, when, and how accessed your account`,
      accountTerSubTitle: `Access our terms and privacy policy`,
      accountUserSubTitle: `Manage who has access to the organization.`,
      accountSettSubTitle: `How you want to receive your emails, privacy policy, and others.`,
      aboutUs: `About us`,
      aboutYou: `About you`,
      aboutYourAccount: `About your account`,
      aboutTheProgramPolicy: `About the program's politics!`,
      add: `Add`,
      addUser: `Add User`,
      addAcomment: `Add a comment`,
      addExpertToBlacklist: `Add expert to the Blacklist`,
      addTheScopesHere: `Add the scopes here!`,
      addOutOfScopesHere: `Add here the applications that should be avoided during safety tests!`,
      addYourPayPalAccount: `Add your PayPal account`,
      adjustedTheImpactTo: `Adjust the impact to`,
      adjustedTheImpactFrom: `Adjusted the impact of`,
      adjustMetrics: `Adjust Metrics`,
      allowedFiles: `Allowed files: videos, images and text files .jpg .jpeg .png .txt .rar .zip .7z`,
      alreadyHaveAccount: `Do you already have an account?`,
      accepted: `Accepted`,
      acceptThisInvitation: `Accept this Invitation!`,
      access: `Access history`,
      accessControl: `Access control`,
      accessMyAccount: `Access my account!`,
      accessProfile: `Access profile`,
      accessInformation: `Access information`,
      accountCreatedSuccessfully: `Account created successfully!`,
      accountDeleted: `Deleted account`,
      accountRecovery: `Account recovery`,
      accurate: `Ascertained`,
      activate: `Activate`,
      activated: `Enabled`,
      additionalServices: `Additional services`,
      addOtherRewardsHere: `Add other rewards here!`,
      addToBlacklist: `Add to Blacklist`,
      agreementSpecialists: `Experts in agreement`,
      ago: `{0} ago`,
      aGoodPolicAvoids: `A good policy avoids problems, if you have any problems contact us.`,
      all: `All`,
      gatTagOptDescription: `Only reports that contain the GAT tag`,
      gatTagDescription: `What reports will be sent to the GAT platform?`,
      allowMobileAccess: `Allow cell phone accesses`,
      allowedToPayReward: `You are allowed to pay rewards.`,
      allThePrograms: `All programs`,
      allStatus: `All Statuses`,
      aLowercaseLetter: `a lowercase letter`,
      anEmailContainingPasswordReset: `An email containing instructions for resetting the password has been sent.`,
      aNewValidationEmailHasBeenSenToYou: `A new validation email has been sent to you, please check your mailbox`,
      aNewSuperStrongPassword: `A new super strong password!`,
      annotation: `Note`,
      aNumber: `a number`,
      anUppercaseLetter: `a capital letter`,
      thePasswordMustHave: `The password must have`,
      anyQuestionsAboutIntegration: `Questions about this integration?`,
      application: `Application`,
      applicableReport: `Applicable report`,
      approvedReports: `Approved reports`,
      approveWithoutRetest: `Do you really want to close the report as approved before requesting a retest?`,
      approveRetest: `Approve retest`,
      approvedRetest: `Approved the retest`,
      areYouSureYouWantToDeleteThisUser: `Are you sure you want to delete this user?`,
      as: `like`,
      aSuperStrongPasswordNow: `A super strong password now!`,
      atBugHuntYouWillFindPrograms: `At BugHunt you will find programs to test different types of technologies, put your knowledge into practice, testing real applications in an ethical and legalized way.`,
      attention: `Attention!`,
      atLeastCharacters: `at least 6 characters`,
      authentication: `Authentication`,
      averageTicket: `Medium ticket`,
      average_time_to_bounty: `Average time to pay a reward`,
      average_time_to_first_response: `Average time for the first response`,
      average_time_to_resolution: `Average time to close the report`,
      averageTimeToBounty: `Average payment time`,
      avgTimeToBounty: `The average time elapsed from the company's first interaction with a report to the request for payment of a reward.`,
      avgTimeToFirstResponse: `The average time elapsed from the submission of the report to the company's first interaction with a report.`,
      avgTimeToResolution: `The average time elapsed from the opening of a report to its closing.`,
      awaitingAcceptance: `Waiting for acceptance`,
      awaitingPayment: `Awaiting payment`,
      paymentReceived: `Received payment`,
      awaitingResponse: `Waiting for Reply`,
      award: `Awarding`,
      backupCodesLeft: `Remaining backup codes`,
      balance: `Balance`,
      basedLast90Day: `Based on the last 90 days`,
      beforeActivatingTwoFactorAuthentication: `Before activating Two-factor authentication, you must validate your phone.`,
      beforeContinuingYouNeed: `Before continuing you need to validate your email!`,
      billingCreditCard: `Billing Credit card`,
      billingForms: `Billing forms`,
      billingInformation: `Billing information`,
      byActivatingTheProgramSpecialistsWill: `By activating the program, specialists will be able to submit new reports!`,
      byPausingTheProgramExpertsWill: `When you pause the program, specialists will no longer be able to submit new reports!`,
      bounty: `Financial`,
      bountyAwarded: `Reward granted`,
      bugBountyAndTheSecurityParadox: `Bug Bounty and the Security Paradox`,
      bugHuntIsTheFirstBrazilianBugBounty: `<b>BugHunt</b> is the first Brazilian Bug Bounty platform, and is now partnering with <b>AME Digital</b> with the purpose of democratizing access to information security and thereby making the Internet a safer place.`,
      ongoingProfileVerification: `Your profile is being verified!`,
      cancel: `Cancel`,
      cannotEnterEqualScopes: `It is not possible to enter equal scopes`,
      cannotEnterSpecialCharacters: `It is not possible to enter special characters`,
      cautionNDA1: `When drafting your company's NDA, make sure that it includes the following items:`,
      cautionNDA2: `contain at least one penalty clause in case of non-compliance;`,
      cautionNDA3: `inform the parties that make that commitment;`,
      cautionNDA4: `contain an expiration date;`,
      cautionNDA5: `detail specifically what that NDA refers to, since generic and ambiguous information mischaracterizes the legal document;`,
      cautionNDA6: `Use the tag `,
      cautionNDA7: `to refer to the name of the specialist;`,
      cautionNDA8: `The NDA template below is illustrative. Make sure you enter your company details correctly when drafting the confidentiality agreement `,
      changeAccessPassword: `Change access password`,
      changePassword: `Change Password`,
      changePermission: `Change permission`,
      changedReportSeverity: `Severity of the report changed`,
      changedReportStatus: `Report status changed`,
      changedTheStatusFrom: `changed the situation from {f} to {l}`,
      changedTheSituationTo: `changed the situation to {0}`,
      changedTheTitleOf: `changed the title of the report from {f} to {l}`,
      changedTheTitleTo: `changed the report title to {0}`,
      changedTheVisibilityOf: `changed visibility from {f} to {l}`,
      changedTheVisibilityTo: `changed visibility to {0}`,
      checkOutAllFieldsHighlightedInRed: `Check out all the fields highlighted in red!`,
      chooseANicknameYoursAlone: `Choose a nickname to be just yours!`,
      city: `Townland`,
      clickHereToLearn: `Learn more.`,
      clearData: `Clear data`,
      clearlyDefine: `Clearly define your program policy.`,
      close: `Enclosing`,
      closed: `Terminated`,
      closedAgo: `Closed {0} days`,
      closedIn: `Ended in`,
      closedReport: `Closed report`,
      closedReports: `Closed reports`,
      closedTheReportAs: `Close the report as`,
      reopenedTheReport: `Reopened the report`,
      code: `Code`,
      conclude: `Conclude`,
      connectionDenied: `Denied connection`,
      connectionTime: `Approximate connection time`,
      connectionRefusedUserDisabled: `Connection refused, user disabled!`,
      connectionsPerUser: `Connections per user`,
      contacts: `Liaisons`,
      company: `Undertaking`,
      completed: `Completed`,
      confirm: `Confirm!`,
      confirmAccountRemoval: `Confirm Account Removal`,
      confirmYourPassword: `Confirm your password!`,
      token2fa: `Enter the 2-factor authentication token`,
      confirmProgramChanges: `Describe the changes made to the program`,
      congratulationsYourUsernameIsNowVerified: `Congratulations, your username is now verified.`,
      invalidEmail: `Invalid email, please check and try again.`,
      continueReport: `Continue Report`,
      copiedId: `Copied id`,
      copyLink: `Copy link`,
      continue: `Continue`,
      creatAccountInvit: `You created the account by invitation`,
      createA: `Create a`,
      created: `Created!`,
      createMyAccount: `Create my account!`,
      critical: `Critical`,
      request_response: `Response`,
      request_closure: `Foreclosure`,
      responseRequestReport: `requested a response to this report.`,
      reportClosureRequest: `requested closure of this report.`,
      day: `daytime`,
      days: `days`,
      dateTime: `Date/time`,
      declined: `Refused`,
      dataChanged: `Changed data!`,
      dataWillBeRemovedWithPhoneValidation: `2fa data will be removed upon validation of the phone!`,
      date: `Date`,
      declineThisInvitation: `Decline this Invitation!`,
      delimitDomains: `Delimit domains, subdomains, apps, and more`,
      delimitItems: `Delimit items`,
      deleteUser: `Delete user`,
      depositedAmount: `Total Contributions`,
      delimitationOfDomainsSubdomains: `Delimiting domains, subdomains, apps, and others`,
      describeALittleMoreAboutTheImpact: `Describe a little more about the impact!`,
      describeChangesMadeInProgram: `This summary will be available to all specialists participating in this program!`,
      describeClearlyHowTheVulnerabilityWorks: `Clearly describe how the vulnerability works.`,
      describeInDetailTheImpactOfThisRepor: `Describe in detail the impact of this report.`,
      describeThePerformedTests: `Describe the tests performed`,
      describeTheTitleOfTheReport: `Describe the title of the report`,
      describeTheScope: `What is the URL of the vulnerable application?`,
      description: `Description`,
      descriptionSubmitReport: `##### 1. Summary\\n(add vulnerability summary)\\n\\n##### 2. Description\\n(add more details about this vulnerability)\\n1. [add step]\\n\\n##### 3. Steps to reproduce\\n(Add details of how we can reproduce the problem)\\n1. [add step]\\n2. [add step]\\n3. [add step]\\n\\n##### 4. Supporting material/references\\n(e.g. screenshots, logs, etc.) \\n1. List any additional material\\n `,
      descriptionCannotContainSpecialCharacters: `The description cannot contain special characters`,
      descriptionMustBeFromToCharacters: `The description must be {f} to {l} characters long.`,
      describeEditsMade: `Describe what changed on your program.`,
      details: `Details`,
      directoryName: `Directory name`,
      disable: `Disable`,
      domain: `Domain`,
      done: `Done`,
      doNotUseSpecialCharactersAndMalicious: `Do not use special characters and malicious payloads in the title, impact, and summary, these items must be attached as .zip, .rar, or .7z at the end of the report.`,
      doNotUseSpecialCharacters: `Do not send payloads with possible malicious code, these items must be attached as .zip, .rar, or .7z!`,
      dontForgetToSaveYourChanges: `Don't forget to save the changes!`,
      downloadTheReportPDF: `Download the Report in PDF`,
      doYouHaveOrganizationAndDidYou: `Would you like to protect your company?`,
      doYouWantToRemoveThePhone: `Do you want to remove the phone?`,
      doyoureallyWanttoDeleteVacancy: `Do you really want to delete this vacancy?`,
      doYouReallyWantToRemoveTwoFactor: `Do you really want to remove Two-factor authentication?`,
      doYouReallyWantToRemoveThisAccount: `Do you really want to remove this account?`,
      doYouReallyWantToRemoveThis: `Do you really want to remove this {0}?`,
      doYouWantToActivateTheProgram: `Do you want to activate the program?`,
      doYouWantToContinue: `Do you want to continue with the fields already filled in?`,
      doYouWantDisableProgram: `Do you want to deactivate the program?`,
      doYouWantToPauseTheProgram: `Do you want to pause the program?`,
      doYouWantToAddVPNToYourNewProgram: `Do you want to add VPN to your new program?`,
      editProgram: `Edit Program`,
      editNda: `Edit NDA`,
      eligible: `Eligible`,
      efficiencyMetrics: `Efficiency metrics`,
      emailAlreadyRegistered: `E-mail is already registered`,
      emailAlreadyValidatedNonExistent: `Email already validated or expired!`,
      emailConfirmation: `E-mail confirmation`,
      emailDoesNotAppearToBeValid: `The email does not seem to be valid`,
      emailSuccessfullyValidated: `Email successfully validated!`,
      enableTwoFactorAuthentication: `Enable two-factor authentication`,
      end: `Finish`,
      enterNewTags: `Type new tags by separating them by a comma`,
      enterPasswordConfirmation: `Enter password confirmation`,
      enterTheCode: `Enter the code`,
      enterTheCodeReceivedBySms: `Enter the code received by SMS`,
      enterTheCompletePhone: `Enter the full telephone number`,
      enterTheDescriptionOfTheOrganization: `Enter the description of the organization`,
      enterTheEmail: `Enter the e-mail`,
      enterTheNameOfTheOrganization: `Enter the name of the organization`,
      enterThePassword: `Enter the password`,
      enterTheUsername: `Enter the username`,
      enterTheScope: `Tell me the scope of the program!`,
      enterUserName: `Enter the username`,
      enterYourEmail: `Enter your email`,
      enterYourFullName: `Write your full name`,
      enterYourPayPalAccountEmail: `Enter the PayPal account email`,
      enterYourPrimaryEmailAddress: `Enter your primary email!`,
      enterYourUserPassword: `Enter your user password`,
      enterYourRewardDetails: `Enter the reward details!`,
      evaluate_retest: `Evaluate retest`,
      evaluatedRetest: `Evaluated retest`,
      executiveSummary: `Executive summary of the organization`,
      exit: `Exit`,
      expertSuccessfullCreated: `Expert {0} created successfully`,
      export: `Export`,
      exportLogs: `Export logs`,
      exportInCsv: `Export to .csv`,
      exportReports: `Export reports`,
      externalLinkNotice: `External link warning`,
      extract: `Statement`,
      extractedBy: `Extracted by`,
      fillInTheDetailsBelowTo: `Fill in the details below to change your password.`,
      fillInAllFieldHighlightedInRed: `Fill in all the fields highlighted in red!`,
      filterByTags: `Tags`,
      findSecurityJobsOnOurDashboard: `BugHunt connecting the community with the best companies.`,
      forgotYourPassword: `Forgot your password?`,
      forSecurityWeRequestYourPassword: `For security reasons we request your password for this operation.`,
      forYourSecurityToPDF: `For your security it is necessary to add a password to the PDF.`,
      fullName: `Full name`,
      generateNewCodes: `Generate new codes`,
      getAccessToExclusiveRewards: `Get access to the exclusive rewards of this program!`,
      gift: `Toast`,
      giftsAndAcknowledgments: `Gifts and Acknowledgements`,
      guests: `Guests`,
      hackerControl: `Hacker control`,
      haveYouRevised: `Have you reviewed your model? Then ready!`,
      haveYouReviewedYourReportNow: `Have you reviewed your report? So done, let's send it for analysis!`,
      here: `hereto`,
      hereYouCanSetUpYourAccount: `Here you can set up your account to receive your rewards.`,
      high: `High`,
      historic: `History`,
      features: `Functionalities`,
      iAlreadyHaveAnSccount: `I already have an account!`,
      iAlreadyRemembered: `I already remembered!`,
      iAgreeWithThe: `I agree with the `,
      ifYouDontReceiveIt: `If you don't receive it, you can try again at`,
      ifYouNeedToSubmitMoreComment: `If you need to send more, just write another comment`,
      impact: `Severity`,
      impactDescriptionCannotContainSpecialCharacters: `The impact description cannot contain special characters!`,
      inactivated: `inactivated`,
      inactiveUsers: `Inactive users`,
      initProgramMessage: `Program started day `,
      informBugHuntPassword: `Enter the BugHunt platform password to confirm this operation.`,
      informThePhoneWithAreaCode: `Enter the number with DDD`,
      informTheRecommendations: `Tell me the rewards that the specialist will receive if successful!`,
      informTheScope: `Enter the scope`,
      informTheScopeWhereTheThreatsAre: `Tell me the scope where the threats lie`,
      selectTheScopeType: `Select the type of scope inspected`,
      informTheImpact: `Report the impact`,
      informTheUser: `Tell the user`,
      informTheWebsite: `Tell the website`,
      interationIdealTime: `The ideal average time for {InterationType} is `,
      interviewWithExpertIgorRincon: `Interview with expert Igor Rincon`,
      invalidBackupCodeOrToken: `Invalid backup code or token`,
      invalidCode: `Invalid code`,
      invalidCodeOrToken: `Invalid code or token`,
      invalidDate: `Invalid date`,
      invalidData: `Invalid data`,
      invalidRegistrationData: `Registration data {0} invalid!`,
      invalidEmailOrPassword: `Invalid email or password!`,
      invalidPassword: `Invalid password`,
      invite: `Invite`,
      invitationAccepted: `Invitation accepted`,
      invitationDeclined: `Declined invitation`,
      invitationLimitManagersReached: `The invitation limit for managers has been reached.`,
      invitationProgramLimitReached: `The invitation limit for the {program} program has been reached.`,
      invitationNotFoundOrExpired: `Invitation not found or expired!`,
      invitationsAccepted: `Invitation accepted`,
      invitationsReceived: `Received Invitations!`,
      invitationRevoked: `Revoked invitation`,
      invitationSent: `Invitation sent`,
      invoiceValue: `Total of the invoice`,
      NdaCreated: `NdA created`,
      inProgress: `Underway`,
      inRelationToTheReport: `Regarding the report`,
      inSomeCasesTheEmailMayFallAsSpam: `In some cases, the e-mail may be considered spam.`,
      integration: `Integration`,
      integrations: `Integrations`,
      integrationsNotAvailable: `Integrations not available!`,
      inTheProgram: `In the program`,
      internal: `Internal`,
      invoices: `Billing`,
      iPAdress: `IP address`,
      issued: `Issued`,
      itHappensInTheBestFamilies: `It happens in the best families! Don't worry, just enter your email and we'll send you a new password.`,
      itHappensInTheBestFamiliesDonotworry: `It happens in the best families! Don't worry.`,
      itIsNotPossibleToEnterEqualRewards: `It's not possible to enter equal rewards!`,
      itIsNotPossibleToEnterMore: `It's not possible to insert more than 30 tags!`,
      itIsNotPossibleToSubmitAnotherRetest: `It was not possible to submit the retest evaluation! <br />Wait for the specialist's retest.`,
      iWantToCreateAnAccount: `I want to create an account!`,
      jobBoard: `Vacancies panel`,
      jobDescription: `##### About the Company\\nDescribe the details about your **company**\\n\\n##### About the Vacancy\\nWe are looking for a Professional whose main responsibilities will be:\\n- Responsibility 1. \\n- Responsibility 2. \\n- Responsibility 3. \\n\\n##### Requirements\\n- **Requirement 1: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Over x years of experience. \\n- **Requirement 2: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Over x years of experience. \\n- **Requirement 3: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Over x years of experience.`,
      jobTitle: `Vacancy title`,
      joinedThePlatform: `Joined the platform`,
      lastReviewSubmittedAgo: `Last review submitted {0} ago`,
      lastInvitations: `Last Invitations Sent`,
      last7daysOfAccess: `Last 7 days of access`,
      latestReports: `Latest reports`,
      letStartYourRegistrationAnd: `We will start your registration and soon we will contact you to answer any questions and finalize your registration!`,
      letsCompleteYourRegistration: `Let's complete your registration!`,
      letsCreateYourAccount: `Let's create your account!`,
      letsCreateYourPreRegistration: `Let's create your pre-registration!`,
      lessThanMonthAgo: `less than a month ago`,
      like: `Of the type`,
      limitScope: `Delimit the scope and only those accesses that will be rewarded!`,
      limitOutOfScope: `What applications should not be tested?`,
      limitOfScopesPerProgramReached: `Limit of {0} scopes per program reached!`,
      linkToJob: `Link to the vacancy`,
      location: `Locale`,
      longPeriodsImpactSpecialists: `Long waiting periods may impact the engagement of specialists in this program.`,
      low: `Low`,
      makePayment: `Make a Payment`,
      makeAPayment: `Make a Payment`,
      makeSureYouHaveACompatibleAppLike: `Make sure you have a compatible app like `,
      makeYourAccessEvenMoreSecure: `Make your access even more secure`,
      manageAccess: `Manage who has access to the program.`,
      managementInvitations: `Management of received invitations.`,
      manageVPNforUsers: `Manage the VPN of the users of each program`,
      manageYourPlanInformation: `Manage your plan information.`,
      manageYourProgressPlatform: `Manage your progress on the BugHunt platform`,
      maximumLengthIsCharacters: `Maximum length is {0} characters`,
      maximumFilesPerComment: `The maximum is 10 files per comment`,
      medianTimeToResolution: `Average time for resolution`,
      medianTimeToFirstResponse: `Average time until the first response`,
      medium: `Medium`,
      metricDoesNotHaveEnoughDataYet: `There is not enough data to calculate this metric`,
      metricsDoesNotHaveEnoughDataYet: `There is still not enough data to calculate the metrics`,
      message: `Message`,
      messagePostedAgo: `message posted {time} ago`,
      messagePublishedDay: `Message posted on {day}`,
      missedResponseTargetsReportsSent: `Responses sent over the expected time`,
      missedResponseTargetsResolved: `Resolution of reports above the expected time`,
      missedResponseTargetsBounty: `Payments made above the expected time`,
      monthlyFee: `Amount of monthly payment`,
      monthlyPayment: `Monthly fee`,
      moreOptions: `More options`,
      money: `Monies`,
      myPlan: `My Plan`,
      myBusiness: `My company`,
      nameChanged: `Name changed!`,
      nameOfAccountHolder: `Name of the person responsible for the account!`,
      nameIsNotValid: `The name is not valid`,
      navigation: `Sailing`,
      needChangeDescription: `Use the template to make a detailed description.`,
      ndaVerificationRequired: `Your profile is eligible to participate in the verification process!`,
      ndaChange: `Change of NDA`,
      next: `Nearby`,
      new: `Newfound`,
      newComment: `New comment`,
      newUsers: `New Users`,
      newPassword: `New Password`,
      newPasswordAndConfirmation: `New password and confirmation are not the same!`,
      newReport: `New report`,
      none: `None`,
      noActivePrograms: `No active program`,
      noInvitationAvailable: `No invitation available`,
      noNotificationsAvailable: `No notification available`,
      noPaymentsFound: `No payment found`,
      noProgramAvailable: `No program available`,
      noReportsFound: `No report found`,
      noScopeAvailable: `No scope available!`,
      noSuggestionsAvailable: `No suggestions available`,
      noteValue: `Value of the Note`,
      notAvailableForThisPlan: `Not available for this Plan!`,
      notAuthorized: `Unauthorized!`,
      shutdownRequested: `The closure of this report has already been requested!`,
      replyNotificationTitle: `Request for a response`,
      closingRequestTitle: `Closing request`,
      replyRequestMessage: `A response has already been requested for this report!`,
      notificationResponseReport: `Attention! A response was requested for this report.`,
      shutdownNotificationMessage: `Attention! A request has been made to close this report.`,
      notificationSeeRequest: `See request`,
      requestSent: `Request sent successfully!`,
      reportResponseNotification: `Attention! A response to this report was requested.`,
      notEligible: `Not eligible`,
      noExpertsFound: `No specialist found`,
      notificationUpdatedNDA: `The confidentiality agreement for the {programName} program has been updated! To continue participating in this program, you must review and accept the NDA.`,
      noUserAvailable: `No users available`,
      noVpnAccessLogFound: `No VPN access logs found!`,
      nowTellUsLittle: `Now tell us a bit about the program's politics!`,
      nowTellUsALittleBitAboutTheThreat: `Now tell us a bit about the threat!`,
      ofReward: `Of reward`,
      oneDayAgo: `A day ago`,
      oldPassword: `Old password`,
      outstandingPayments: `Pending payments`,
      open: `Opened`,
      opssMatiDidntApproveYourData: `Oops, Mati didn't approve your data.`,
      other: `Others`,
      others: `Others`,
      otherTypes: `Other types`,
      outOfScope: `Out of scope`,
      outOfScopeTitle: `Out of Scope`,
      participating: `Participating`,
      password: `Password`,
      passwordChanged: `Password changed!`,
      passwordConfirmation: `Confirmation of the New Password`,
      passwordsMustMatch: `Passwords must be the same`,
      passwordUpdateRequired: `Attention! Change your password to avoid blocking this account!`,
      remainingDaysToUpdateYourPassword: `days left to update your password.`,
      passwordExpiredNotificationTitle: `Attention! Your password has expired!`,
      passwordExpiredInstructions: `Your account will be temporarily blocked. Keep your password up to date and follow the instructions sent to the email associated with this account.`,
      enablePasswordExpiration: `Enable password expiration`,
      configSuccess: `Configuration successfully updated!`,
      expirePasswordConfig: `User passwords will be valid for`,
      passwordUpdateRequired: `Attention! Change your password to avoid blocking this account!`,
      remainingDaysToUpdateYourPassword: `days left to update your password.`,
      passwordExpiredNotificationTitle: `Attention! Your password has expired!`,
      passwordExpiredInstructions: `Your account will be temporarily blocked. Keep your password up to date and follow the instructions sent to the email associated with this account.`,
      enablePasswordExpiration: `Enable password expiration`,
      configSuccess: `Configuration successfully updated!`,
      expirePasswordConfig: `User passwords will be valid for`,
      pasteTheLinkIntoTheBodyOfTheDescription: `Paste the link into the body of the description.`,
      pause: `Pausing`,
      paused: `Paused`,
      pauseProgram: `Pause program?`,
      paymentFor: `Payment for`,
      paymentHistory: `Payment history`,
      paymentSummary: `Summary of payments`,
      paymentRequested: `Payment requested`,
      pending: `Pending`,
      pendingSubscription: `Pending Subscription`,
      permission: `Permission`,
      permissions: `Permits`,
      pleaseMakeSureThatThisEmail: `Please make sure that this email is correct and that it belongs to you.`,
      phoneNumber: `Telephone number`,
      phoneSuccessfullyRemoved: `Phone successfully removed!`,
      phoneValidation: `Phone validation`,
      platform: `Platform`,
      points: `Points`,
      pointsIn: `Points in`,
      possibleDup: `Possibly duplicate report - Scope {scope} has already received reports referring to {CWE}`,
      possibleSpam: `Possible SPAM - We verified that the expert {expert} sent several reports referring to {CWE} in the scope {scope}.`,
      postedComment: `Posted a comment `,
      postedImage: `Posted an image`,
      previous: `Prior`,
      primaryEmail: `main email`,
      primaryEmailReceiving: `Primary email for receiving information`,
      privacy: `Privacy`,
      privacyPolicy: `Privacy policy`,
      private: `Private`,
      privateProgram: `private program`,
      profileInformation: `Profile information`,
      profileVerifiedReleased: `Requested profile verification`,
      program: `Program`,
      programs: `Programs`,
      programDetails: `Program details`,
      program_management: `Program management`,
      programLifeCycle: `Program lifecycle`,
      programsLimitReached: `Program limit {0} reached!`,
      programsIhaveAlreadyContributed: `Programs that I have already contributed`,
      programPolicy: `Program policy`,
      programPolicyMustBeInformed: `Program policy must be reported`,
      programPolicyMustBeBetweenAndCharacters: `The program policy must be between {f} and {l} characters`,
      programRanking: `Program ranking`,
      programNdaMustBeBetweenAndCharacters: `NDA content must be between {f} and {l} characters long`,
      programsPublishedOnTheWeb: `Programs published on the web can be accessed by specialists not registered on the platform.`,
      programSuccessfullyChanged: `Program changed successfully`,
      programType: `Program type`,
      programWith: `Program with {0}`,
      proofOfConceptLinks: `Links to proof of concept are generally benign but can often be accompanied by unintended consequences.`,
      setProgramNda: `Do you want to add the confidentiality agreement to your new program?`,
      public: `Public`,
      publicInformation: `Public data`,
      publicOrPrivateProgram: `Public or private program`,
      publicProgram: `Public program`,
      publish: `Publish`,
      published: `Published`,
      publishedDaysAgo: `Published {0} ago`,
      publishProgramOnTheWeb: `Publish a program on the Web?`,
      publishToTheWeb: `Publish on the Web `,
      questionsAboutUrl: `Questions about {0}`,
      rankingDoesNotHaveEnoughDataYet: `The Ranking does not have enough data yet`,
      rankingPosition: `{0}° in the Ranking`,
      received: `Welcomed`,
      receiveAdvertising: `Receive advertising emails`,
      receiveEmails: `Receiving E-Mails`,
      receiveAdvertisingEmails: `Receive advertising emails`,
      receiveNotificationsAboutNewReports: `Receive notifications about new reports directly on your management platforms`,
      referenceDate: `Reference date`,
      refuseRetest: `Refuse retest`,
      refusedRetest: `Refused the retest`,
      registerBelowTheTags: `Tag management`,
      registeredUsers: `Registered users`,
      registeredVacancies: `Vacancies`,
      registration: `Cadastre`,
      removeAccount: `Remove Account`,
      remove: `Remove`,
      removeFromWhitelist: `Remove from Whitelist`,
      removeFromBlacklist: `Remove from Blacklist`,
      removed: `Removed`,
      reportAllPossibleThreatData: `Provide all possible threat data`,
      report: `Reportage`,
      reportID: `Report ID`,
      reportCreatedSuccessfully: `Report created successfully`,
      reportEvaluation: `Evaluation of the report`,
      reportPayments: `Report payments`,
      reports: `Reports`,
      reportSent: `Report sent`,
      reportsSent: `Submitted reports`,
      reportTitle: `Report title`,
      reportedThatTheVulnerabilityIsFixed: `You reported that the vulnerability is corrected`,
      reportedThatTheVulnerabilityIsNotPatched: `You reported that the vulnerability is not fixed`,
      reportedVulnerabilities: `Reported vulnerabilities`,
      vulnerabilities: `Vulnerabilities`,
      overviewSubTitle: `A managerial view of your account just for you`,
      summaryCard: `Summary of the reports`,
      requestedPayment: `Requested a payment`,
      requestedPaymentOf: `Requested payment of`,
      requestedANewTestOfTheReport: `requested a new test of the report`,
      reset: `Wipe`,
      rewardValue: `Amount of the reward`,
      whatIsAnNda: `What is an NDA?`,
      whatIsAnNda2: `NdA is an acronym in English for Non-Disclosure-Agreements, or simply information confidentiality agreement.`,
      whatIsAnNda3: `It intends to protect industrial or commercial secrets, or even any information that cannot be disclosed and must be kept confidential among those who have access to it.`,
      whatIsaVPNAndHow: `What is a VPN and how can it help your programs?`,
      reportTags: `Add tag(s) to the report`,
      requestNewPassword: `Request a new password!`,
      requestRetest: `Request Reteste`,
      requestSubscription: `Request Subscription`,
      requiredField: `Required field`,
      retestRequested: `Requested retest`,
      requestedRetestPayment: `Requested payment for the retest`,
      retestId: `Retest ID`,
      retestSent: `Retest sent`,
      return: `Go back`,
      resolved: `Resolved`,
      revoke: `Revoke`,
      revokeWebAccessToTheProgram: `Revoke web access to the program?`,
      revoked: `Revoked`,
      revokeAccess: `Revoke Access`,
      rewardAmount: `Reward amount`,
      reward: `Reward`,
      rewardDetails: `Reward details`,
      rewards: `Rewards`,
      rewardsReceived: `Rewards Received`,
      rewardsWithFinancialValues: `Rewards with financial amounts`,
      save: `Save`,
      saveEditions: `Save changes`,
      saveNda: `Save confidentiality agreement`,
      saveInformation: `Save`,
      scopePerProgram: `Scope by program`,
      scopesPerProgram: `Scopes by program`,
      search: `Search`,
      seconds: `secs`,
      select: `Select`,
      selectAddAccount: `Select “Add account” or “+” and scan the QR code below`,
      selectAScoreForTheReport: `Select a score for the report`,
      selectFile: `Select the file!`,
      selectProgram: `Select a program`,
      selectLanguage: `Select a language`,
      selectScopeType: `Select scope type`,
      selectTheThreat: `Select the threat!`,
      selectTheProgramScope: `Select the scope of the program!`,
      selectTheProgramImpact: `Select the impact of the program!`,
      selectTheReport: `Select the report`,
      selectTheScope: `Select the scope`,
      selectTheCWE: `Select the CWE`,
      selectTheVulnerability: `Select the vulnerability`,
      securityAnalyst: `Ex. Security Analyst`,
      send: `Submit`,
      sentTheRetest: `Sent the retest`,
      sendMessage: `Send Message`,
      sent: `Mailed`,
      sentTo: `Uploaded`,
      sentTheReport: `Sent the report`,
      settings: `Settings`,
      severityReports: `Reports by severity`,
      severity: `Severity`,
      currentValue: `Current value`,
      finalValue: `Final value`,
      showingResultsOfTotal: `Showing {results} of {TotalResults} results.`,
      since: `Since {0}`,
      sinceLastMonth: `Since last month`,
      situation: `Situation`,
      scope: `Scoping`,
      scopeLimitExceeded: `The program scope limit has been exceeded.`,
      scopeListOfTheProgram: `Program scope list!`,
      score: `Scoring`,
      scoreHistory: `Scoring history`,
      scopeType: `Scope type`,
      share: `Share`,
      smsCode: `SMS code`,
      smsCodeSent: `SMS code sent`,
      specialist: `Specialist`,
      specialistNotFound: `Specialist not found!`,
      standard: `Standard`,
      standoutCreate: `Stand out! Create a motivating headline.`,
      start: `Start`,
      pauseMessage: `It was not possible to execute the action, since the campaign has not yet started.`,
      startAnAccountForOrganization: `Create an account for organization`,
      startWithRewards: `Start with the rewards that have financial value`,
      statistics: `Stats`,
      stateCity: `Status`,
      status: `Status`,
      statusChanged: `Changed status!`,
      storeYourBackupCodes: `Store your backup codes`,
      subdomain: `Subdomain`,
      submittedDays: `Shipped {0} days ago`,
      submitComment: `Send Comment`,
      submitForReview: `Send for Analysis`,
      rewardNotice: `Reminder: This program offers double rewards`,
      submitReport: `Submit Report`,
      submit_retest: `Submit retest`,
      successfullyGeneratedKeys: `Keys successfully generated!`,
      suggestions: `Suggestions`,
      suggestedReward: `Suggested reward`,
      summary: `Summary`,
      superSimpleItDoesntEvenTake: `It's simple, it doesn't take even a minute. Just enter the details below and that's it! Your account has been created.`,
      superSimpleItDoesntEvenTakeCompany: `It's simple, it doesn't take even a minute. Just enter the organization's common data and that's it! Your account will be submitted for review.`,
      support: `Strut`,
      sureAddExpertBlacklist: `Are you sure you want to add this expert to the blacklist?`,
      sureAddExpertWhiteList: `Are you sure you want to add this expert to Whitelist?`,
      sureRemoveExpertBlacklist: `Are you sure you want to remove this expert from the Blacklist?`,
      sureRemoveExpertWhitelist: `Are you sure you want to remove this expert from Whitelist?`,
      successfullyCreatedProgram: `Program created successfully`,
      successfullyCreated: `created successfully`,
      acceptedNda: `NdA successfully accepted!`,
      openReports: `Open reports`,
      openYourApp: `Open your app.`,
      or: `or`,
      organizationName: `Name of the organization`,
      overallRanking: `Overall ranking`,
      paidRetest: `If the <b>retest is approved</b>, you will receive <b>{0}</b> more than the bounty amount.`,
      tagsAreUsedToHelpIdentifyReports: `Tags are used to assist in identifying reports.`,
      tagsForReports: `Tags for reports`,
      takeAction: `Perform Action`,
      takeTheOpportunityToAcquireMoreComplete: `Take the opportunity to purchase more complete plans for your company`,
      talkDirectlyToOurOperators: `Speak directly with our operators.`,
      target: `Expected time: {0}`,
      telephone: `Telephone`,
      testDescriptionsMustBetweenCharacters: `The description of the tests must be between {f} and {l} characters`,
      tests: `Tests`,
      terms: `Terms`,
      termsAPolicy: `Terms and Policy`,
      termsOfUse: `Terms of Use`,
      thanksForRegistering: `Thank you for registering!`,
      thankByEmail: `Thank you by e-mail`,
      theActionsTakenOnTheReportCannotBe: `Actions taken in the report cannot be removed`,
      theCommentNeedsToBeInformed: `The comment needs to be reported!`,
      theDescriptionTestsMustBeInformed: `The description of the tests must be entered`,
      theDescriptionOfTheProgramMustBeInformed: `The description of the program must be entered`,
      theImpactDescriptionMustBeInformed: `The description of the impact must be entered`,
      theImpactDescriptionMustBetweenCharacters: `The impact description must be between {f} and {l} characters`,
      theIsNotValid: `{0} is not valid`,
      theFileIsNotValid: `The file is not valid!`,
      theNameMustBeFromToCharacters: `The name must have {f} to {l} characters`,
      theNameOfThePersonResponsibleIsMandatory: `The name of the responsible person is required.`,
      theNameOfTheProgramMustBInformed: `The name of the program must be entered`,
      theNameWillBeAssignedToYourProgramsURL: `The name will be assigned to the URL of your program.`,
      thenUseYourEmail: `Then use your email, your password and access our platform. If you've forgotten your password or username, use the recovery option below!`,
      thePhoneIsNotValid: `The phone is not valid.`,
      theProgramDescriptionMustBeBetweenAndCharacters: `The program description must be between {f} and {l} characters long!`,
      theProgramNameMustBeBetweenAndCharacters: `The program name must be between {f} and {l} characters`,
      thereIsAlreadyAprogram: `There is already a registered program with that name!`,
      thereIsAlreadyProgramSlug: `There is already a registered program with this slug!`,
      theReportNeedsToBeInformed: `The report needs to be reported`,
      theRetestMustBeSentWithinDays: `The retest must be sent within {0} days`,
      theRetestWasNotSubmitted: `The retest was not submitted!`,
      theRetestHaAlreadyAccepted: `The retest has already been accepted!`,
      theseSettingsDirectlyImpactTheAccessOfExperts: `These settings have a direct impact on expert access.`,
      theScopeAddressMustBeInformed: `The scope address must be entered`,
      theThreatDescriptionMustBeInformed: `The threat description must be reported!`,
      theThreatDescriptionMustBetweenCharacters: `The threat description must be between {f} and {l} characters`,
      theTitleMustBeInformed: `The title must be entered`,
      theTitleMustBeBetweenCharacters: `The title must be between {f} and {l} characters`,
      theWebhookIsNotValid: `The webhook is not valid!`,
      theWebsiteMustBeFromToCharacters: `The website must have {f} to {l} characters`,
      thisChangeIsIrreversible: `This change is irreversible.`,
      thisInformationCanAppear: `This information may appear on the company's public profile, next to your comments and in any of your reports.`,
      thisIsAnInternalSurvey: `This is an internal survey, experts will not have access to the data from this questionnaire.`,
      thisServiceCreatesAVPNResponsible: `This service creates a VPN, responsible for connecting and monitoring the data traffic from the specialist's tests to their scopes, and thus greater traceability and security.`,
      thisWeek: `This week`,
      threats: `Threats`,
      target: `Expected time: {0}`,
      time: `Time`,
      timeToFirstResponse: `The first answer`,
      timeToBounty: `Pay the reward`,
      timeToResolution: `Close the report`,
      title: `Title`,
      to: `towards`,
      toAcceptThisInvitation: `To accept this invitation it is necessary to check the Meta <b>Map</b>, after verification, wait a few minutes and refresh the page.`,
      tokenIsInvalid: `The token is invalid or has already been used`,
      toAddMorePrograms: `To add more programs check out our plans by clicking`,
      toAddMoreScopesToThe: `To add more scopes to the program check out our plans by clicking`,
      toAddMoreUsersCheck: `To add more users, check out our plans by clicking`,
      toAddTheseIntegrations: `To add these integrations check out our plans by clicking`,
      toAddThisFeatureCheck: `To add this feature, check out our plans by clicking`,
      toChangeYourPlanContactSupport: `To change your plan, contact support.`,
      toCheck: `Verify`,
      toConfirmWeNeedYourPassword: `To confirm we need your password`,
      toConfirmYourRegistrationOn: `To confirm your registration on our platform it is necessary to click on the button below.`,
      today: `Todays`,
      toDoThisYouNeedToEnterYourAppCode: `To do this you must enter the code of your application or paste one of your backup tokens!`,
      topReportedCWE: `Most reported CWe`,
      totalConnectedHours: `Total connected hours`,
      totalEvents: `Total events`,
      totalMonthlyFees: `Total monthly fees`,
      totalReports: `Total reports`,
      totalReceived: `Total Received`,
      totalRewards: `Total rewards`,
      toTheProgram: `To the program`,
      totalSpent: `Total Payment`,
      totalSum: `Total sum`,
      trackYourOpenReports: `Follow your open reports`,
      twoFactorAuthentication: `Two-factor authentication`,
      type: `Type`,
      typeOfContract: `Type of contract`,
      typeOrPasteOneOfYourBackupTokens: `Type or paste one of your backup tokens, remembering that each token can only be used once!`,
      typeProgramLimitExceeded: `The limit of programs of type {ProgramType} has been exceeded`,
      unableToCompleteThisRequest: `We were unable to complete this request.`,
      unableToSubmittedTheReport: `It was not possible to submit this report. Make sure that all fields are filled out correctly.`,
      undefinedRanking: `Indefinite ranking`,
      uninformed: `Not informed`,
      unshowPassword: `Hide password`,
      update: `Upgrade`,
      updates: `Updates ({numberOfUpdates})`,
      updated: `Upgraded`,
      uploadFiles: `Send files`,
      upTo: `Unto`,
      urlIsNotValid: `The URL is not valid`,
      useBackupCode: `Use backup code?`,
      user: `User`,
      userBlockedForOverTrying: `User blocked due to excessive attempts, please try again later.`,
      userByCompany: `User by company`,
      userDisconnected: `User disconnected!`,
      userLimitReached: `User limit reached!`,
      userLoggedIn: `Logged in user!`,
      usersByCompany: `Users by company`,
      userDoesNotHavPermissionToPerform: `User is not allowed to perform this action`,
      usernameHasInvalidCharacters: `The username has invalid characters`,
      usernameIsNotAvailable: `Username is not available!`,
      usernameMustBeFromCharacters: `The username must be {f} to {l} characters long.`,
      users: `Users`,
      userEmail: `Username or email`,
      usersOnTheBlacklist: `Users on the Blacklist will not have access to this program!`,
      userRemoved: `Removed user`,
      useYourAuthenticationAppToEnterTheCode: `Use your authentication app to enter the code`,
      validatePhone: `Validate phone`,
      validatedPhone: `Validated phone`,
      value: `Worthiness`,
      verified: `Verified`,
      verifieds: `Verified`,
      vpnIP: `VPN IP`,
      waitingConfirmation: `Waiting for confirmation`,
      wantSaveChangesProgram: `Do you really want to save the changes made to this program?`,
      waysExplore: `Ways to Explore`,
      weLeaveThisPanel: `We leave this panel for you to publish your vacancies to our specialists`,
      whatIsBugBounty: `What is Bug Bounty`,
      whatIsYourAction: `What is your action?`,
      whatIsNdaHeader: `Stay tuned!`,
      whatPrograms: `What programs?`,
      whatTypeOfVulnerability: `What type of vulnerability is reported`,
      whoDoYouWantInvite: `Who do you want to invite?`,
      whiteMessage: `Write a message...`,
      weakPasswordContain: `Weak password! She must tell`,
      websiteInvitation: `Site invitation`,
      weSendAToast: `We send a toast`,
      weAreUnderMaintenance: `We are under maintenance! Come back soon!`,
      weTemporarilyStoreYourReport: `We temporarily store the data from your report for the program`,
      weWillContactYouShortly: `We will contact you shortly to confirm your details.`,
      wikiSubTitle: `We help how we can and how we can't.`,
      withoutWebAccessTheProgram: `Without web access the program will be available only to platform users.`,
      workModel: `Work model`,
      workSchedule: `Working hours`,
      yesIWantToRegister: `Yes, I want to register`,
      yes: `Yes`,
      no: `Not`,
      youAcceptedThisInvitation: `Did you accept this invitation`,
      youAreAboutToVisitLink: `You are about to visit an external link.`,
      youAreAllowedToViewTheReports: `You are allowed to view the reports.`,
      youCanUseOneOfTheseBackupCodes: `You can use one of these backup codes to log in if you lose access to your smartphone. Remember that each code can only be used once.`,
      yourCurrentPlanIsThe: `Your current plan is`,
      youDoNotHaveAnyTagRegistered: `<a href=\"/account?tags\">you don't have any registered Tags, to add them go to the My Account/Tags menu</a>`,
      youDontHave: `You don't have`,
      youDontHaveAnyAcceptedInvitations: `There are no accepted invitations yet!`,
      youDontHaveAnyInvitationsWaiting: `There are no invitations waiting for answers yet!`,
      youDontHaveAnyNDAs: `You don't have a program with a confidentiality agreement yet!`,
      youDontHaveAnyNDAsHacker: `You haven't agreed to any confidentiality agreement yet!`,
      youDontHaveAnyProgramsInThisCategoryYet: `You don't have any programs in this category yet`,
      youDontHaveSubmittedReports: `There are no approved reports yet!`,
      youHave: `You have`,
      youHaveBeenInvitedToSend: `You were invited to submit reports to this program`,
      youHavePermissionToViewAndEditReports: `You have permission to view and edit the reports.`,
      youMustAgreeToThe: `You need to agree with the`,
      youMustAgreeToTheTermsOfUse: `You need to agree to the term of use.`,
      youMustAgreeToTheTermsOfUseAndCodeOfConduct: `You need to agree to the term of use and code of conduct.`,
      yourAccessPassword: `Your access password!`,
      yourAccesEmail: `Your email address for accessing {0}`,
      youReachedLimit: `You have reached the daily reporting limit!`,
      yourEmail: `Your email`,
      yourFullName: `Your full name!`,
      yourNameMustBeBetweenAndCharacters: `Your name must be between {f} and {l} characters long!`,
      yourOrganizationNameIsRequired: `The name of your organization is required`,
      YourOrganizationTradeName: `Fancy name of your organization!`,
      yourPassword: `Your password`,
      yourPhoneToGetInTouch: `Call us so we can get in touch!`,
      yourProfileIsNowAbleTo: `Your profile is eligible to participate in the verification process!`,
      ndaVerificationRequired1: `You were invited to participate in the program `,
      ndaVerificationRequired2: `Verification of your profile is required to accept this invitation!`,
      ndaVerificationRequired3: `Check your notification list and proceed with the verification process.`,
      noJobsFound: `No vacancies found`,
      registrationDone: `Registration completed!`,
      reportPaymentVerificationRequired1: `The payment of a reward for the report `,
      reportPaymentVerificationRequired2: `it was requested!`,
      reportSummaryNotValid: `The summary of the report is not valid!`,
      reportContentIsNotValid: `The content of the report is not valid!`,
      reportVulnerabilitIsNotValid: `The impact of the vulnerability is not valid!`,
      reportCriticalityIsNotValid: `The critical nature of the vulnerability is not valid`,
      reportCantAcceptEspecialCaracter: `(You can't enter special characters.)`,
      reportScopeIsNotValid: `The report scope identifier is not valid!`,
      reportIdentifierIsNotValid: `The program identifier is not valid!`,
      reportVulnerabilityIdentifierIsNotValid: `The vulnerability identifier is not valid!`,
      ndaVerificationRequired6: `Complete the validation of your profile so that we can proceed with the payment of the reward!`,
      reportTitleIsNotValid: `The report title is not valid!`,
      showPassword: `Show password`,
      companyNdaVerificationRequired: `You need to create an NDA for your program before inviting specialists!`,
      taxesNotIncluded: `Tributes not included`,
      youAcceptedParticipateInThisProgram: `You have agreed to participate in this program.`,
      youCanCalculate: `You can calculate the severity using the calculator below`,
      youShouldConsiderUsingSeparate: `You should consider using a separate browser or virtual machine before continuing.`,
      yourSecurityPlatformAndBugReward: `Your Bug Bounty platform`,
      youWereInvitedPartOf: `You were invited to join the {0} team, just enter your account details.`,
      youWillBeRedirectedIn: `You will be redirected to`,
      youWillReceiveReportsFromCommunity: `You will receive reports from security experts in our community, at no additional cost, minimizing the risks of your data being exposed or vulnerabilities exploited.`,
      invitationsSummary: `Summary of invitations`,
      doubleReward: `Double reward`,
      boostedProgram: `Boosted program!`,
      doubleCampaignNotificationStarted: `Bonus campaign started`,
      doubleCampaignNotificationClosed: `Bonus campaign closed`,
      doubleCampaignNotificationPaused: `Paused bonus campaign`,
      doubleCampaignNotificationResumed: `Bonus campaign resumed`,
      campSubTitle: `Manage your campaigns! Keep track of all the details.`,
      historicCampaign: `History`,
      historicDoubleBounty: `Double Bounty`,
      historicDoubleScore: `Double score`,
      inText: `From`,
      until: `Unto`,
      finished: `Finalized`,
      in_progress: `Ongoing`,
      situationCancel: `Cancelled`,
      createdTh: `Created in`,
      periodTh: `Timeframes`,
      rewardsTh: `Rewards`,
      situationsTh: `Situations`,
      historicApproved: `Approved`,
      historicCancel: `Cancelled`,
      historicPaused: `Paused`,
      historicFinished: `Completed`,
      notificationAttention: `Attention!`,
      notificationYourCampaignHasStarted: `Your campaign has started!`,
      notificationThisCampaign: `This campaign`,
      notificationHasClosed: `It was closed`,
      notificationHasBeenPaused: `Was it paused`,
      keepAnEyeOutNotification: `Keep an eye out`,
      notificationWillLetYouKnowWhenToStartAgain: `we'll let you know when it starts again.`,
      notificationThisCampaignIsLiveAgain: `This campaign is on the air again!`,
      finalDate: `End`,
      remain: `Remain`,
      campaignStarted: `The double rewards campaign has started!`,
      campaignClosed: `The double rewards campaign has ended!`,
      campaignPause: `The double rewards campaign has been paused!`,
      campaignReactivated: `The double rewards campaign has been reactivated!`,
      campaignFinalDays: `For the end of the campaign`,
      campaignInitialDays: `For the start of the campaign`,
      dayCampaign: `daytime`,
      daysCampaign: `days`,
      daysGeneric: `day (s)`,
      btnRegister: `Register`,
      btnCancel: `Cancel`,
      btnLabel: `Select the date`,
      doubleBounties: `Double Bounties`,
      doubleScore: `Double score`,
      activeDoubleCampaign: `Boost program`,
      selectAPeriod: `Select a period:`,
      monthlyRanking: `Monthly ranking`,
      generalRanking: `Overall ranking`,
      expertRating: `Check out the BugHunt expert ranking`,
      bountyOffer: `You're offering: Double Bounties`,
      bountyScore: `You're offering: Double score`,
      bountyAndScoreOffer: `you're offering: Bouties and Double Scoring`,
      closeCampaign: `Close Bonus Campaign`,
      pauseCampaign: `Pause Bonus Campaign`,
      reactivateCampaign: `Reactivate Bonus Campaign`,
      boostCampaign: `Boost program`,
      doubleCheckCampaign: `I am aware of the changes in the current value of the rewards.`,
      successfullyCreatedCampaign: `Request made successfully, please wait for the approval of the campaign!`,
      vpnMessage: `There is no VPN enabled in this program.`,
      campaignPaused: `Campaign successfully paused!`,
      doubleCampaignClosed: `Campaign successfully closed!`,
      doubleCampaignResumed: `Campaign resumed successfully!`,
      registeredProgramWarning: `This program already has a campaign approved or closed less than 15 days ago.`,
      warningBoutiesOrScore: `The campaign must offer bounties or double scores!`,
      invalidDateMessage: `Invalid date, please check that the field has been filled in correctly!`,
      v_administrator: `administrator`,
      v_viewer: `viewer`,
      v_analyst: `Analyst`,
      administrator: `Administrator`,
      viewer: `Viewer`,
      analyst: `Analyst`,
      v_private: `privates`,
      v_public: `Public`,
      v_internal: `internal`,
      v_new: `newfound`,
      v_under_review: `under review`,
      v_triaged: `Triaged`,
      v_needs_information: `Do you need information`,
      v_approved: `approved`,
      v_informative: `informative`,
      v_duplicated: `duplicated`,
      v_not_applicable: `Not applicable`,
      v_spam: `spam`,
      v_accepted: `Accepted`,
      v_pending: `Pendants`,
      v_declined: `Refused`,
      v_revoked: `Revoked`,
      v_pending_retest: `Retest`,
      v_retest_done: `Retest completed`,
      retest_done: `Retest completed`,
      pending_retest: `Reteste Pending`,
      notImpact: `Severity not reported`,
      lowImpact: `Low severity`,
      mediumImpact: `Average severity`,
      highImpact: `High severity`,
      criticalImpact: `Critical severity`,
      approved: `Approved`,
      informative: `Informative`,
      duplicated: `Duplicated`,
      not_applicable: `Not applicable`,
      spam: `Spam`,
      comment: `Post a comment`,
      change_situation: `Change situation`,
      update_severity: `Change severity`,
      request_update: `Request update`,
      retest: `Request retest`,
      pay_bounty: `Pay a reward`,
      close_report: `Close the report`,
      reopen_report: `Reopen the report`,
      needs_information: `Waiting for information`,
      under_review: `Under review`,
      triaged: `Triado`,
      plan_trial: `Trial plan`,
      plan_bronze: `Bronze plan`,
      plan_silver: `Silver plan`,
      plan_gold: `Gold plan`,
      trial: `Trial`,
      bronze: `Bronze`,
      silver: `Silver`,
      gold: `Gold`,
      fulltime: `Full-time`,
      parttime: `Part-time`,
      clt: `CLt`,
      pj: `PJ`,
      autonomous: `Standalone`,
      cltflex: `CLT-Flex`,
      cooperative: `Cooperative`,
      internship: `Stage`,
      hybrid: `Hybrid`,
      office: `In person`,
      remote: `Remote`,
      web: `Web application`,
      api: `API`,
      mobileapplication: `Mobile app`,
      mobileapplicationandroid: `Android Mobile app`,
      mobileapplicationios: `IOS Mobile app`,
      ip: `IP address`,
      january: `January`,
      february: `February`,
      march: `March`,
      april: `April`,
      may: `May`,
      june: `June`,
      july: `July`,
      august: `August`,
      september: `September`,
      october: `October`,
      november: `November`,
      december: `December`,
      seeOriginalText: `Original text.`,
      waiting_for_information: `Waiting for information`,
      severity_updated: `Severity updated`,
      retest_requested: `Request for a test`,
      bounty_paid: `Paid reward`,
      close_as_approved: `Close as approved`,
      close_as_informative: `Close as informational`,
      close_as_spam: `Close as spam`,
      close_as_duplicated: `Close as duplicate`,
      close_as_not_applicable: `Close as not applicable`,
      select_option: `Select an option`,
      deleteMessageAlert: `Are you sure you want to delete this message?`,
      automaticMessage: `When selecting the option, the automatic response will be recorded as a first interaction in the report.`,
      defaultMessageCenterMenu: `Standard Message Center`,
      registerNotFound: `No record was found.`,
      registeredMessageTitle: `Registered messages`,
      customSettingsTitle: `Custom settings`,
      customSettingsSubtitle: `Configuring messages for standardized responses`,
      addMessageButton: `Add message`,
      existingMessageAlert: `It is possible to register only one message per message type. Currently, all messages are already registered!`,
      editMessage: `Edit Message`,
      registerMessage: `Register Message`,
      placeholderTitleMessage: `Message title`,
      placeholderTextAreaMessage: `Add a description...`,
      labelAutomatic: `Automatic`,
      alertMessageSuccess: `Message registered successfully!`,
      alertMessageUpdate: `Message updated successfully!`,
      swalTokenRemoved: `The token was successfully deleted.`,
      deleteTokenCompany: `Delete token`,
      placeholderTokenCompany: `Type a token`,
      errorToken: `The token must contain a minimum of 20 characters and a maximum of 500 characters!`,
      emailNotification: `The email notification has been successfully activated!`,
      enableEmailNotification: `Enable the receipt of program updates via an email address.`,
      emailNotificationDisabled: `The notification sent by e-mail has been deactivated!`,
      china: `China`,
      india: `India`,
      estadosUnidos: `United States`,
      indonesia: `Indonesia`,
      paquistao: `Pakistan`,
      brasil: `Brazil`,
      nigeria: `Nigeria`,
      bangladesh: `Bangladesh`,
      russia: `Russia`,
      mexico: `Mexico`,
      japao: `Japan`,
      etiopia: `Ethiopia`,
      filipinas: `Philippines`,
      egito: `Egypt`,
      vietna: `Vietnam`,
      repuplicaDemocraticaDoCongo: `Democratic Republic of the Congo`,
      turquia: `Turkey`,
      ira: `Iran`,
      alemanha: `Germany`,
      tailandia: `Thailand`,
      reinoUnido: `United Kingdom`,
      franca: `France`,
      italia: `Italy`,
      tanzania: `Tanzania`,
      africaDoSul: `South Africa`,
      mianmar: `Myanmar (Burma)`,
      coreiaDoSul: `South Korea`,
      colombia: `Colombia`,
      quenia: `Kenya`,
      espanha: `Spain`,
      ucrania: `Ukraine`,
      uganda: `Uganda`,
      sudao: `Sudan`,
      angertina: `Argentinean`,
      angelia: `Algeria`,
      iraque: `Iraq`,
      polonia: `Poland`,
      canada: `Canada`,
      uzbequistao: `Uzbekistan`,
      arabiaSaudita: `Saudi Arabia`,
      br: `Portuguese`,
      en: `Englishman`,
      es: `Espanol`,
      fr: `Frenchman`,
      it: `Italiano`,
      ru: `Russian`,
      de: `Deutsch`,
      jp: `Japanese`,
      cn: `Chinese`,
      pl: `Polish`,
      ua: `Ukrainian`,
      sd: `Arabic`,
      kr: `Korean`,
      in: `Hindi`,
      id: `Indonesian`,
      pk: `Urdu`,
      bd: `Bengali`,
      et: `Amharic`,
      ph: `Filipino (Tagalog)`,
      vn: `Vietnamese`,
      tr: `Turkish`,
      ir: `Persian`,
      th: `Thai`,
      za: `Afrikaans`,
      mm: `Burmese`,
      ug: `Swahili`,
      uz: `Uzbek`,
      sa: `Arabic`,
      additionalMoreLanguages: `Add more language`,
      country: `Country`,
      language: `Language`,
      clearText: `Use the standard message`,
      selectCountry: `Select a country`,
      basic: `Basic`,
      proficiency: `Proficiency`,
      conversational: `Conversational`,
      fluent: `Fluent`,
      native: `Native or bilingual`,
      AreYouSureYouWantToCompleteTheRequest: `Are you sure you want to complete this request?`,
      managers: `Managers`,
      manageProgram: `Define who will manage your new program.`,
      config: `Settings`,
      programSettings: `Program settings`,
      programEditAlert: `Attention! You can't edit programs that are inactive or waiting for approval.`,
      changeSettings: `Change settings`,
      managersWithAccesToTheProgram: `Managers with access to the program`,
      freeAccess: `Access released`,
      pendingInviteAlert: `Attention! There is already a pending invitation associated with this email address.`,
      USDT: `Dollar`,
      BRL: `Real`,
      selectCurrencyType: `Select the type of currency`,
      passwordSuccess: `Successfully registered password!`,
      isNan: `The value entered must be numeric.`,
      filterScope: `Filter by scope`,
      selectScope: `Select a scope option`,
      filterScopeTitle: `Filter by scope`,
      scopeSelected: `Selected scope`,
      summaryFinancialCard: `Financial summary`,
      summaryTotalCard: `Total contributions`,
      summaryTotalPgCard: `Total payment`,
      projectedValueLabel: `Number of months to be projected`,
      totalMonthlyPayments: `Total monthly fees`,
      totalManagedServices: `Total managed services`,
      totalRewardsPaid: `Total rewards paid`,
      monthAndyear: `Month/year`,
      contribution: `Contribution`,
      managed: `Managed`,
      costProjection: `Cost projection`,
      contributionBalance: `Contribution balance`,
      detailsNF: `NF details`,
      total: `Total`,
      expenseNotification: `Stay in control! Set up notifications for when you reach \"70%\" of your spending budget.`,
      errorValueBudget: `Enter the budget limit`,
      errorBudgetNotification: `Enter the desired percentage`,
      labelInvalidValue: `Invalid value. Please enter a value between 0 and 100`,
      labelCurrencyValue: `Invalid value: It is not possible to register negative values.`,
      titleBudgetActive: `Limit monthly reward costs`,
      budgetLimitProgram: `The budget limit for this program is`,
      errorBudgetLimit: `Enter the budget limit`,
      invalidValueBudget: `Invalid value: It is not possible to register negative values.`,
      notificationBudget: `Notify when you reach the amount of`,
      percentageBudget: `Enter the desired percentage`,
      percentageErrorBudget: `Invalid value. Please enter a value between 0 and 100`,
      pauseProgramBudget: `Pause the program before reaching the total budget?`,
      percentagePauseBudget: `Pause percentage (0-99%)`,
      createCredentialTooltip: `Define credential`,
      confirmBtn: `Confirm`,
      swalCredential: `Credential saved successfully.`,
      labelCredentialForTest: `The credentials to test the system and the scope of the program`,
      labelCredentialForTestContinued: `are listed below`,
      labelCredentialIndividual: `Individual use. Don't share to ensure your safety.`,
      labelCredentialShared: `Shared use. All experts have the same access.`,
      credentials: `Credentials`,
      confirmPassword: `Confirm Password`,
      confirmPasswordToViewCredential: `Confirm your password to access the platform to view the `,
      confirmPasswordToViewCredentialContinued: `available credentials`,
      hello: `Hello`,
      doYouHaveCredentials: `You have credentials to use in the systems and scopes that will be tested`,
      manageYourCredentials: `Manage your registered generic credentials to facilitate access for specialists who will perform tests on your systems`,
      manageYourCredentialsTooltip: `Manage your credentials`,
      credentialPublica: `Generic Credential`,
      credentialPrivate: `Exclusive Credential`,
      credentialPublicaDescription: `The registered generic credentials will be sent to all experts participating in the program, with the aim of being used to carry out security tests.`,
      credentialSentToSpecialist: `The unique registered credentials will only be sent to the destination specialist`,
      credentialSentToSpecialistContinued: `with the purpose of being used to carry out safety tests.`,
      request_review: `Request screening review`,
      request_review_report: `You requested a review of the screening`,
      reviewRequestedNotification: `Review request`,
      availableCredential: `Credential available`,
      allActionsAllowed: `Is allowed to manage all programs and users.`,
      owner: `Owner`,
      AreYouSureYouWantToUpdateTheUserRole: `Do you want to apply the changes to this user's permissions?`,
      v_owner: `Owner`,
      manageCredentials: `Manage registered credentials.`,
      setPublicCredential: `Manage your public credentials`,
      programSpellers: `Program specialists`,
      viewCredentials: `View Credentials`,
      informPassword: `Enter your password`,
      credentialDeleted: `Credential deleted successfully!`,
      genericError: `Something went wrong. We are resolving this now. Please try again later.`,
      delete: `Delete`,
      toClose: `Close`,
      labelDeleteCredential: `Are you sure you want to delete this credential?`,
      credentialsTooltip: `Available Credentials`,
      setPasswordExpiration: `Set password expiration`,
      authenticationViaEmail: `Enable email authentication`,
      accessValidation: `Access validation`,
      invalidCodeError: `The code entered is not valid!`,
      confirmPasswordLabel: `Confirm your platform access password to complete the desired action.`,
      emailAuthenticationInformation: `Increase the security of all accounts by enabling email authentication, protecting user information from unauthorized access.`,
      alertTwoFactory: `<div class="container-two-factory"><p class="two-factory-descrition">To send a report in this program, you need to enable two-factor authentication. Your security is our priority and this extra layer of protection is essential to ensure the integrity of your account. <span>Follow the setup steps to enable 2-factor authentication now.</span></p></div>`,
      twoFactoryNewUsersContinuation: `will be able to interact with the reports.`,
      restriction: `Restriction`,
      warningTwoFactorAuthentication: `Attention! 2-factor authentication setup required.`,
      labelFeatureTwoFactorAuthentication: `Only managers with Two-factor Authentication can interact with program reports.`,
      labelFeatureTwoFactorAuthenticationHacker: `Only experts with Two-Factor Authentication can submit new reports to the program.`,
      configureNow: `Configure now`,
      enable2fa: `enabled the requirement to configure dual-factor authentication`,
      disable2fa: `disabled the requirement to configure dual-factor authentication`,
      itWas: `It was`,
      toProgram: `for the program`,
      translateText: `Translate text`,
      openingDate: `Opening date:`,
      classification: `Classification`,
      confidential: `Confidential`,
      selectProgram: `Select program`,
      swalSuccess: `Change made successfully.`,
      dateDownloadReport: `download`,
      setHallOfFame: `Do you want to enable the hall of fame in your new program?`,
      addHackerToHof: `Do you want to add the expert to the Hall of Fame?`,
      hallOfFame: `Hall of Fame`,
      hallOfFameDoesNotHaveEnoughDataYet: `The Hall of Fame does not yet have specialists!`,
      hallOfFameThanksDescription: `would like to thank the following researchers for reporting significant security flaws.`,
      addedAt: `Added at`,
      programByObjective: `Objective program`,
      programObjective: `Program Objective`,
      nowTellUsLittleObjective: `Now tell us a little about the objective of the program!`,
      aGoodObjectiveAvoids: `A well-defined objective avoids problems, if you have any problems, contact us.`,
      target: `Target`,
      include: `Include`,
      infoTarget: `Attention! It is necessary to inform at least one objective.`,
      aboutTarget: `About the objective of the program!`,
      setProgramReward: `Set program reward`,
      maxProgram: `Attention! A maximum of 5 objectives are allowed per program.`,
      requiredProgram: `Please register an objective for the program.`,
      targetRequired: `Please fill in the program objective.`,
      requiredBounty: `Please enter a value.`,
      idConfirmation: `Almost done! Confirm your identity to proceed with the password change process.`,
      titleTarget: `Objective title`,
      targetPlaceholder: `Program objective title!`,
      titleTargetError: `Please fill in the objective title of the program.`,
      updateTarget: `Objective updated successfully!`,
      swalTarget: `Please check that the fields are filled in correctly.`,
      areYouSureYouWantToDeleteThisTarget: `Are you sure you want to remove this objective?`,
      removeTargetProgram: `Objective successfully removed!`,
      selectAnObjectiveForTheReport: `What type of objective is reported?`,
      informTheTarget: `State the objective`,
      selectTheProgramTarget: `Select a program objective!`,
      achievedTheObjective: `Was the objective of the program achieved?`,
      reachedIn: `Objective achieved in`,
      noObjectivesAvailable: `No objectives available!`,
      removeIn: `removed`,
      achievedIn: `achieved by`,
      pauseProgramSwal: `Program paused due to lack of active objectives.`,
      cBoostedProgram: `Boosted program`,
      signedAgreements: `Signed Agreements`,
      ccpProgObj: `Objective program`,
      ccpProgObjDesc: `Create a program with pre-defined objectives, where you choose who can participate and send reports!`,
      objectiveProgram: `objective program`,
      publicPrograms: `public programs`,
      privatePrograms: `private programs`,
      objectivePrograms: `objective programs`,
      alertMessageRemoved: `Message removed successfully!`,
      scopeNotFound: `Scope not found.`,
      usernameOrEmail: `Username or E-Mail`,
      aboutTheProgramPolicyHacker: `The rules contained in the program policy must be respected!`,
      jiraIssueType: `Which issue type will be registered in Jira?`,
      conceded: `conceded`,
      toTheSpecialist: `to the specialist`,
      getToKnow: `Get to know`,
      solutions: `Solutions`,
      contact: `Contact`,
      ourBlog: `Our Blog`,
      doubts: `Doubts?`,
      inTheMedia: `In the media`,
      talkToUs: `Talk to us`,
      understandHowItWorks: `Understand how it works!`,
      publicPrograms: `Public programs`,
      privatePrograms: `Private programs`,
      managedPrograms: `Managed programs`,
      vdpPrograms: `VDP programs`,
      howItWorks: `How does it work!`,
      ranking: `Ranking`,
      url: `URL`,
      multipliedScore: `Bonus! multiplied score`,
      codeOfConduct: `Code of Conduct`,
      and: `and`,
      reportConfidential: `Document classification: Confidential`,
      securitySystem: `Security system`,
      emailAlreadyRegisteredInOurDatabase: `Email already registered in our database`,
      theTokenMustBeEntered: `The token needs to be entered`,
      actionAlreadyReported: `Action already reported!`,
      statusPauseProgram: `The program has been paused`,
      statusStartProgram: `The program has been reactivated`,
      by: `by`,
      in: `in`,
      invalidName: `The name entered is not valid!`,
      includeMoreDetails: `Increase more details...`,
      maxTech: `The maximum allowed is 10 technologies per scope.`,
      maxLine: `Please limit the message to a maximum of 10 line breaks.`,
      includeInfoScope: `Enter notes about the scope... `,
      includeTech: `Enter technologies`,
      editScope: `Edit scope`,
      scopeDetails: `Scope details`,
      minMaxScopeCaracter: `The scope must be between 3 and 40 characters`,
      characters: `Characters`,
      //translation_script_end_en
    }),

    new MLanguage('spanish').create({
      ln: 'es',
      //translation_script_start_es
      agreementText: `¿Está de acuerdo con los términos del acuerdo de confidencialidad?`,
      agree: `Estoy de acuerdo`,
      doNotAgree: `No estoy de acuerdo`,
      programWithNda: `¡este programa tiene un NDA vinculado!`,
      ndaAccepted: `¡NdA aceptado!`,
      programWithoutNda: `¡este programa aún no tiene un NDA vinculado!`,
      menuProgram: `Horarios`,
      menuReport: `Informes`,
      menuAccount: `Mi cuenta`,
      navInvitations: `Invitaciones`,
      navPayments: `Pagos`,
      navCreateNda: `Crear una plantilla de NDA`,
      navEditNda: `Editar NDA`,
      navPrograms: `Horarios`,
      navPublished: `Publicado`,
      navClosed: `Inactivo`,
      navNda: `NDA`,
      navAll: `Todos`,
      navPending: `Pendiente`,
      navRetest: `Vuelva a probar`,
      dashTitle: `Bienvenido {0}!`,
      dashSubTitle: `Una visión general y un acceso rápido a tu cuenta solo para ti`,
      dashReportResolv: `Informes aprobados`,
      navAverage: `Recompensas promedio`,
      dashMsgYouHave: `Tienes`,
      dashMsgYouDHave: `No tienes`,
      msgProgramPu: `programas públicos!`,
      msgProgramPr: `programas privados!`,
      dashMsgGP: `Administre sus programas.`,
      dashMsgCP: `Registrar un programa ahora?`,
      dashInvTitle: `¡invita a expertos!`,
      dashInvSubTitle: `Invite a especialistas a participar en sus programas.`,
      dashPayTitle: `Pagos!`,
      dashPaySubTitle: `Resumen financiero y solicitudes de pago.`,
      dashNdaTitle: `¡Contratos de confidencialidad!`,
      dashNdaSubTitle: `Administre los acuerdos de confidencialidad de sus programas.`,
      dashCreatNdaTitle: `¡Plantilla de NDA estándar!`,
      dashCreatNdaSubTitle: `Cree una plantilla estándar para gestionar los acuerdos de confidencialidad de sus programas.`,
      dashCreatNdaAbriefsummary: `Un breve resumen para que el especialista entienda de qué se trata...`,
      dashCreatNdaDesc: `NdA es un acrónimo en inglés de Non-Disclosure-Agreements, o simplemente acuerdo de confidencialidad de la información. Su objetivo es proteger los secretos industriales o comerciales, o cualquier información que no pueda divulgarse y que deba mantenerse confidencial entre quienes tienen acceso a ella.`,
      dashCreatNdaWriteTerms: `Redacte los términos de su acuerdo de confidencialidad y sus particularidades.`,
      dashCreatNdawritePaste: `¡Empecemos, escribe o pega tus términos!`,
      dashCreatNdaWantAttach: `¿quieres adjuntar un documento para firmarlo?`,
      progTitle: `¡Descripción general!`,
      progSubTitle: `Rastrea y administra tus programas en BugHunt.`,
      progPubTitle: `¡Programas publicados!`,
      progPubSubTitle: `¡administra tus programas publicados! Lleve un registro de todos los detalles.`,
      progCampTitle: `Campañas`,
      progClosTitle: `¡Programas inactivos!`,
      progClosSubTitle: `¿Me has echado de menos? Consulte los datos de los programas inactivos.`,
      progCreateTitle: `Crear un programa`,
      progCreateSubTitle: `Momento emocionante, ¡hora de empezar a crear tu programa!`,
      progRankTitle: `¡Clasificación de contribuciones!`,
      progRankSubTitle: `Vea quién contribuye más a sus programas.`,
      progRankSendThank: `Envía un ¡Gracias!`,
      progRankBtnSendThank: `Enviar acuse de recibo`,
      progTimelineTitle: `¡Programas de cronograma!`,
      progTimelineSubTitle: `Siga el cronograma de sus programas`,
      repTitle: `Informes!`,
      repSubTitle: `Administre los informes enviados por los expertos a sus programas.`,
      repSubTitleHacker: `Administrar los informes enviados a los programas.`,
      repDetMsgAlter: `¡Los cambios realizados en el informe no se pueden deshacer!`,
      ccpTitle: `¿vamos a crear un programa?`,
      ccpProgPubli: `Programa público`,
      ccpProgPubliDesc: `¡cree un programa donde todos los especialistas registrados puedan ver y enviar informes!`,
      ccpProgVDPDesc: `¡cree un programa donde todos los especialistas puedan ver y enviar informes!`,
      ccpProgPriv: `Programa privado`,
      ccpProgPrivDesc: `¡cree un programa donde solo los especialistas seleccionados puedan ver y enviar informes!`,
      managedProgram: `Programa gestionado`,
      protectedByNDA: `Protegido por un NDA`,
      helpTitle: `¿necesitas ayuda?`,
      helpProgram: `¿Cómo funciona un programa?`,
      helpDifference: `¿Cuál es la diferencia entre lo privado y lo público?`,
      helpaverage: `¿Cuál es el promedio aplicado a una recompensa?`,
      rankTitle: `Clasificación de contribuciones`,
      retest_confirmed: `Revestido`,
      retest_denied: `La falla persiste`,
      accountSubTitle: `Una descripción general y un acceso rápido a su cuenta solo para usted.`,
      accountAcSubTitle: `Quién, cuándo y cómo accedió a tu cuenta`,
      accountTerSubTitle: `Acceda a nuestros términos y política de privacidad`,
      accountUserSubTitle: `Administrar quién tiene acceso a la organización.`,
      accountSettSubTitle: `Cómo quieres recibir tus correos electrónicos, política de privacidad y otros.`,
      aboutUs: `Acerca de nosotros`,
      aboutYou: `Acerca de ti`,
      aboutYourAccount: `Acerca de tu cuenta`,
      aboutTheProgramPolicy: `Sobre la política del programa!`,
      add: `Agregar`,
      addUser: `Agregar usuario`,
      addAcomment: `Añadir un comentario`,
      addExpertToBlacklist: `Añadir experto a la lista negra`,
      addTheScopesHere: `¡agrega los alcances aquí!`,
      addOutOfScopesHere: `¡Agregue aquí las aplicaciones que deben evitarse durante las pruebas de seguridad!`,
      addYourPayPalAccount: `Añade tu cuenta PayPal`,
      adjustedTheImpactTo: `Ajusta el impacto a`,
      adjustedTheImpactFrom: `Se ajustó el impacto de`,
      adjustMetrics: `Ajustar las métricas`,
      allowedFiles: `Archivos permitidos: vídeos, imágenes y archivos de texto .jpg .jpeg .png .txt .rar .zip .7z`,
      alreadyHaveAccount: `¿Ya tienes una cuenta?`,
      accepted: `Aceptada`,
      acceptThisInvitation: `¡Acepta esta invitación!`,
      access: `Accesiones`,
      accessControl: `Control de acceso`,
      accessMyAccount: `¡accede a mi cuenta!`,
      accessProfile: `Perfil de acceso`,
      accessInformation: `Acceder a la información`,
      accountCreatedSuccessfully: `¡la cuenta se creó correctamente!`,
      accountDeleted: `Cuenta eliminada`,
      accountRecovery: `Recuperación de cuenta`,
      accurate: `Comprobado`,
      activate: `Activar`,
      activated: `Habilitado`,
      additionalServices: `Servicios adicionales`,
      addOtherRewardsHere: `¡agrega otras recompensas aquí!`,
      addToBlacklist: `Agregar a la lista negra`,
      agreementSpecialists: `Expertos de acuerdo`,
      ago: `Hay {0}`,
      aGoodPolicAvoids: `Una buena política evita problemas, si tienes algún problema ponte en contacto con nosotros.`,
      all: `Todos`,
      gatTagOptDescription: `Solo los informes que contienen la etiqueta GAT`,
      gatTagDescription: `¿qué informes se enviarán a la plataforma GAT?`,
      allowMobileAccess: `Permitir el acceso a teléfonos celulares`,
      allowedToPayReward: `Se le permite pagar recompensas.`,
      allThePrograms: `Todos los programas`,
      allStatus: `Todos los estados`,
      aLowercaseLetter: `una letra minúscula`,
      anEmailContainingPasswordReset: `Se ha enviado un correo electrónico con instrucciones para restablecer la contraseña.`,
      aNewValidationEmailHasBeenSenToYou: `Se le ha enviado un nuevo correo electrónico de validación, compruebe su buzón`,
      aNewSuperStrongPassword: `¡una nueva contraseña súper segura!`,
      annotation: `Nota`,
      aNumber: `un número`,
      anUppercaseLetter: `una letra mayúscula`,
      thePasswordMustHave: `La contraseña debe tener`,
      anyQuestionsAboutIntegration: `¿Tiene preguntas sobre esta integración?`,
      application: `Aplicación`,
      applicableReport: `Informe aplicable`,
      approvedReports: `Informes aprobados`,
      approveWithoutRetest: `¿Realmente desea cerrar el informe tal como se aprobó antes de solicitar una nueva prueba?`,
      approveRetest: `Aprobar la nueva prueba`,
      approvedRetest: `Aprobó la nueva prueba`,
      areYouSureYouWantToDeleteThisUser: `¿Está seguro de que desea eliminar este usuario?`,
      as: `como`,
      aSuperStrongPasswordNow: `¡una contraseña súper segura ahora!`,
      atBugHuntYouWillFindPrograms: `En BugHunt encontrarás programas para probar diferentes tipos de tecnologías, poner en práctica tus conocimientos y probar aplicaciones reales de forma ética y legalizada.`,
      attention: `¡Atención!`,
      atLeastCharacters: `al menos 6 caracteres`,
      authentication: `Autenticación`,
      averageTicket: `Billete mediano`,
      average_time_to_bounty: `Tiempo promedio para pagar una recompensa`,
      average_time_to_first_response: `Tiempo promedio para la primera respuesta`,
      average_time_to_resolution: `Tiempo promedio para cerrar el informe`,
      averageTimeToBounty: `Tiempo medio de pago`,
      avgTimeToBounty: `El tiempo medio transcurrido desde la primera interacción de la empresa con un informe hasta la solicitud de pago de una recompensa.`,
      avgTimeToFirstResponse: `El tiempo medio transcurrido desde la presentación del informe hasta la primera interacción de la empresa con un informe.`,
      avgTimeToResolution: `El tiempo medio transcurrido desde la apertura de un informe hasta su cierre.`,
      awaitingAcceptance: `Esperando la aceptación`,
      awaitingPayment: `En espera de pago`,
      paymentReceived: `Pago recibido`,
      awaitingResponse: `Esperando respuesta`,
      award: `Concesión`,
      backupCodesLeft: `Códigos de respaldo restantes`,
      balance: `Equilibrio`,
      basedLast90Day: `Basado en los últimos 90 días`,
      beforeActivatingTwoFactorAuthentication: `Antes de activar la autenticación de dos factores, debes validar tu teléfono.`,
      beforeContinuingYouNeed: `¡Antes de continuar necesitas validar tu correo electrónico!`,
      billingCreditCard: `Facturación con tarjeta de crédito`,
      billingForms: `Formularios de facturación`,
      billingInformation: `Información de facturación`,
      byActivatingTheProgramSpecialistsWill: `¡Al activar el programa, los especialistas podrán enviar nuevos informes!`,
      byPausingTheProgramExpertsWill: `Cuando pauses el programa, ¡los especialistas ya no podrán enviar nuevos informes!`,
      bounty: `Financiero`,
      bountyAwarded: `Recompensa concedida`,
      bugBountyAndTheSecurityParadox: `Bug Bounty y la paradoja de la seguridad`,
      bugHuntIsTheFirstBrazilianBugBounty: `<b>BugHunt</b> es la primera plataforma brasileña de Bug Bounty y ahora se asocia con <b>AME Digital</b> con el propósito de democratizar el acceso a la seguridad de la información y, por lo tanto, hacer de Internet un lugar más seguro.`,
      ongoingProfileVerification: `¡Tu perfil está siendo verificado!`,
      cancel: `Cancelar`,
      cannotEnterEqualScopes: `No es posible introducir ámbitos iguales`,
      cannotEnterSpecialCharacters: `No es posible introducir caracteres especiales`,
      cautionNDA1: `Al redactar el NDA de su empresa, asegúrese de que incluya los siguientes elementos:`,
      cautionNDA2: `contener al menos una cláusula sancionadora en caso de incumplimiento;`,
      cautionNDA3: `informar a las partes que asumen ese compromiso;`,
      cautionNDA4: `contienen una fecha de caducidad;`,
      cautionNDA5: `detallar específicamente a qué se refiere ese NDA, ya que la información genérica y ambigua caracteriza erróneamente el documento legal;`,
      cautionNDA6: `Usa la etiqueta `,
      cautionNDA7: `para hacer referencia al nombre del especialista;`,
      cautionNDA8: `La plantilla de NDA que aparece a continuación es ilustrativa. Asegúrese de introducir correctamente los datos de su empresa al redactar el acuerdo de confidencialidad `,
      changeAccessPassword: `Cambiar contraseña de acceso`,
      changePassword: `Cambiar contraseña`,
      changePermission: `Cambiar permiso`,
      changedReportSeverity: `Se modificó la gravedad del informe`,
      changedReportStatus: `El estado del informe ha cambiado`,
      changedTheStatusFrom: `cambió la situación de {f} a {l}`,
      changedTheSituationTo: `cambió la situación a {0}`,
      changedTheTitleOf: `cambió el título del informe de {f} a {l}`,
      changedTheTitleTo: `cambió el título del informe a {0}`,
      changedTheVisibilityOf: `se cambió la visibilidad de {f} a {l}`,
      changedTheVisibilityTo: `cambió la visibilidad a {0}`,
      checkOutAllFieldsHighlightedInRed: `¡echa un vistazo a todos los campos resaltados en rojo!`,
      chooseANicknameYoursAlone: `¡elige un apodo para que sea solo tuyo!`,
      city: `Pueblo`,
      clickHereToLearn: `Aprende más.`,
      clearData: `Borrar datos`,
      clearlyDefine: `Defina claramente la política de su programa.`,
      close: `Adjunto`,
      closed: `Terminado`,
      closedAgo: `Cerrado {0} días`,
      closedIn: `Terminó en`,
      closedReport: `Informe cerrado`,
      closedReports: `Informes cerrados`,
      closedTheReportAs: `Cerrar el informe como`,
      reopenedTheReport: `Reabrió el informe`,
      code: `Código`,
      conclude: `Concluir`,
      connectionDenied: `Conexión denegada`,
      connectionTime: `Tiempo de conexión aproximado`,
      connectionRefusedUserDisabled: `¡conexión rechazada, usuario desactivado!`,
      connectionsPerUser: `Conexiones por usuario`,
      contacts: `Enlaces`,
      company: `Compromiso`,
      completed: `Completado`,
      confirm: `¡confirmar!`,
      confirmAccountRemoval: `Confirmar la eliminación de la cuenta`,
      confirmYourPassword: `¡confirme su contraseña!`,
      token2fa: `Introduzca el token de autenticación de 2 factores`,
      confirmProgramChanges: `Describa los cambios realizados en el programa`,
      congratulationsYourUsernameIsNowVerified: `Enhorabuena, tu nombre de usuario ya está verificado.`,
      invalidEmail: `Correo electrónico no válido, compruébalo e inténtalo de nuevo.`,
      continueReport: `Continuar con el informe`,
      copiedId: `ID copiado`,
      copyLink: `Copiar enlace`,
      continue: `Continuar`,
      creatAccountInvit: `Creaste la cuenta por invitación`,
      createA: `Crear un`,
      created: `Creado!`,
      createMyAccount: `¡crea mi cuenta!`,
      critical: `Sentencioso`,
      request_response: `Respuesta`,
      request_closure: `Juicio hipotecario`,
      responseRequestReport: `solicitó una respuesta a este informe.`,
      reportClosureRequest: `solicitó el cierre de este informe.`,
      day: `día`,
      days: `días`,
      dateTime: `Fecha/hora`,
      declined: `Rechazado`,
      dataChanged: `Datos cambiados!`,
      dataWillBeRemovedWithPhoneValidation: `¡Los datos 2fa se eliminarán una vez que se valide el teléfono!`,
      date: `Cita`,
      declineThisInvitation: `¡Rechaza esta invitación!`,
      delimitDomains: `Delimita dominios, subdominios, aplicaciones y más`,
      delimitItems: `Delimitar artículos`,
      deleteUser: `Eliminar usuario`,
      depositedAmount: `Contribuciones totales`,
      delimitationOfDomainsSubdomains: `Delimitar dominios, subdominios, aplicaciones y otros`,
      describeALittleMoreAboutTheImpact: `¡Describe un poco más sobre el impacto!`,
      describeChangesMadeInProgram: `¡este resumen estará disponible para todos los especialistas que participan en este programa!`,
      describeClearlyHowTheVulnerabilityWorks: `Describa claramente cómo funciona la vulnerabilidad.`,
      describeInDetailTheImpactOfThisRepor: `Describa en detalle el impacto de este informe.`,
      describeThePerformedTests: `Describa las pruebas realizadas`,
      describeTheTitleOfTheReport: `Describa el título del informe`,
      describeTheScope: `¿Cuál es la URL de la aplicación vulnerable?`,
      description: `Descripción`,
      descriptionSubmitReport: `##### 1. Resumen\\n(añadir resumen de vulnerabilidades)\\n\\n##### 2. Descripción\\n(añada más detalles sobre esta vulnerabilidad)\\n1. [añadir paso]\\n\\n##### 3. Pasos para reproducir\\n(Añade detalles sobre cómo podemos reproducir el problema)\\n1. [añadir paso]\\n2. [añadir paso]\\n3. [añadir paso]\\n\\n##### 4. Material de apoyo o referencias\\n(p. ej., capturas de pantalla, registros, etc.) \\n1. Enumera cualquier material adicional\\n `,
      descriptionCannotContainSpecialCharacters: `La descripción no puede contener caracteres especiales`,
      descriptionMustBeFromToCharacters: `La descripción debe tener entre {f} y {l} caracteres.`,
      describeEditsMade: `Describe las ediciones realizadas.`,
      details: `Detalles`,
      directoryName: `Nombre del directorio`,
      disable: `Deshabilitar`,
      domain: `Maestría`,
      done: `Pagado`,
      doNotUseSpecialCharactersAndMalicious: `No utilices caracteres especiales ni cargas maliciosas en el título, el impacto y el resumen; estos elementos deben adjuntarse como .zip, .rar o .7z al final del informe.`,
      doNotUseSpecialCharacters: `No envíes cargas con posibles códigos malintencionados, ¡estos elementos deben adjuntarse como .zip, .rar o.7z!`,
      dontForgetToSaveYourChanges: `¡no olvides guardar los cambios!`,
      downloadTheReportPDF: `Descarga el informe en PDF`,
      doYouHaveOrganizationAndDidYou: `¿quieres proteger tu empresa?`,
      doYouWantToRemoveThePhone: `¿quieres quitar el teléfono?`,
      doyoureallyWanttoDeleteVacancy: `¿Realmente quieres eliminar esta vacante?`,
      doYouReallyWantToRemoveTwoFactor: `¿Realmente quieres eliminar la autenticación de dos factores?`,
      doYouReallyWantToRemoveThisAccount: `¿De verdad quieres eliminar esta cuenta?`,
      doYouReallyWantToRemoveThis: `¿De verdad quieres eliminar este {0}?`,
      doYouWantToActivateTheProgram: `¿quieres activar el programa?`,
      doYouWantToContinue: `¿quieres continuar con los campos ya rellenados?`,
      doYouWantDisableProgram: `¿quieres desactivar el programa?`,
      doYouWantToPauseTheProgram: `¿quieres pausar el programa?`,
      doYouWantToAddVPNToYourNewProgram: `¿quieres añadir una VPN a tu nuevo programa?`,
      editProgram: `Editar programa`,
      editNda: `Editar NDA`,
      eligible: `Elegible`,
      efficiencyMetrics: `Métricas de eficiencia`,
      emailAlreadyRegistered: `El correo electrónico ya está registrado`,
      emailAlreadyValidatedNonExistent: `¡El correo electrónico ya está validado o ha caducado!`,
      emailConfirmation: `Confirmación por correo electrónico`,
      emailDoesNotAppearToBeValid: `El correo electrónico no parece ser válido`,
      emailSuccessfullyValidated: `¡correo electrónico validado correctamente!`,
      enableTwoFactorAuthentication: `Habilitar la autenticación de dos factores`,
      end: `Final`,
      enterNewTags: `Escriba las etiquetas nuevas separándolas con comas`,
      enterPasswordConfirmation: `Ingresa la confirmación de contraseña`,
      enterTheCode: `Introduce el código`,
      enterTheCodeReceivedBySms: `Introduzca el código recibido por SMS`,
      enterTheCompletePhone: `Introduzca el número de teléfono completo`,
      enterTheDescriptionOfTheOrganization: `Introduzca la descripción de la organización`,
      enterTheEmail: `Introduzca el correo electrónico`,
      enterTheNameOfTheOrganization: `Introduzca el nombre de la organización`,
      enterThePassword: `Introduzca la contraseña`,
      enterTheUsername: `Introduzca el nombre de usuario`,
      enterTheScope: `¡Dime el alcance del programa!`,
      enterUserName: `Introduzca el nombre de usuario`,
      enterYourEmail: `Introduce tu correo electrónico`,
      enterYourFullName: `Escriba su nombre completo`,
      enterYourPayPalAccountEmail: `Introduce el correo electrónico de la cuenta PayPal`,
      enterYourPrimaryEmailAddress: `¡introduce tu correo electrónico principal!`,
      enterYourUserPassword: `Introduzca su contraseña de usuario`,
      enterYourRewardDetails: `¡introduce los detalles de la recompensa!`,
      evaluate_retest: `Evaluar la repetición de la prueba`,
      evaluatedRetest: `Repetición de prueba evaluada`,
      executiveSummary: `Resumen ejecutivo de la organización`,
      exit: `Dejando`,
      expertSuccessfullCreated: `Experto {0} creado correctamente`,
      export: `Exportar`,
      exportLogs: `Registros de exportación`,
      exportInCsv: `Exportar a .csv`,
      exportReports: `Informes de exportación`,
      externalLinkNotice: `Advertencia de enlace externo`,
      extract: `Declaración`,
      extractedBy: `Extraído por`,
      fillInTheDetailsBelowTo: `Rellena los datos que aparecen a continuación para cambiar tu contraseña.`,
      fillInAllFieldHighlightedInRed: `¡rellena todos los campos resaltados en rojo!`,
      filterByTags: `Etiquetas`,
      findSecurityJobsOnOurDashboard: `BugHunt conecta a la comunidad con las mejores empresas.`,
      forgotYourPassword: `¿olvidaste tu contraseña?`,
      forSecurityWeRequestYourPassword: `Por motivos de seguridad, solicitamos su contraseña para esta operación.`,
      forYourSecurityToPDF: `Por su seguridad es necesario añadir una contraseña al PDF.`,
      fullName: `Nombre completo`,
      generateNewCodes: `Generar nuevos códigos`,
      getAccessToExclusiveRewards: `¡accede a las recompensas exclusivas de este programa!`,
      gift: `Brindis`,
      giftsAndAcknowledgments: `Obsequios y agradecimientos`,
      guests: `Huéspedes`,
      hackerControl: `Control de piratas informáticos`,
      haveYouRevised: `¿Has revisado tu modelo? ¡Entonces listo!`,
      haveYouReviewedYourReportNow: `¿Ha revisado su informe? ¡Listo! ¡Vamos a enviarlo para su análisis!`,
      here: `al presente`,
      hereYouCanSetUpYourAccount: `Aquí puedes configurar tu cuenta para recibir tus recompensas.`,
      high: `Ruidosamente`,
      historic: `Historia`,
      features: `Funcionalidades`,
      iAlreadyHaveAnSccount: `¡Ya tengo una cuenta!`,
      iAlreadyRemembered: `¡Ya me he acordado!`,
      iAgreeWithThe: `Estoy de acuerdo con la `,
      ifYouDontReceiveIt: `Si no lo recibes, puedes volver a intentarlo en`,
      ifYouNeedToSubmitMoreComment: `Si necesitas enviar más, solo tienes que escribir otro comentario`,
      impact: `Impacto`,
      impactDescriptionCannotContainSpecialCharacters: `¡la descripción del impacto no puede contener caracteres especiales!`,
      inactivated: `inactivado`,
      inactiveUsers: `Usuarios inactivos`,
      initProgramMessage: `Día de inicio del programa `,
      informBugHuntPassword: `Introduzca la contraseña de la plataforma BugHunt para confirmar esta operación.`,
      informThePhoneWithAreaCode: `Ingresa el número con DDD`,
      informTheRecommendations: `¡Dime las recompensas que recibirá el especialista si tiene éxito!`,
      informTheScope: `Introduzca el ámbito`,
      informTheScopeWhereTheThreatsAre: `Dime el alcance de las amenazas`,
      selectTheScopeType: `Seleccione el tipo de osciloscopio inspeccionado`,
      informTheImpact: `Reportar el impacto`,
      informTheUser: `Díselo al usuario`,
      informTheWebsite: `Díselo al sitio web`,
      interationIdealTime: `El tiempo promedio ideal para {interationType} es `,
      interviewWithExpertIgorRincon: `Entrevista con el experto Igor Rincón`,
      invalidBackupCodeOrToken: `Código de respaldo o token no válido`,
      invalidCode: `Código no válido`,
      invalidCodeOrToken: `Código o token no válido`,
      invalidDate: `Fecha no válida`,
      invalidData: `Datos no válidos`,
      invalidRegistrationData: `Los datos de registro {0} no son válidos.`,
      invalidEmailOrPassword: `¡correo electrónico o contraseña inválidos!`,
      invalidPassword: `Contraseña no válida`,
      invite: `Invitación`,
      invitationAccepted: `Invitación aceptada`,
      invitationDeclined: `Invitación rechazada`,
      invitationLimitManagersReached: `Se ha alcanzado el límite de invitaciones para los administradores.`,
      invitationProgramLimitReached: `Se ha alcanzado el límite de invitaciones para el programa {program}.`,
      invitationNotFoundOrExpired: `¡La invitación no se encontró o ha caducado!`,
      invitationsAccepted: `Invitación aceptada`,
      invitationsReceived: `¡Invitaciones recibidas!`,
      invitationRevoked: `Invitación revocada`,
      invitationSent: `Invitación enviada`,
      invoiceValue: `Total de la factura`,
      NdaCreated: `NdA creado`,
      inProgress: `En marcha`,
      inRelationToTheReport: `En cuanto al informe`,
      inSomeCasesTheEmailMayFallAsSpam: `En algunos casos, el correo electrónico puede considerarse spam.`,
      integration: `Integración`,
      integrations: `Integraciones`,
      integrationsNotAvailable: `¡las integraciones no están disponibles!`,
      inTheProgram: `En el programa`,
      internal: `Interno`,
      invoices: `Facturación`,
      iPAdress: `Dirección IP`,
      issued: `Emitido`,
      itHappensInTheBestFamilies: `¡Sucede en las mejores familias! No te preocupes, introduce tu correo electrónico y te enviaremos una nueva contraseña.`,
      itHappensInTheBestFamiliesDonotworry: `¡Sucede en las mejores familias! No te preocupes.`,
      itIsNotPossibleToEnterEqualRewards: `¡No es posible ingresar recompensas iguales!`,
      itIsNotPossibleToEnterMore: `¡no es posible insertar más de 30 etiquetas!`,
      itIsNotPossibleToSubmitAnotherRetest: `¡No fue posible enviar la nueva evaluación! <br />Espere a que el especialista vuelva a realizar la prueba.`,
      iWantToCreateAnAccount: `¡Quiero crear una cuenta!`,
      jobBoard: `Panel de vacantes`,
      jobDescription: `##### Acerca de la empresa\\nDescriba los detalles sobre su **empresa**\\n\\n##### Acerca de la vacante\\nEstamos buscando un profesional cuyas principales responsabilidades sean:\\n- Responsabilidad 1. \\n- Responsabilidad 2. \\n- Responsabilidad 3. \\n\\n##### Requisitos\\n- **Requisito 1: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Más de x años de experiencia. \\n- **Requisito 2: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Más de x años de experiencia. \\n- **Requisito 3: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Más de x años de experiencia.`,
      jobTitle: `Título de la vacante`,
      joinedThePlatform: `Se unió a la plataforma`,
      lastReviewSubmittedAgo: `Última reseña enviada hace {0}`,
      lastInvitations: `Últimas invitaciones enviadas`,
      last7daysOfAccess: `Últimos 7 días de acceso`,
      latestReports: `Últimos informes`,
      letStartYourRegistrationAnd: `¡Comenzaremos su registro y pronto nos pondremos en contacto con usted para responder cualquier pregunta y finalizar su registro!`,
      letsCompleteYourRegistration: `¡completemos su registro!`,
      letsCreateYourAccount: `¡vamos a crear tu cuenta!`,
      letsCreateYourPreRegistration: `¡creemos tu preinscripción!`,
      lessThanMonthAgo: `hace menos de un mes`,
      like: `Del tipo`,
      limitScope: `¡Delimita el alcance y solo aquellos accesos que serán recompensados!`,
      limitOutOfScope: `¿Qué aplicaciones no deben probarse?`,
      limitOfScopesPerProgramReached: `¡Se ha alcanzado el límite de {0} alcances por programa!`,
      linkToJob: `Enlace a la vacante`,
      location: `Local`,
      longPeriodsImpactSpecialists: `Los largos períodos de espera pueden afectar la participación de los especialistas en este programa.`,
      low: `Baja`,
      makePayment: `Realizar un pago`,
      makeAPayment: `Realizar un pago`,
      makeSureYouHaveACompatibleAppLike: `Asegúrate de tener una aplicación compatible como `,
      makeYourAccessEvenMoreSecure: `Haga que su acceso sea aún más seguro`,
      manageAccess: `Gestionar quién tiene acceso al programa.`,
      managementInvitations: `Gestión de las invitaciones recibidas.`,
      manageVPNforUsers: `Administrar la VPN de los usuarios de cada programa`,
      manageYourPlanInformation: `Administre la información de su plan.`,
      manageYourProgressPlatform: `Gestiona tu progreso en la plataforma BugHunt`,
      maximumLengthIsCharacters: `La longitud máxima es de {0} caracteres`,
      maximumFilesPerComment: `El máximo es de 10 archivos por comentario`,
      medianTimeToResolution: `Tiempo promedio de resolución`,
      medianTimeToFirstResponse: `Tiempo promedio hasta la primera respuesta`,
      medium: `Mediano`,
      metricDoesNotHaveEnoughDataYet: `No hay datos suficientes para calcular esta métrica`,
      metricsDoesNotHaveEnoughDataYet: `Aún no hay datos suficientes para calcular las métricas`,
      message: `Mensaje`,
      messagePostedAgo: `mensaje publicado hace {hora}`,
      messagePublishedDay: `Mensaje publicado el {día}`,
      missedResponseTargetsReportsSent: `Respuestas enviadas durante el tiempo previsto`,
      missedResponseTargetsResolved: `Resolución de informes por encima del tiempo previsto`,
      missedResponseTargetsBounty: `Pagos realizados por encima del tiempo esperado`,
      monthlyFee: `Importe del pago mensual`,
      monthlyPayment: `Cuota mensual`,
      moreOptions: `Más opciones`,
      money: `Fondos`,
      myPlan: `Mi plan`,
      myBusiness: `Mi empresa`,
      nameChanged: `Nombre cambiado!`,
      nameOfAccountHolder: `Nombre de la persona responsable de la cuenta!`,
      nameIsNotValid: `El nombre no es válido`,
      navigation: `Navegación`,
      needChangeDescription: `Utilice la plantilla para hacer una descripción detallada.`,
      ndaVerificationRequired: `¡tu perfil es elegible para participar en el proceso de verificación!`,
      ndaChange: `Cambio de NDA`,
      next: `Cerca`,
      new: `Recién descubierto`,
      newComment: `Nuevo comentario`,
      newUsers: `Nuevos usuarios`,
      newPassword: `Contraseña nueva`,
      newPasswordAndConfirmation: `¡La nueva contraseña y la confirmación no son lo mismo!`,
      newReport: `Nuevo informe`,
      none: `Ninguna`,
      noActivePrograms: `Ningún programa activo`,
      noInvitationAvailable: `No hay invitación disponible`,
      noNotificationsAvailable: `No hay ninguna notificación disponible`,
      noPaymentsFound: `No se encontró ningún pago`,
      noProgramAvailable: `No hay programa disponible`,
      noReportsFound: `No se encontró ningún informe`,
      noScopeAvailable: `¡no hay visor disponible!`,
      noSuggestionsAvailable: `No hay sugerencias disponibles`,
      noteValue: `Valor de la nota`,
      notAvailableForThisPlan: `¡no está disponible para este plan!`,
      notAuthorized: `¡no autorizado!`,
      shutdownRequested: `¡Ya se ha solicitado el cierre de este informe!`,
      replyNotificationTitle: `Solicitud de respuesta`,
      closingRequestTitle: `Solicitud de cierre`,
      replyRequestMessage: `¡Ya se ha solicitado una respuesta para este informe!`,
      notificationResponseReport: `¡Atención! Se solicitó una respuesta para este informe.`,
      shutdownNotificationMessage: `¡Atención! Se ha presentado una solicitud para cerrar este informe.`,
      notificationSeeRequest: `Ver solicitud`,
      requestSent: `¡La solicitud se envió correctamente!`,
      reportResponseNotification: `¡Atención! Se solicitó una respuesta a este informe.`,
      notEligible: `No es elegible`,
      noExpertsFound: `No se encontró ningún especialista`,
      notificationUpdatedNDA: `¡Se ha actualizado el acuerdo de confidencialidad del programa {programName}! Para seguir participando en este programa, debe revisar y aceptar el NDA.`,
      noUserAvailable: `No hay usuarios disponibles`,
      noVpnAccessLogFound: `¡No se encontró ningún registro de acceso a la VPN!`,
      nowTellUsLittle: `¡Ahora cuéntanos un poco sobre la política del programa!`,
      nowTellUsALittleBitAboutTheThreat: `¡Ahora cuéntanos un poco sobre la amenaza!`,
      ofReward: `De recompensa`,
      oneDayAgo: `Hace un día`,
      oldPassword: `Contraseña antigua`,
      outstandingPayments: `Pagos pendientes`,
      open: `Abierto`,
      opssMatiDidntApproveYourData: `Vaya, Mati no aprobó tus datos.`,
      other: `Otros`,
      others: `Otros`,
      otherTypes: `Otros tipos`,
      outOfScope: `Fuera del alcance`,
      outOfScopeTitle: `Fuera del alcance`,
      participating: `Participante`,
      password: `Contraseña`,
      passwordChanged: `¡contraseña cambiada!`,
      passwordConfirmation: `Confirmación de la nueva contraseña`,
      passwordsMustMatch: `Las contraseñas deben ser las mismas`,
      passwordUpdateRequired: `¡Atención! ¡Cambia tu contraseña para evitar bloquear esta cuenta!`,
      remainingDaysToUpdateYourPassword: `quedan días para actualizar su contraseña.`,
      passwordExpiredNotificationTitle: `¡Atención! ¡Tu contraseña ha caducado!`,
      passwordExpiredInstructions: `Tu cuenta se bloqueará temporalmente. Mantén tu contraseña actualizada y sigue las instrucciones enviadas al correo electrónico asociado a esta cuenta.`,
      enablePasswordExpiration: `Habilitar el vencimiento de la contraseña`,
      configSuccess: `¡la configuración se actualizó correctamente!`,
      expirePasswordConfig: `Las contraseñas de usuario serán válidas para`,
      passwordUpdateRequired: `¡Atención! ¡Cambia tu contraseña para evitar bloquear esta cuenta!`,
      remainingDaysToUpdateYourPassword: `quedan días para actualizar su contraseña.`,
      passwordExpiredNotificationTitle: `¡Atención! ¡Tu contraseña ha caducado!`,
      passwordExpiredInstructions: `Tu cuenta se bloqueará temporalmente. Mantén tu contraseña actualizada y sigue las instrucciones enviadas al correo electrónico asociado a esta cuenta.`,
      enablePasswordExpiration: `Habilitar el vencimiento de la contraseña`,
      configSuccess: `¡la configuración se actualizó correctamente!`,
      expirePasswordConfig: `Las contraseñas de usuario serán válidas para`,
      pasteTheLinkIntoTheBodyOfTheDescription: `Pega el enlace en el cuerpo de la descripción.`,
      pause: `Pausa`,
      paused: `Pausado`,
      pauseProgram: `¿Pausar el programa?`,
      paymentFor: `Pago por`,
      paymentHistory: `Historial de pagos`,
      paymentSummary: `Resumen de los pagos`,
      paymentRequested: `Pago solicitado`,
      pending: `Pendiente`,
      pendingSubscription: `Suscripción pendiente`,
      permission: `Permiso`,
      permissions: `Permisos`,
      pleaseMakeSureThatThisEmail: `Asegúrate de que este correo electrónico es correcto y de que te pertenece.`,
      phoneNumber: `Número de teléfono`,
      phoneSuccessfullyRemoved: `¡el teléfono se eliminó correctamente!`,
      phoneValidation: `Validación telefónica`,
      platform: `Plataforma`,
      points: `Puntadas`,
      pointsIn: `Puntos en`,
      possibleDup: `Informe posiblemente duplicado: Scope {scope} ya ha recibido informes relacionados con {CWE}`,
      possibleSpam: `Posible spam: hemos verificado que el experto {expert} envió varios informes haciendo referencia a {CWE} en el ámbito {scope}.`,
      postedComment: `Publicó un comentario `,
      postedImage: `Publicó una imagen`,
      previous: `Previo`,
      primaryEmail: `correo electrónico principal`,
      primaryEmailReceiving: `Correo electrónico principal para recibir información`,
      privacy: `Intimidad`,
      privacyPolicy: `Política de privacidad`,
      private: `Privado`,
      privateProgram: `programa privado`,
      profileInformation: `Información del perfil`,
      profileVerifiedReleased: `Verificación de perfil solicitada`,
      program: `Programa`,
      programs: `Programas`,
      programDetails: `Detalles del programa`,
      program_management: `Gestión de programas`,
      programLifeCycle: `Ciclo de vida del programa`,
      programsLimitReached: `¡Se ha alcanzado el límite del programa {0}!`,
      programsIhaveAlreadyContributed: `Programas en los que ya he contribuido`,
      programPolicy: `Política del programa`,
      programPolicyMustBeInformed: `Se debe informar sobre la política del programa`,
      programPolicyMustBeBetweenAndCharacters: `La política del programa debe tener entre {f} y {l} caracteres`,
      programRanking: `Clasificación del programa`,
      programNdaMustBeBetweenAndCharacters: `El contenido del NDA debe tener entre {f} y {l} caracteres`,
      programsPublishedOnTheWeb: `Los especialistas no registrados en la plataforma pueden acceder a los programas publicados en la web.`,
      programSuccessfullyChanged: `El programa se modificó correctamente`,
      programType: `Tipo de programa`,
      programWith: `Programa con {0}`,
      proofOfConceptLinks: `Los vínculos con la prueba de concepto son generalmente benignos, pero a menudo pueden ir acompañados de consecuencias imprevistas.`,
      setProgramNda: `¿desea añadir el acuerdo de confidencialidad a su nuevo programa?`,
      public: `Público`,
      publicInformation: `Datos públicos`,
      publicOrPrivateProgram: `Programa público o privado`,
      publicProgram: `Programa público`,
      publish: `Publicar`,
      published: `Publicado`,
      publishedDaysAgo: `Publicado hace {0}`,
      publishProgramOnTheWeb: `Publicar un programa en la Web?`,
      publishToTheWeb: `Publicar en la Web `,
      questionsAboutUrl: `Preguntas sobre {0}`,
      rankingDoesNotHaveEnoughDataYet: `El Ranking aún no tiene suficientes datos`,
      rankingPosition: `{0}° en el Ranking`,
      received: `Bienvenido`,
      receiveAdvertising: `Reciba correos electrónicos publicitarios`,
      receiveEmails: `Recibir correos electrónicos`,
      receiveAdvertisingEmails: `Recibir correos electrónicos publicitarios`,
      receiveNotificationsAboutNewReports: `Reciba notificaciones sobre nuevos informes directamente en sus plataformas de gestión`,
      referenceDate: `Fecha de referencia`,
      refuseRetest: `Rechazar la nueva prueba`,
      refusedRetest: `Rechazó la nueva prueba`,
      registerBelowTheTags: `Gestión de etiquetas`,
      registeredUsers: `Usuarios registrados`,
      registeredVacancies: `Vacantes`,
      registration: `Catastro`,
      removeAccount: `Eliminar cuenta`,
      remove: `Retirar`,
      removeFromWhitelist: `Eliminar de la lista blanca`,
      removeFromBlacklist: `Eliminar de la lista negra`,
      removed: `Eliminado`,
      reportAllPossibleThreatData: `Proporcione todos los datos de amenazas posibles`,
      report: `Reportaje`,
      reportID: `ID del informe`,
      reportCreatedSuccessfully: `Informe creado correctamente`,
      reportEvaluation: `Evaluación del informe`,
      reportPayments: `Reportar pagos`,
      reports: `Informes`,
      reportSent: `Informe enviado`,
      reportsSent: `Informes presentados`,
      reportTitle: `Título del informe`,
      reportedThatTheVulnerabilityIsFixed: `Ha informado de que la vulnerabilidad está corregida`,
      reportedThatTheVulnerabilityIsNotPatched: `Ha informado de que la vulnerabilidad no se ha solucionado`,
      reportedVulnerabilities: `Vulnerabilidades reportadas`,
      vulnerabilities: `Vulnerabilidades`,
      overviewSubTitle: `Una visión gerencial de tu cuenta solo para ti`,
      summaryCard: `Resumen de los informes`,
      requestedPayment: `Solicitó un pago`,
      requestedPaymentOf: `Pago solicitado de`,
      requestedANewTestOfTheReport: `solicitó una nueva prueba del informe`,
      reset: `Limpiar`,
      rewardValue: `Importe de la recompensa`,
      whatIsAnNda: `¿Qué es un NDA?`,
      whatIsAnNda2: `NdA es un acrónimo en inglés de Non-Disclosure-Agreements, o simplemente acuerdo de confidencialidad de la información.`,
      whatIsAnNda3: `Tiene la intención de proteger los secretos industriales o comerciales, o incluso cualquier información que no pueda divulgarse y deba mantenerse confidencial entre quienes tienen acceso a ella.`,
      whatIsaVPNAndHow: `¿Qué es una VPN y cómo puede ayudar a sus programas?`,
      reportTags: `Agregar etiqueta(s) al informe`,
      requestNewPassword: `¡solicita una nueva contraseña!`,
      requestRetest: `Solicita Reteste`,
      requestSubscription: `Solicitar suscripción`,
      requiredField: `Campo obligatorio`,
      retestRequested: `Se ha solicitado una nueva prueba`,
      requestedRetestPayment: `Pago solicitado para volver a realizar la prueba`,
      retestId: `Volver a probar el ID`,
      retestSent: `Se ha enviado una nueva prueba`,
      return: `Regresar`,
      resolved: `Resuelto`,
      revoke: `Revocar`,
      revokeWebAccessToTheProgram: `¿revocar el acceso web al programa?`,
      revoked: `Revocado`,
      revokeAccess: `Revocar el acceso`,
      rewardAmount: `Monto de recompensa`,
      reward: `Recompensa`,
      rewardDetails: `Detalles de la recompensa`,
      rewards: `Recompensas`,
      rewardsReceived: `Recompensas recibidas`,
      rewardsWithFinancialValues: `Recompensas con importes financieros`,
      save: `Ahorrando`,
      saveEditions: `Guardar cambios`,
      saveNda: `Guardar acuerdo de confidencialidad`,
      saveInformation: `Ahorrando`,
      scopePerProgram: `Alcance por programa`,
      scopesPerProgram: `ámbitos por programa`,
      search: `Búsqueda`,
      seconds: `segundos`,
      select: `Seleccionar`,
      selectAddAccount: `Selecciona «Añadir cuenta» o «+» y escanea el código QR que aparece a continuación`,
      selectAScoreForTheReport: `Seleccione una puntuación para el informe`,
      selectFile: `¡selecciona el archivo!`,
      selectProgram: `Selecciona un programa`,
      selectLanguage: `Selecciona un idioma`,
      selectScopeType: `Seleccione el tipo de ámbito`,
      selectTheThreat: `¡selecciona la amenaza!`,
      selectTheProgramScope: `¡seleccione el alcance del programa!`,
      selectTheProgramImpact: `¡selecciona el impacto del programa!`,
      selectTheReport: `Seleccione el informe`,
      selectTheScope: `Seleccione el ámbito`,
      selectTheCWE: `Seleccione el CWE`,
      selectTheVulnerability: `Seleccione la vulnerabilidad`,
      securityAnalyst: `Ex. Analista de seguridad`,
      send: `Enviar`,
      sentTheRetest: `Envié la nueva prueba`,
      sendMessage: `Enviar mensaje`,
      sent: `Enviado por correo`,
      sentTo: `Subido`,
      sentTheReport: `Envié el informe`,
      settings: `Ajustes`,
      severityReports: `Informes por gravedad`,
      severity: `Severidad`,
      currentValue: `Valor actual`,
      finalValue: `Valor final`,
      showingResultsOfTotal: `Mostrando {results} de {totalResults} resultados.`,
      since: `Desde {0}`,
      sinceLastMonth: `Desde el mes pasado`,
      situation: `Situación`,
      scope: `Alcance`,
      scopeLimitExceeded: `Se ha superado el límite del alcance del programa.`,
      scopeListOfTheProgram: `Lista de alcances del programa!`,
      score: `Anotando`,
      scoreHistory: `Historial de puntuación`,
      scopeType: `Tipo de ámbito`,
      share: `Compartir`,
      smsCode: `Código SMS`,
      smsCodeSent: `Código SMS enviado`,
      specialist: `Especialista`,
      specialistNotFound: `¡No se encontró el especialista!`,
      standard: `Estándar`,
      standoutCreate: `¡destaque! Crea un titular motivador.`,
      start: `Comienzo`,
      pauseMessage: `No fue posible ejecutar la acción, ya que la campaña aún no ha comenzado.`,
      startAnAccountForOrganization: `Crear una cuenta para la organización`,
      startWithRewards: `Comience con las recompensas que tienen valor financiero`,
      statistics: `Estadísticas`,
      stateCity: `Estado`,
      status: `Estado`,
      statusChanged: `¡estado cambiado!`,
      storeYourBackupCodes: `Almacena tus códigos de respaldo`,
      subdomain: `Subdominio`,
      submittedDays: `Enviado hace {0} días`,
      submitComment: `Enviar comentario`,
      submitForReview: `Enviar para su análisis`,
      rewardNotice: `Recordatorio: este programa ofrece recompensas dobles`,
      submitReport: `Enviar informe`,
      submit_retest: `Enviar nueva prueba`,
      successfullyGeneratedKeys: `Claves generadas correctamente!`,
      suggestions: `Sugerencias`,
      suggestedReward: `Recompensa sugerida`,
      summary: `Resumen`,
      superSimpleItDoesntEvenTake: `Es sencillo, no lleva ni un minuto. ¡Simplemente ingresa los detalles a continuación y listo! Se ha creado su cuenta.`,
      superSimpleItDoesntEvenTakeCompany: `Es sencillo, no lleva ni un minuto. Simplemente introduzca los datos comunes de la organización y ¡listo! Su cuenta se enviará para su revisión.`,
      support: `Puntal`,
      sureAddExpertBlacklist: `¿Estás seguro de que quieres añadir a este experto a la lista negra?`,
      sureAddExpertWhiteList: `¿Está seguro de que desea agregar a este experto a la lista blanca?`,
      sureRemoveExpertBlacklist: `¿Está seguro de que desea eliminar a este experto de la lista negra?`,
      sureRemoveExpertWhitelist: `¿Está seguro de que desea eliminar a este experto de la lista blanca?`,
      successfullyCreatedProgram: `Programa creado correctamente`,
      successfullyCreated: `creado correctamente`,
      acceptedNda: `¡NdA aceptado con éxito!`,
      openReports: `Informes abiertos`,
      openYourApp: `Abre tu aplicación.`,
      or: `o`,
      organizationName: `Nombre de la organización`,
      overallRanking: `Clasificación general`,
      paidRetest: `Si <b>se aprueba la repetición de la prueba</b>, recibirás <b>{0}</b> más que el importe de la recompensa.`,
      tagsAreUsedToHelpIdentifyReports: `Las etiquetas se utilizan para ayudar a identificar los informes.`,
      tagsForReports: `Etiquetas para informes`,
      takeAction: `Realizar acción`,
      takeTheOpportunityToAcquireMoreComplete: `Aproveche la oportunidad de adquirir planes más completos para su empresa`,
      talkDirectlyToOurOperators: `Hable directamente con nuestros operadores.`,
      target: `Hora prevista: {0}`,
      telephone: `Teléfono`,
      testDescriptionsMustBetweenCharacters: `La descripción de las pruebas debe tener entre {f} y {l} caracteres`,
      tests: `Exámenes`,
      terms: `Términos`,
      termsAPolicy: `Términos y política`,
      termsOfUse: `Condiciones de uso`,
      thanksForRegistering: `¡gracias por registrarte!`,
      thankByEmail: `Gracias por correo electrónico`,
      theActionsTakenOnTheReportCannotBe: `Las acciones realizadas en el informe no se pueden eliminar`,
      theCommentNeedsToBeInformed: `¡El comentario debe ser reportado!`,
      theDescriptionTestsMustBeInformed: `Debe ingresarse la descripción de las pruebas`,
      theDescriptionOfTheProgramMustBeInformed: `Se debe introducir la descripción del programa`,
      theImpactDescriptionMustBeInformed: `Debe ingresarse la descripción del impacto`,
      theImpactDescriptionMustBetweenCharacters: `La descripción del impacto debe tener entre {f} y {l} caracteres`,
      theIsNotValid: `{0} no es válido`,
      theFileIsNotValid: `¡el archivo no es válido!`,
      theNameMustBeFromToCharacters: `El nombre debe tener de {f} a {l} caracteres`,
      theNameOfThePersonResponsibleIsMandatory: `Se requiere el nombre de la persona responsable.`,
      theNameOfTheProgramMustBInformed: `Se debe introducir el nombre del programa`,
      theNameWillBeAssignedToYourProgramsURL: `El nombre se asignará a la URL de su programa.`,
      thenUseYourEmail: `Luego usa tu correo electrónico, tu contraseña y accede a nuestra plataforma. Si ha olvidado su contraseña o nombre de usuario, ¡utilice la opción de recuperación que aparece a continuación!`,
      thePhoneIsNotValid: `El teléfono no es válido.`,
      theProgramDescriptionMustBeBetweenAndCharacters: `¡la descripción del programa debe tener entre {f} y {l} caracteres!`,
      theProgramNameMustBeBetweenAndCharacters: `El nombre del programa debe tener entre {f} y {l} caracteres`,
      thereIsAlreadyAprogram: `¡Ya hay un programa registrado con ese nombre!`,
      thereIsAlreadyProgramSlug: `¡Ya hay un programa registrado con este slug!`,
      theReportNeedsToBeInformed: `El informe debe ser reportado`,
      theRetestMustBeSentWithinDays: `La nueva prueba debe enviarse en un plazo de {0} días`,
      theRetestWasNotSubmitted: `¡No se envió la nueva prueba!`,
      theRetestHaAlreadyAccepted: `¡La nueva prueba ya ha sido aceptada!`,
      theseSettingsDirectlyImpactTheAccessOfExperts: `Estas configuraciones tienen un impacto directo en el acceso de los expertos.`,
      theScopeAddressMustBeInformed: `Se debe introducir la dirección del ámbito`,
      theThreatDescriptionMustBeInformed: `¡Se debe informar la descripción de la amenaza!`,
      theThreatDescriptionMustBetweenCharacters: `La descripción de la amenaza debe tener entre {f} y {l} caracteres`,
      theTitleMustBeInformed: `Se debe introducir el título`,
      theTitleMustBeBetweenCharacters: `El título debe tener entre {f} y {l} caracteres`,
      theWebhookIsNotValid: `¡el webhook no es válido!`,
      theWebsiteMustBeFromToCharacters: `El sitio web debe tener de {f} a {l} caracteres`,
      thisChangeIsIrreversible: `Este cambio es irreversible.`,
      thisInformationCanAppear: `Esta información puede aparecer en el perfil público de la empresa, junto a sus comentarios y en cualquiera de sus informes.`,
      thisIsAnInternalSurvey: `Se trata de una encuesta interna, los expertos no tendrán acceso a los datos de este cuestionario.`,
      thisServiceCreatesAVPNResponsible: `Este servicio crea una VPN, responsable de conectar y monitorear el tráfico de datos desde las pruebas del especialista hasta sus alcances y, por lo tanto, una mayor trazabilidad y seguridad.`,
      thisWeek: `Esta semana`,
      threats: `Amenazas`,
      time: `Clima`,
      timeToFirstResponse: `La primera respuesta`,
      timeToBounty: `Paga la recompensa`,
      timeToResolution: `Cerrar el informe`,
      title: `Título`,
      to: `hacia`,
      toAcceptThisInvitation: `Para aceptar esta invitación es necesario revisar el Meta <b>Mapa</b>, después de la verificación, esperar unos minutos y actualizar la página.`,
      tokenIsInvalid: `El token no es válido o ya se ha utilizado`,
      toAddMorePrograms: `Para agregar más programas, consulte nuestros planes haciendo clic`,
      toAddMoreScopesToThe: `Para agregar más ámbitos al programa, consulte nuestros planes haciendo clic`,
      toAddMoreUsersCheck: `Para añadir más usuarios, consulta nuestros planes haciendo clic`,
      toAddTheseIntegrations: `Para agregar estas integraciones, consulte nuestros planes haciendo clic`,
      toAddThisFeatureCheck: `Para añadir esta función, consulta nuestros planes haciendo clic`,
      toChangeYourPlanContactSupport: `Para cambiar tu plan, ponte en contacto con el servicio de asistencia.`,
      toCheck: `Verificar`,
      toConfirmWeNeedYourPassword: `Para confirmarlo necesitamos tu contraseña`,
      toConfirmYourRegistrationOn: `Para confirmar su registro en nuestra plataforma, es necesario hacer clic en el botón de abajo.`,
      today: `Hoy`,
      toDoThisYouNeedToEnterYourAppCode: `¡Para ello debes introducir el código de tu aplicación o pegar uno de tus tokens de respaldo!`,
      topReportedCWE: `CWe más denunciado`,
      totalConnectedHours: `Total de horas conectadas`,
      totalEvents: `Total de eventos`,
      totalMonthlyFees: `Cuotas mensuales totales`,
      totalReports: `Total de informes`,
      totalReceived: `Total recibido`,
      totalRewards: `Recompensas totales`,
      toTheProgram: `Al programa`,
      totalSpent: `Pago total`,
      totalSum: `Suma total`,
      trackYourOpenReports: `Siga sus informes abiertos`,
      twoFactorAuthentication: `Autenticación de dos factores`,
      type: `Tipo`,
      typeOfContract: `Tipo de contrato`,
      typeOrPasteOneOfYourBackupTokens: `Escribe o pega uno de tus tokens de respaldo, ¡recordando que cada token solo se puede usar una vez!`,
      typeProgramLimitExceeded: `Se ha superado el límite de programas de tipo {ProgramType}`,
      unableToCompleteThisRequest: `No hemos podido completar esta solicitud.`,
      unableToSubmittedTheReport: `No fue posible presentar este informe. Asegúrese de que todos los campos estén rellenados correctamente.`,
      undefinedRanking: `Clasificación indefinida`,
      uninformed: `No informado`,
      unshowPassword: `Ocultar contraseña`,
      update: `Mejorar`,
      updates: `Actualizaciones ({numberOfUpdates})`,
      updated: `Actualizado`,
      uploadFiles: `Enviar archivos`,
      upTo: `Hasta`,
      urlIsNotValid: `La URL no es válida`,
      useBackupCode: `Usar código de respaldo?`,
      user: `Usuario`,
      userBlockedForOverTrying: `Usuario bloqueado por intentos excesivos. Vuelve a intentarlo más tarde.`,
      userByCompany: `Usuario por empresa`,
      userDisconnected: `Usuario desconectado!`,
      userLimitReached: `¡Se ha alcanzado el límite de usuarios!`,
      userLoggedIn: `Usuario registrado!`,
      usersByCompany: `Usuarios por empresa`,
      userDoesNotHavPermissionToPerform: `El usuario no puede realizar esta acción`,
      usernameHasInvalidCharacters: `El nombre de usuario tiene caracteres no válidos`,
      usernameIsNotAvailable: `¡El nombre de usuario no está disponible!`,
      usernameMustBeFromCharacters: `El nombre de usuario debe tener entre {f} y {l} caracteres.`,
      users: `Portadores`,
      userEmail: `Nombre de usuario o correo electrónico`,
      usersOnTheBlacklist: `¡los usuarios de la Lista Negra no tendrán acceso a este programa!`,
      userRemoved: `Usuario eliminado`,
      useYourAuthenticationAppToEnterTheCode: `Usa tu aplicación de autenticación para introducir el código`,
      validatePhone: `Validar teléfono`,
      validatedPhone: `Teléfono validado`,
      value: `Dignidad`,
      verified: `Verificado`,
      verifieds: `Verificado`,
      vpnIP: `IP DE VPN`,
      waitingConfirmation: `Esperando confirmación`,
      wantSaveChangesProgram: `¿Realmente desea guardar los cambios realizados en este programa?`,
      waysExplore: `Formas de explorar`,
      weLeaveThisPanel: `Dejamos este panel para que publiques tus vacantes a nuestros especialistas`,
      whatIsBugBounty: `Qué es Bug Bounty`,
      whatIsYourAction: `¿Cuál es tu acción?`,
      whatIsNdaHeader: `¡estad atentos!`,
      whatPrograms: `¿qué programas?`,
      whatTypeOfVulnerability: `Qué tipo de vulnerabilidad se informa`,
      whoDoYouWantInvite: `¿A quién quieres invitar?`,
      whiteMessage: `Escribe un mensaje...`,
      weakPasswordContain: `Contraseña débil! Ella debe decir`,
      websiteInvitation: `Invitación al sitio`,
      weSendAToast: `Enviamos un brindis`,
      weAreUnderMaintenance: `¡estamos en mantenimiento! ¡Vuelve pronto!`,
      weTemporarilyStoreYourReport: `Almacenamos temporalmente los datos de su informe para el programa`,
      weWillContactYouShortly: `Nos pondremos en contacto con usted en breve para confirmar sus datos.`,
      wikiSubTitle: `Ayudamos en lo que podemos y en lo que no podemos.`,
      withoutWebAccessTheProgram: `Sin acceso a la web, el programa estará disponible solo para los usuarios de la plataforma.`,
      workModel: `Modelo de trabajo`,
      workSchedule: `Horas de trabajo`,
      yesIWantToRegister: `Sí, quiero registrarme`,
      yes: `Sí`,
      no: `No`,
      youAcceptedThisInvitation: `¿Aceptaste esta invitación?`,
      youAreAboutToVisitLink: `Estás a punto de visitar un enlace externo.`,
      youAreAllowedToViewTheReports: `Puede ver los informes.`,
      youCanUseOneOfTheseBackupCodes: `Puedes usar uno de estos códigos de respaldo para iniciar sesión si pierdes el acceso a tu smartphone. Recuerda que cada código solo se puede usar una vez.`,
      yourCurrentPlanIsThe: `Tu plan actual es`,
      youDoNotHaveAnyTagRegistered: `<a href=\"/account?tags\">no tienes ninguna etiqueta registrada, para añadirla ve al menú Mi cuenta/Etiquetas</a>`,
      youDontHave: `No tienes`,
      youDontHaveAnyAcceptedInvitations: `¡Aún no se han aceptado invitaciones!`,
      youDontHaveAnyInvitationsWaiting: `¡Aún no hay invitaciones esperando respuestas!`,
      youDontHaveAnyNDAs: `¡aún no tienes un programa con un acuerdo de confidencialidad!`,
      youDontHaveAnyNDAsHacker: `¡aún no has aceptado ningún acuerdo de confidencialidad!`,
      youDontHaveAnyProgramsInThisCategoryYet: `Aún no tienes ningún programa en esta categoría`,
      youDontHaveSubmittedReports: `¡Aún no hay informes aprobados!`,
      youHave: `Tienes`,
      youHaveBeenInvitedToSend: `Se le invitó a enviar informes a este programa`,
      youHavePermissionToViewAndEditReports: `Tiene permiso para ver y editar los informes.`,
      youMustAgreeToThe: `Tienes que estar de acuerdo con la`,
      youMustAgreeToTheTermsOfUse: `Debe aceptar las condiciones de uso.`,
      youMustAgreeToTheTermsOfUseAndCodeOfConduct: `Debe aceptar las condiciones de uso y el código de conducta.`,
      yourAccessPassword: `¡tu contraseña de acceso!`,
      yourAccesEmail: `Tu dirección de correo electrónico para acceder a {0}`,
      youReachedLimit: `¡Has alcanzado el límite de informes diarios!`,
      yourEmail: `Tu correo electrónico`,
      yourFullName: `¡tu nombre completo!`,
      yourNameMustBeBetweenAndCharacters: `¡tu nombre debe tener entre {f} y {l} caracteres!`,
      yourOrganizationNameIsRequired: `El nombre de su organización es obligatorio`,
      YourOrganizationTradeName: `¡Nombre elegante de tu organización!`,
      yourPassword: `Tu contraseña`,
      yourPhoneToGetInTouch: `¡Llámenos para que podamos ponernos en contacto!`,
      yourProfileIsNowAbleTo: `¡tu perfil es elegible para participar en el proceso de verificación!`,
      ndaVerificationRequired1: `Te invitaron a participar en el programa `,
      ndaVerificationRequired2: `¡Es necesario verificar tu perfil para aceptar esta invitación!`,
      ndaVerificationRequired3: `Revisa tu lista de notificaciones y continúa con el proceso de verificación.`,
      noJobsFound: `No se han encontrado vacantes`,
      registrationDone: `Registro completado!`,
      reportPaymentVerificationRequired1: `El pago de una recompensa por el informe `,
      reportPaymentVerificationRequired2: `¡fue solicitado!`,
      reportSummaryNotValid: `¡el resumen del informe no es válido!`,
      reportContentIsNotValid: `¡el contenido del informe no es válido!`,
      reportVulnerabilitIsNotValid: `¡el impacto de la vulnerabilidad no es válido!`,
      reportCriticalityIsNotValid: `La naturaleza crítica de la vulnerabilidad no es válida`,
      reportCantAcceptEspecialCaracter: `(No puede introducir caracteres especiales).`,
      reportScopeIsNotValid: `¡el identificador del alcance del informe no es válido!`,
      reportIdentifierIsNotValid: `¡el identificador del programa no es válido!`,
      reportVulnerabilityIdentifierIsNotValid: `¡el identificador de vulnerabilidad no es válido!`,
      ndaVerificationRequired6: `¡completa la validación de tu perfil para que podamos proceder al pago de la recompensa!`,
      reportTitleIsNotValid: `¡el título del informe no es válido!`,
      showPassword: `Mostrar contraseña`,
      companyNdaVerificationRequired: `¡necesita crear un acuerdo de confidencialidad para su programa antes de invitar a especialistas!`,
      taxesNotIncluded: `Homenajes no incluidos`,
      youAcceptedParticipateInThisProgram: `Ha aceptado participar en este programa.`,
      youCanCalculate: `Puede calcular la gravedad con la calculadora que aparece a continuación.`,
      youShouldConsiderUsingSeparate: `Deberías considerar la posibilidad de usar un navegador o una máquina virtual independientes antes de continuar.`,
      yourSecurityPlatformAndBugReward: `Tu plataforma Bug Bounty`,
      youWereInvitedPartOf: `Te han invitado a unirte al equipo de {0}, solo tienes que introducir los detalles de tu cuenta.`,
      youWillBeRedirectedIn: `Serás redirigido a`,
      youWillReceiveReportsFromCommunity: `Recibirá informes de expertos en seguridad de nuestra comunidad, sin costo adicional, lo que minimizará los riesgos de que sus datos queden expuestos o de que se exploten las vulnerabilidades.`,
      invitationsSummary: `Resumen de las invitaciones`,
      doubleReward: `Recompensa doble`,
      boostedProgram: `Programa impulsado!`,
      doubleCampaignNotificationStarted: `Campaña de bonificación iniciada`,
      doubleCampaignNotificationClosed: `Campaña de bonificación cerrada`,
      doubleCampaignNotificationPaused: `Campaña de bonificación pausada`,
      doubleCampaignNotificationResumed: `Se reanudó la campaña de bonificación`,
      campSubTitle: `¡gestiona tus campañas! Mantén un registro de todos los detalles.`,
      historicCampaign: `Historia`,
      historicDoubleBounty: `Recompensa doble`,
      historicDoubleScore: `Doble puntuación`,
      inText: `De`,
      until: `Hasta`,
      finished: `Completado`,
      in_progress: `Continuo`,
      situationCancel: `Cancelado`,
      createdTh: `Creado en`,
      periodTh: `Plazos`,
      rewardsTh: `Recompensas`,
      situationsTh: `Situaciones`,
      historicApproved: `Aprobado`,
      historicCancel: `Cancelado`,
      historicPaused: `En pausa`,
      historicFinished: `Completado`,
      notificationAttention: `¡Atención!`,
      notificationYourCampaignHasStarted: `¡Tu campaña ha comenzado!`,
      notificationThisCampaign: `Esta campaña`,
      notificationHasClosed: `Estaba cerrado`,
      notificationHasBeenPaused: `¿Estaba en pausa?`,
      keepAnEyeOutNotification: `Esté atento`,
      notificationWillLetYouKnowWhenToStartAgain: `te avisaremos cuando vuelva a empezar.`,
      notificationThisCampaignIsLiveAgain: `¡esta campaña está en el aire otra vez!`,
      finalDate: `Fin`,
      remain: `Permanecer`,
      campaignStarted: `¡La campaña de doble recompensa ha comenzado!`,
      campaignClosed: `¡La campaña de recompensas dobles ha terminado!`,
      campaignPause: `¡La campaña de recompensas dobles se ha detenido!`,
      campaignReactivated: `¡La campaña de recompensas dobles se ha reactivado!`,
      campaignFinalDays: `Para el final de la campaña`,
      campaignInitialDays: `Para el inicio de la campaña`,
      dayCampaign: `día`,
      daysCampaign: `días`,
      daysGeneric: `día (s)`,
      btnRegister: `Registrarse`,
      btnCancel: `Cancelar`,
      btnLabel: `Selecciona la fecha`,
      doubleBounties: `Recompensas dobles`,
      doubleScore: `Doble puntuación`,
      activeDoubleCampaign: `Programa Boost`,
      selectAPeriod: `Selecciona un periodo:`,
      monthlyRanking: `Clasificación mensual`,
      generalRanking: `Clasificación general`,
      expertRating: `Consulta el ranking de expertos de BugHunt`,
      bountyOffer: `Estás ofreciendo: Double Bounties`,
      bountyScore: `Estás ofreciendo: Doble puntuación`,
      bountyAndScoreOffer: `estás ofreciendo: Bouties and Double Scoring`,
      closeCampaign: `Cerrar campaña de bonificación`,
      pauseCampaign: `Pausa la campaña de bonificación`,
      reactivateCampaign: `Reactivar la campaña de bonificación`,
      boostCampaign: `Programa Boost`,
      doubleCheckCampaign: `Estoy al tanto de los cambios en el valor actual de las recompensas.`,
      successfullyCreatedCampaign: `Solicitud realizada correctamente, ¡espere a que se apruebe la campaña!`,
      vpnMessage: `No hay ninguna VPN habilitada en este programa.`,
      campaignPaused: `¡La campaña se ha pausado correctamente!`,
      doubleCampaignClosed: `¡La campaña se cerró correctamente!`,
      doubleCampaignResumed: `¡La campaña se reanudó con éxito!`,
      registeredProgramWarning: `Este programa ya tiene una campaña aprobada o cerrada hace menos de 15 días.`,
      warningBoutiesOrScore: `¡la campaña debe ofrecer recompensas o puntajes dobles!`,
      invalidDateMessage: `Fecha no válida, ¡compruebe que el campo se ha rellenado correctamente!`,
      v_administrator: `fideicomisario`,
      v_viewer: `espectador`,
      v_analyst: `Analista`,
      administrator: `Fideicomisario`,
      viewer: `Espectador`,
      analyst: `Analista`,
      v_private: `soldados`,
      v_public: `Público`,
      v_internal: `interno`,
      v_new: `recién descubierto`,
      v_under_review: `en revisión`,
      v_triaged: `Triado`,
      v_needs_information: `¿Necesitas información`,
      v_approved: `aprobado`,
      v_informative: `informativo`,
      v_duplicated: `duplicado`,
      v_not_applicable: `No aplicable`,
      v_spam: `correo no deseado`,
      v_accepted: `Aceptado`,
      v_pending: `Colgantes`,
      v_declined: `Rechazado`,
      v_revoked: `Revocado`,
      v_pending_retest: `Vuelva a probar`,
      v_retest_done: `Realización de la prueba`,
      retest_done: `Realización de la prueba`,
      pending_retest: `Recomprobación pendiente`,
      notImpact: `Gravedad no notificada`,
      lowImpact: `Gravedad baja`,
      mediumImpact: `Severidad promedio`,
      highImpact: `Gravedad alta`,
      criticalImpact: `Gravedad crítica`,
      approved: `Aprobado`,
      informative: `Informativo`,
      duplicated: `Duplicado`,
      not_applicable: `No aplicable`,
      spam: `Correo no deseado`,
      comment: `Publicar un comentario`,
      change_situation: `Cambiar situación`,
      update_severity: `Cambiar la gravedad`,
      request_update: `Solicitar actualización`,
      retest: `Solicitar una nueva prueba`,
      pay_bounty: `Pague una recompensa`,
      close_report: `Cerrar el informe`,
      reopen_report: `Vuelva a abrir el informe`,
      needs_information: `Esperando información`,
      under_review: `En revisión`,
      triaged: `Triado`,
      plan_trial: `Plan de prueba`,
      plan_bronze: `Plano de bronce`,
      plan_silver: `Plan Silver`,
      plan_gold: `Plan dorado`,
      trial: `Juicio`,
      bronze: `Bronce`,
      silver: `Plata`,
      gold: `Oro`,
      fulltime: `Tiempo completo`,
      parttime: `A tiempo parcial`,
      clt: `CLT`,
      pj: `PJ`,
      autonomous: `Individual`,
      cltflex: `CLT Flex`,
      cooperative: `Cooperativa`,
      internship: `Etapa`,
      hybrid: `Híbrido`,
      office: `En persona`,
      remote: `Remoto`,
      web: `Aplicación web`,
      api: `API`,
      mobileapplication: `Aplicación móvil`,
      mobileapplicationandroid: `Aplicación móvil Android`,
      mobileapplicationios: `Aplicación móvil iOS`,
      ip: `Dirección IP`,
      january: `Enero`,
      february: `Febrero`,
      march: `Marzo`,
      april: `Abril`,
      may: `Mayo`,
      june: `Junio`,
      july: `Julio`,
      august: `Agosto`,
      september: `Septiembre`,
      october: `Octubre`,
      november: `Noviembre`,
      december: `Diciembre`,
      seeOriginalText: `Texto original.`,
      waiting_for_information: `Esperando información`,
      severity_updated: `Gravity actualizado`,
      retest_requested: `Solicitud de una prueba`,
      bounty_paid: `Recompensa pagada`,
      close_as_approved: `Cerrar según lo aprobado`,
      close_as_informative: `Cerrar como informativo`,
      close_as_spam: `Cerrar como spam`,
      close_as_duplicated: `Cerrar como duplicado`,
      close_as_not_applicable: `Cerrar porque no se aplica`,
      select_option: `Selecciona una opción`,
      deleteMessageAlert: `¿Estás seguro de que deseas eliminar este mensaje?`,
      automaticMessage: `Al seleccionar la opción, la respuesta automática se registrará como primera interacción en el informe.`,
      defaultMessageCenterMenu: `Centro de mensajes estándar`,
      registerNotFound: `No se encontró ningún registro.`,
      registeredMessageTitle: `Mensajes registrados`,
      customSettingsTitle: `Ajustes personalizados`,
      customSettingsSubtitle: `Configurar mensajes para respuestas estandarizadas`,
      addMessageButton: `Añadir mensaje`,
      existingMessageAlert: `Es posible registrar solo un mensaje por tipo de mensaje. ¡Actualmente, todos los mensajes ya están registrados!`,
      editMessage: `Editar mensaje`,
      registerMessage: `Registrar mensaje`,
      placeholderTitleMessage: `Título del mensaje`,
      placeholderTextAreaMessage: `Añadir una descripción...`,
      labelAutomatic: `Automática`,
      alertMessageSuccess: `Mensaje registrado correctamente!`,
      alertMessageUpdate: `¡El mensaje se actualizó correctamente!`,
      swalTokenRemoved: `El token se ha eliminado correctamente.`,
      deleteTokenCompany: `Eliminar token`,
      placeholderTokenCompany: `Escriba un token`,
      errorToken: `¡el token debe contener un mínimo de 20 caracteres y un máximo de 500 caracteres!`,
      emailNotification: `¡la notificación por correo electrónico se ha activado correctamente!`,
      enableEmailNotification: `Habilite la recepción de actualizaciones del programa a través de una dirección de correo electrónico.`,
      emailNotificationDisabled: `¡La notificación enviada por correo electrónico se ha desactivado!`,
      china: `China`,
      india: `India`,
      estadosUnidos: `Estados Unidos`,
      indonesia: `Indonesia`,
      paquistao: `Pakistán`,
      brasil: `Brasil`,
      nigeria: `Nigeria`,
      bangladesh: `Bangladesh`,
      russia: `Rusia`,
      mexico: `Mexico`,
      japao: `Japón`,
      etiopia: `Etiopía`,
      filipinas: `Filipinas`,
      egito: `Egipto`,
      vietna: `Vietnam`,
      repuplicaDemocraticaDoCongo: `República Democrática del Congo`,
      turquia: `Turquía`,
      ira: `Irán`,
      alemanha: `Alemania`,
      tailandia: `Tailandia`,
      reinoUnido: `Reino Unido`,
      franca: `Francia`,
      italia: `Italia`,
      tanzania: `Tanzania`,
      africaDoSul: `Sudáfrica`,
      mianmar: `Myanmar (Birmania)`,
      coreiaDoSul: `Corea del Sur`,
      colombia: `Colombia`,
      quenia: `Kenia`,
      espanha: `España`,
      ucrania: `Ucrania`,
      uganda: `Uganda`,
      sudao: `Sudán`,
      angertina: `Argentino`,
      angelia: `Argelia`,
      iraque: `Irak`,
      polonia: `Polonia`,
      canada: `Canadá`,
      uzbequistao: `Uzbekistán`,
      arabiaSaudita: `Arabia Saudí`,
      br: `Portugués`,
      en: `Inglés`,
      es: `Espanol`,
      fr: `Francés`,
      it: `Italian`,
      ru: `Rusa`,
      de: `Deutsch`,
      jp: `Japonés`,
      cn: `Chino`,
      pl: `Polaco`,
      ua: `Ucraniana`,
      sd: `árabe`,
      kr: `Coreano`,
      in: `Hindi`,
      id: `Indonesio`,
      pk: `Urdu`,
      bd: `Bengalí`,
      et: `Amárico`,
      ph: `Filipino (tagalo)`,
      vn: `Vietnamita`,
      tr: `Turca`,
      ir: `Persa`,
      th: `Tailandés`,
      za: `Afrikáans`,
      mm: `Birmano`,
      ug: `Swahili`,
      uz: `Uzbeko`,
      sa: `árabe`,
      additionalMoreLanguages: `Añadir más idioma`,
      country: `Campo`,
      language: `Lengua`,
      clearText: `Usa el mensaje estándar`,
      selectCountry: `Selecciona un país`,
      basic: `Básica`,
      proficiency: `Competencia`,
      conversational: `Conversacional`,
      fluent: `Fluido`,
      native: `Nativo o bilingüe`,
      AreYouSureYouWantToCompleteTheRequest: `¿Está seguro de que desea completar esta solicitud?`,
      managers: `Gerentes`,
      manageProgram: `Defina quién administrará su nuevo programa.`,
      config: `Ajustes`,
      programSettings: `Ajustes del programa`,
      programEditAlert: `¡Atención! No puede editar los programas que están inactivos o en espera de aprobación.`,
      changeSettings: `Cambiar la configuración`,
      managersWithAccesToTheProgram: `Gerentes con acceso al programa`,
      freeAccess: `Acceso publicado`,
      pendingInviteAlert: `¡Atención! Ya hay una invitación pendiente asociada a esta dirección de correo electrónico.`,
      USDT: `Dólar`,
      BRL: `Real`,
      selectCurrencyType: `Selecciona el tipo de moneda`,
      passwordSuccess: `Contraseña registrada correctamente!`,
      isNan: `El valor introducido debe ser numérico.`,
      filterScope: `Filtrar por ámbito`,
      selectScope: `Seleccione una opción de ámbito`,
      filterScopeTitle: `Filtrar por ámbito`,
      scopeSelected: `ámbito seleccionado`,
      summaryFinancialCard: `Resumen financiero`,
      summaryTotalCard: `Contribuciones totales`,
      summaryTotalPgCard: `Pago total`,
      projectedValueLabel: `Número de meses a proyectar`,
      totalMonthlyPayments: `Cuotas mensuales totales`,
      totalManagedServices: `Total de servicios gestionados`,
      totalRewardsPaid: `Total de recompensas pagadas`,
      monthAndyear: `Mes/año`,
      contribution: `Contribución`,
      managed: `Logró`,
      costProjection: `Proyección de costos`,
      contributionBalance: `Saldo de contribución`,
      detailsNF: `Detalles de NF`,
      total: `Total`,
      expenseNotification: `¡mantén el control! Configure las notificaciones para cuando alcance el \"70%\" de su presupuesto de gastos.`,
      errorValueBudget: `Introduce el límite de presupuesto`,
      errorBudgetNotification: `Introduzca el porcentaje deseado`,
      labelInvalidValue: `Valor no válido. Introduzca un valor entre 0 y 100`,
      labelCurrencyValue: `Valor no válido: no es posible registrar valores negativos.`,
      titleBudgetActive: `Limitar los costos de recompensas mensuales`,
      budgetLimitProgram: `El límite de presupuesto para este programa es`,
      errorBudgetLimit: `Introduce el límite de presupuesto`,
      invalidValueBudget: `Valor no válido: no es posible registrar valores negativos.`,
      notificationBudget: `Notifica cuando llegues a la cantidad de`,
      percentageBudget: `Introduzca el porcentaje deseado`,
      percentageErrorBudget: `Valor no válido. Introduzca un valor entre 0 y 100`,
      pauseProgramBudget: `¿pausar el programa antes de alcanzar el presupuesto total?`,
      percentagePauseBudget: `Porcentaje de pausa (0-99%)`,
      createCredentialTooltip: `Definir credencial`,
      confirmBtn: `Confirmar`,
      swalCredential: `Credencial guardada correctamente.`,
      labelCredentialForTest: `Las credenciales para probar el sistema y el alcance del programa`,
      labelCredentialForTestContinued: `se enumeran a continuación`,
      labelCredentialIndividual: `Uso individual. No comparta para garantizar su seguridad.`,
      labelCredentialShared: `Uso compartido. Todos los expertos tienen el mismo acceso.`,
      credentials: `Credenciales`,
      confirmPassword: `Confirmar contraseña`,
      confirmPasswordToViewCredential: `Confirme su contraseña para acceder a la plataforma y ver la `,
      confirmPasswordToViewCredentialContinued: `credenciales disponibles`,
      hello: `Hola`,
      doYouHaveCredentials: `¿Tiene credenciales para usar en los sistemas y ámbitos que se probarán?`,
      manageYourCredentials: `Administre sus credenciales genéricas registradas para facilitar el acceso de los especialistas que realizarán pruebas en sus sistemas`,
      manageYourCredentialsTooltip: `Administra tus credenciales`,
      credentialPublica: `Credencial Genérica`,
      credentialPrivate: `Credencial Exclusiva`,
      credentialPublicaDescription: `Las credenciales genéricas registradas se enviarán a todos los expertos participantes en el programa, con el objetivo de ser utilizadas para la realización de pruebas de seguridad.`,
      credentialSentToSpecialist: `Las credenciales únicas registradas solo se enviarán al especialista en destino`,
      credentialSentToSpecialistContinued: `con el fin de utilizarlos para realizar pruebas de seguridad.`,
      request_review: `Solicitar una revisión de selección`,
      request_review_report: `Solicitaste una revisión de la proyección`,
      reviewRequestedNotification: `Solicitud de revisión`,
      availableCredential: `Credencial disponible`,
      allActionsAllowed: `Puede administrar todos los programas y usuarios.`,
      owner: `Dueño`,
      AreYouSureYouWantToUpdateTheUserRole: `¿desea aplicar los cambios a los permisos de este usuario?`,
      v_owner: `Dueño`,
      manageCredentials: `Administrar las credenciales registradas.`,
      setPublicCredential: `Administra tus credenciales públicas`,
      programSpellers: `Especialistas del programa`,
      viewCredentials: `Ver credenciales`,
      informPassword: `Introduce tu contraseña`,
      credentialDeleted: `Credencial eliminada exitosamente!`,
      genericError: `Algo salió mal. Estamos resolviendo esto ahora. Por favor, inténtelo de nuevo más tarde.`,
      delete: `Borrar`,
      toClose: `Cerrar`,
      labelDeleteCredential: `¿Está seguro de que desea eliminar esta credencial?`,
      credentialsTooltip: `Credenciales Disponibles`,
      setPasswordExpiration: `Establecer la caducidad de la contraseña`,
      authenticationViaEmail: `Habilitar la autenticación de correo electrónico`,
      accessValidation: `Validación de acceso`,
      invalidCodeError: `¡El código ingresado no es válido!`,
      alertTwoFactory: `<div class="container-two-factory"><p class="two-factory-descrition">Para enviar un informe en este programa, debe habilitar la autenticación de dos factores. Su seguridad es nuestra prioridad y esta capa adicional de protección es esencial para garantizar la integridad de su cuenta. <span>Siga los pasos de configuración para habilitar la autenticación de 2 factores ahora.</span></p></div>`,
      twoFactoryNewUsersContinuation: `podrá interactuar con los informes.`,
      restriction: `Restricción`,
      warningTwoFactorAuthentication: `¡Atención! Se requiere configuración de autenticación de 2 factores.`,
      labelFeatureTwoFactorAuthentication: `Sólo los administradores con autenticación de dos factores pueden interactuar con los informes del programa.`,
      labelFeatureTwoFactorAuthenticationHacker: `Sólo los expertos con autenticación de dos factores pueden enviar nuevos informes al programa.`,
      configureNow: `Configurar ahora`,
      enable2fa: `habilitó el requisito de configurar la autenticación de doble factor`,
      disable2fa: `deshabilitó el requisito de configurar la autenticación de doble factor`,
      itWas: `Ha sido`,
      toProgram: `para el programa`,
      translateText: `Traducir texto`,
      openingDate: `Fecha de apertura:`,
      classification: `Clasificación`,
      confidential: `Confidencial`,
      selectProgram: `Seleccionar programa`,
      swalSuccess: `Cambio realizado con éxito.`,
      dateDownloadReport: `descargar`,
      setHallOfFame: `¿Quieres habilitar el hall of fame en tu nuevo programa?`,
      addHackerToHof: `¿Quieres agregar al experto al hall of fame?`,
      hallOfFame: `Hall of Fame`,
      hallOfFameDoesNotHaveEnoughDataYet: `¡El Hall of fame aún no tiene especialistas!`,
      hallOfFameThanksDescription: `gustaría agradecer a los siguientes investigadores por informar importantes fallas de seguridad.`,
      addedAt: `Agregado en`,
      programByObjective: `Programa por objetivo`,
      programObjective: `Objetivo del programa`,
      nowTellUsLittleObjective: `¡Ahora cuéntanos un poco sobre el objetivo del programa!`,
      aGoodObjectiveAvoids: `Un objetivo bien definido evita problemas, si tienes algún problema contacta con nosotros.`,
      target: `Meta`,
      include: `Incluir`,
      infoTarget: `¡Atención! Es necesario informar al menos un objetivo.`,
      aboutTarget: `¡Sobre el objetivo del programa!`,
      setProgramReward: `Establecer recompensa del programa`,
      maxProgram: `¡Atención! Se permiten un máximo de 10 objetivos por programa.`,
      requiredProgram: `Por favor registre un objetivo para el programa.`,
      targetRequired: `Por favor complete el objetivo del programa.`,
      requiredBounty: `porfavor introduzca un valor.`,
      idConfirmation: `¡Casi terminado! Confirme su identidad para continuar con el proceso de cambio de contraseña.`,
      titleTarget: `Título objetivo`,
      targetPlaceholder: `Título del objetivo del programa!`,
      titleTargetError: `Por favor complete el título objetivo del programa.`,
      updateTarget: `¡Objetivo actualizado exitosamente!`,
      swalTarget: `Por favor, compruebe que los campos estén cumplimentados correctamente.`,
      areYouSureYouWantToDeleteThisTarget: `¿Estás seguro de que deseas eliminar este objetivo?`,
      removeTargetProgram: `¡Objetivo eliminado con éxito!`,
      selectAnObjectiveForTheReport: `¿Qué tipo de objetivo se informa?`,
      informTheTarget: `Indique el objetivo`,
      selectTheProgramTarget: `¡Seleccione un objetivo del programa!`,
      achievedTheObjective: `¿Se logró el objetivo del programa?`,
      reachedIn: `Objetivo alcanzado en`,
      noObjectivesAvailable: `¡No hay objetivos disponibles!`,
      removeIn: `eliminado`,
      achievedIn: `conseguido por`,
      pauseProgramSwal: `Programa pausado por falta de objetivo(s) activo.`,
      cBoostedProgram: `Programa impulsado`,
      signedAgreements: `Acuerdos firmados`,
      ccpProgObj: `Programa por objetivo`,
      ccpProgObjDesc: `¡Crea un programa con objetivos predefinidos, donde tú eliges quién puede participar y enviar informes!`,
      objectiveProgram: `programa por objetivo`,
      publicPrograms: `programas públicos`,
      privatePrograms: `programas privados`,
      objectivePrograms: `programas objetivos`,
      alertMessageRemoved: `¡Mensaje eliminado correctamente!`,
      scopeNotFound: `Alcance no encontrado.`,
      usernameOrEmail: `Username o E-Mail`,
      aboutTheProgramPolicyHacker: `¡Deben respetarse las normas contenidas en la política del programa!`,
      jiraIssueType: `¿Qué tipo de emisión se registrará en Jira?`,
      conceded: `concedido`,
      toTheSpecialist: `al especialista`,
      getToKnow: `Conozca`,
      solutions: `Soluciones`,
      contact: `Contactar`,
      ourBlog: `Nuestro blog`,
      doubts: `Dudas?`,
      inTheMedia: `En los medios`,
      talkToUs: `Hable con nosotros`,
      understandHowItWorks: `¡entiende cómo funciona!`,
      publicPrograms: `Programas públicos`,
      privatePrograms: `Programas privados`,
      managedPrograms: `Programas gestionados`,
      vdpPrograms: `Programas VDP`,
      howItWorks: `¡Cómo funciona!`,
      ranking: `Clasificación`,
      url: `URL`,
      multipliedScore: `¡Bonificación! Puntuación multiplicada`,
      codeOfConduct: `Código de Conducta`,
      and: `y`,
      reportConfidential: `Clasificación del documento: Confidencial`,
      securitySystem: `sistema de seguridad`,
      emailAlreadyRegisteredInOurDatabase: `Correo electrónico ya registrado en nuestra base de datos`,
      theTokenMustBeEntered: `Es necesario introducir el token`,
      actionAlreadyReported: `Acción ya notificada!`,
      statusPauseProgram: `El programa ha sido pausado.`,
      statusStartProgram: `El programa ha sido reactivado`,
      by: `por`,
      in: `en`,
      invalidName: `¡El nombre ingresado no es válido!`,
      includeMoreDetails: `Aumentar más detalles...`,
      maxTech: `El máximo permitido es 10 tecnologías por alcance.`,
      maxLine: `Limite el mensaje a un máximo de 10 saltos de línea.`,
      includeInfoScope: `Introduzca notas sobre el alcance...`,
      includeTech: `Introduzca las tecnologías`,
      editScope: `Editar alcance`,
      scopeDetails: `Detalles del alcance`,
      minMaxScopeCaracter: `El alcance debe tener entre 3 y 40 caracteres.`,
      characters: `Caracteres`,
      //translation_script_end_es
    }),
  ],
});
